{
  "update": {
    "available": "A new version of Thiia is available.",
    "description": "Reload to get the latest improvements.",
    "reload": "Reload",
    "later": "Later",
    "fromTo": "Update: {{from}} → {{to}}",
    "toOnly": "New version: {{to}}",
    "fromOnly": "Current version: {{from}}",
    "draftRestoredTitle": "Draft restored",
    "draftRestoredDescription": "Your fields were restored as they were before reloading ({{count}} field).",
    "draftRestoredDescription_plural": "Your fields were restored as they were before reloading ({{count}} fields)."
  },
  "rightPanel": {
    "ariaLabel": "Side panel",
    "errorTitle": "This panel couldn't load",
    "errorGeneric": "An unexpected error occurred.",
    "stuck": "Loading is taking longer than expected. Check your connection and retry.",
    "retry": "Retry",
    "copyDetails": "Copy details",
    "copied": "Copied",
    "close": "Close"
  },
  "common": {
    "loading": "Loading…",
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "search": "Search",
    "searchPlaceholder": "Search…",
    "language": "Language",
    "french": "French",
    "english": "English",
    "settings": "Settings",
    "logout": "Sign out",
    "menu": "Menu",
    "more": "More",
    "documentation": "Documentation",
    "contactUs": "Contact us",
    "legal": "Legal notice",
    "privacy": "Privacy",
    "terms": "Terms of use",
    "all": "All",
    "showAll": "Show all",
    "clear": "Effacer",
    "optional": "optional",
    "reset": "Reset",
    "export": "Export",
    "buy": "Buy",
    "deselect": "Deselect",
    "noResults": "No results",
    "confirmDeleteTitle": "Confirm deletion",
    "confirmDeleteDescription": "This action is irreversible. Do you really want to continue?",
    "accept": "Accept",
    "refuse": "Decline",
    "learnMore": "Learn more",
    "apply": "Apply",
    "collapse": "Collapse",
    "create": "Create",
    "error": "Error",
    "expand": "Expand",
    "filters": "Filters",
    "locked": "Locked",
    "pagination": {
      "perPage": "per page",
      "showing": "Showing"
    },
    "security": "Security",
    "switchToLanguage": "Switch to {{language}}",
    "retry": "Retry",
    "dismiss": "Dismiss",
    "actions": "Actions",
    "helpAndDocs": "Help & documentation"
  },
  "offline": {
    "message": "You are offline. Some features are unavailable."
  },
  "cookies": {
    "message": "We use cookies for <strong>authentication</strong>, <strong>bot protection (hCaptcha)</strong> and to improve your experience. No advertising cookies.",
    "acceptAll": "Accept all",
    "refuseOptional": "Decline",
    "customize": "Customize",
    "save": "Save my choices",
    "preferences": {
      "title": "Cookie preferences",
      "description": "Choose which categories of cookies you allow. Essential cookies are required for the site to function.",
      "thirdParties": "Third-party services used: Supabase (auth/data, EU), hCaptcha (anti-bot), Stripe (payments), Resend (emails). No advertising cookies."
    },
    "cat": {
      "essential": {
        "title": "Essential",
        "desc": "Supabase authentication, session, load balancing. Always on."
      },
      "security": {
        "title": "Security (anti-bot)",
        "desc": "hCaptcha — protects sign-up, sign-in and password reset against automated abuse."
      },
      "functional": {
        "title": "Functional",
        "desc": "Remembers language, sidebar state, chat and email display preferences."
      },
      "analytics": {
        "title": "Analytics",
        "desc": "Anonymized usage statistics for AI features (chat, search, content generation) to improve the product."
      }
    }
  },
  "nav": {
    "dashboard": "Dashboard",
    "calendar": "Calendar",
    "wellbeing": "Well-being",
    "notifications": "Notifications",
    "search": "Search",
    "searchHub": "Prospecting",
    "events": "Events",
    "people": "People",
    "emailAnalysis": "Email analysis",
    "monitoring": "Tracking",
    "prospects": "Prospects",
    "clients": "Clients",
    "tasks": "Tasks",
    "communicate": "Communicate",
    "emails": "Emails",
    "content": "Digital channels",
    "chat": "Chat with Thiia",
    "credits": "Credits & Packs",
    "autoSearch": "Auto monitoring",
    "aiAssistant": "AI Assistant",
    "featureLockedTooltip": "The \"{{feature}}\" feature is not enabled on your account. Contact your administrator.",
    "orgFilterTitle": "Filter by organization",
    "orgFilterAll": "All organizations",
    "orgFilterActiveOne": "{{count}} active organization",
    "orgFilterActiveOther": "{{count}} active organizations",
    "orgFilterClear": "Clear selection",
    "orgFilterEmpty": "No organization",
    "orgFilterSearchPlaceholder": "Search an organization…",
    "orgFilterNoResults": "No organization found",
    "primaryMobile": "Primary navigation",
    "openChat": "Open chat with Thiia",
    "mobileMenuDescription": "Filter by organization and navigate the app.",
    "drawerNavigation": "App sections",
    "account": "Account",
    "unreadEmails": "unread",
    "watch": "Watch",
    "receipts": "Receipts",
    "management": "Management"
  },
  "landing": {
    "navHome": "Home",
    "navUseCases": "Use cases",
    "navPricing": "Pricing",
    "navContact": "Contact",
    "navDocs": "Documentation",
    "navLogin": "Sign in",
    "navFeatures": "Features",
    "navSecurity": "Security",
    "navTryFree": "Try for free",
    "navTryShort": "Try it",
    "navCreateAccount": "Create my account",
    "navMenu": "Menu",
    "navOpenMenu": "Open menu",
    "ctaTrial": "Free trial",
    "heroBadge": "🇫🇷 Powered by Mistral AI — Sovereign French AI",
    "heroTitle1": "Your copilot to",
    "heroTitleAccent": "grow",
    "heroTitle2": "your business",
    "heroSubtitle": "Prospecting, contact management, content creation, and client follow-up — all in a single intelligent tool designed for entrepreneurs and freelancers.",
    "ctaStart": "Get started for free",
    "ctaDiscover": "Discover features",
    "noCard": "No credit card required · Free trial included",
    "footerTagline": "Your AI assistant for smart B2B prospecting.",
    "footerProduct": "Product",
    "footerFeatures": "Features",
    "footerPricing": "Pricing",
    "footerHow": "How it works",
    "footerLegal": "Legal",
    "footerContact": "Contact",
    "footerCopyright": "All rights reserved.",
    "footerCreatedBy": "Created by",
    "footerMadeIn": "— Made with ❤️ in France 🇫🇷",
    "statProsLabel": "Active professionals",
    "statLeadsLabel": "Prospects managed",
    "statSatLabel": "Customer satisfaction",
    "statTimeLabel": "Saved per week",
    "sovBadge": "🇫🇷 Sovereign AI",
    "sovTitle1": "A",
    "sovTitleAccent1": "100% French",
    "sovTitle2": "AI, your data stays",
    "sovTitleAccent2": "in France",
    "sovSubtitle": "Thiia is powered by **Mistral AI**, the French leader in artificial intelligence. No data leaves French soil.",
    "sovItem1Title": "Mistral AI",
    "sovItem1Desc": "AI model developed in France by French researchers, a sovereign alternative to American giants.",
    "sovItem2Title": "Private data",
    "sovItem2Desc": "Your data is never used to train models. Total confidentiality guaranteed.",
    "sovItem3Title": "French hosting",
    "sovItem3Desc": "Infrastructure hosted in France, GDPR-compliant and aligned with digital sovereignty requirements.",
    "integrationsBadge": "Integrations",
    "integrationsTitle1": "Connected to your",
    "integrationsTitleAccent": "everyday tools",
    "integrationsSubtitle": "Sync your emails, calendars, video calls, social networks and CRM in one click.",
    "featuresBadge": "Features",
    "featuresTitle1": "Everything you need,",
    "featuresTitleAccent": "in one place",
    "featuresSubtitle": "Six powerful modules working together to accelerate your growth.",
    "featuresUseCases": "See use cases by profession",
    "pillars": {
      "badge": "What the agent does for you",
      "title": "Three jobs, one place to ask",
      "exampleLabel": "Real example",
      "allFeatures": "All features",
      "p1Kicker": "01 — Prospecting",
      "p1Title": "Finds the people who need you",
      "p1Body": "You describe who you are looking for in plain language; the agent scans networks and public signals, qualifies them, and only returns profiles whose intent is dated.",
      "p1Credit": "1 search used",
      "p1Ask": "Find me people looking for coaching engagements",
      "p1Answer": "12 profiles expressed this need in the last 30 days. The hottest: Claire M., HR Director at Novalis — two posts about reskilling her teams.",
      "p2Kicker": "02 — Client relationships",
      "p2Title": "Writes, follows up, forgets nothing",
      "p2Body": "Every contact has its own thread (what was said, what is left to do, when to follow up); the agent drafts, schedules, and tells you when a reply arrives.",
      "p2Credit": "4 follow-ups prepared",
      "p2Ask": "Follow up on my quotes with no reply for two weeks",
      "p2Answer": "Four quotes concerned. I prepared one follow-up per contact, based on your last exchange with each. Shall I show them before sending?",
      "p3Kicker": "03 — Digital communication",
      "p3Title": "Feeds your networks without thinking about it",
      "p3Body": "The agent writes from your existing engagements, exchanges and topics; one drafted post is adapted across networks without using another credit.",
      "p3Credit": "1 post used",
      "p3Ask": "Write my LinkedIn post for this week",
      "p3Answer": "Based on the engagement you delivered on Tuesday. Chosen angle: what you learned about resistance to change. Three versions, from understated to bold."
    },
    "feat1Title": "Conversational AI assistant",
    "feat1Desc": "An intelligent copilot that drafts emails, reports and prospecting strategies. Real-time collaborative chat with your teams.",
    "feat2Title": "CRM & Prospect Pipeline",
    "feat2Desc": "Visual Kanban pipeline, detailed records, voice notes, contact relationships and full customer journey tracking.",
    "feat3Title": "Smart contact search",
    "feat3Desc": "Find and qualify prospects via Perplexity AI. Semantic analysis of online activity and automatic scoring.",
    "feat4Title": "Automatic monitoring",
    "feat4Desc": "Schedule recurring searches (daily, weekly). Thiia alerts you when new prospects match your criteria.",
    "feat5Title": "Calendar & Events",
    "feat5Desc": "Google Calendar and Outlook sync. Event management with registrations, QR codes and automatic reminders.",
    "feat6Title": "Built-in email client",
    "feat6Desc": "Gmail and Outlook integrated. Read, reply and send from Thiia with automatic prospect detection in your exchanges.",
    "feat7Title": "Content creation",
    "feat7Desc": "LinkedIn posts, newsletters, blog articles with rich editor. Editorial calendar and direct LinkedIn publishing.",
    "feat8Title": "Emails & Automated sequences",
    "feat8Desc": "Customizable templates, scheduled follow-up sequences, bulk sending and automatically generated PDF attachments.",
    "feat9Title": "Task lists",
    "feat9Desc": "Checklists tied to your prospects or projects with automatic reminders and progress tracking.",
    "feat10Title": "Wellbeing & Anti-burnout",
    "feat10Desc": "Daily check-in, energy tracking and personalized advice to preserve your professional balance.",
    "feat11Title": "Zoom & Teams integrations",
    "feat11Desc": "Import recordings and transcripts from your video calls directly into prospect records.",
    "feat12Title": "Installable app (PWA)",
    "feat12Desc": "Install Thiia on your phone or computer. Offline access to recently consulted data, even without connection.",
    "feat13Title": "Collaborative annotations",
    "feat13Desc": "Highlight Thiia's responses, add comments and resolve discussion threads. Perfect for teamwork on an analysis.",
    "feat14Title": "AI document library",
    "feat14Desc": "Centralize invoices, contracts and meeting notes by prospect. Automatic indexing for instant semantic search from chat.",
    "feat15Title": "Cloud imports (Drive, OneDrive, Dropbox)",
    "feat15Desc": "Connect Google Drive, OneDrive and Dropbox. Import your existing documents in two clicks, without leaving Thiia.",
    "benefitsBadge": "Benefits",
    "benefitsTitle1": "Why freelancers",
    "benefitsTitleAccent": "choose us",
    "ben1Title": "Save 10 hours a week",
    "ben1Desc": "Automate repetitive tasks and focus on what matters: your clients.",
    "ben2Title": "Convert more prospects",
    "ben2Desc": "A structured pipeline and smart follow-ups boost your conversion rate.",
    "ben3Title": "Get started in 5 minutes",
    "ben3Desc": "Intuitive interface, zero technical setup. Operational from day one.",
    "ben4Title": "French AI & data in France",
    "ben4Desc": "Thiia runs on Mistral, the sovereign French AI. Your data stays in France, private and secure, GDPR-compliant.",
    "howBadge": "How it works",
    "howTitle1": "Up and running in",
    "howTitleAccent": "3 steps",
    "step1Title": "Create your account",
    "step1Desc": "Sign up for free and set up your professional profile in a few clicks.",
    "step2Title": "Import or find your prospects",
    "step2Desc": "Add your existing contacts or use our search engine to discover new leads.",
    "step3Title": "Let AI work for you",
    "step3Desc": "The assistant drafts your emails, analyzes your prospects and recommends the best actions to take.",
    "testimonialsBadge": "Testimonials",
    "testimonialsTitle": "They transformed their business",
    "test1Name": "Sophie M.",
    "test1Role": "Leadership coach",
    "test1Quote": "I doubled my number of qualified prospects in 3 months. The AI assistant saves me a huge amount of time on writing.",
    "test2Name": "Thomas D.",
    "test2Role": "Independent consultant",
    "test2Quote": "Finally an all-in-one tool that understands the needs of freelancers. No more juggling 10 different apps!",
    "test3Name": "Marie L.",
    "test3Role": "Personal development trainer",
    "test3Quote": "Event management and participant tracking have transformed my business. 100% recommend.",
    "finalCtaTitle": "Ready to accelerate your growth?",
    "finalCtaSubtitle": "Join hundreds of professionals using Thiia to grow their business faster.",
    "finalCtaButton": "Start now",
    "finalCtaTag1": "Free trial",
    "finalCtaTag2": "No commitment",
    "finalCtaTag3": "Responsive support"
  },
  "dashboard": {
    "greeting": "Hello",
    "subtitle": "Here's an overview of your activity.",
    "stats": {
      "prospects": "Prospects",
      "events": "Events",
      "published": "Published",
      "content": "Content"
    },
    "credits": {
      "title": "Available credits",
      "buy": "Buy"
    },
    "quotaLabels": {
      "chat": "Chat",
      "report": "Report",
      "audio": "Audio",
      "posts": "Posts",
      "newsletter": "NL",
      "search": "Search",
      "analysis": "Analysis",
      "checklist": "Check"
    },
    "recommendations": {
      "title": "Recommended actions",
      "empty": "Add prospects or events to receive recommendations.",
      "priorityHigh": "Urgent",
      "priorityMedium": "Important",
      "priorityLow": "Tip"
    },
    "pipeline": {
      "title": "Pipeline",
      "nouveau": "New",
      "contacte": "Contacted",
      "en_discussion": "In discussion",
      "converti": "Converted",
      "perdu": "Lost"
    },
    "priorityToday": "Today's priority",
    "activeProspects": "active prospects",
    "thisWeek": "this week",
    "todayAgenda": "Today's agenda",
    "noEventToday": "No meeting today.",
    "contextLine": "{{events}} meetings, {{emails}} unread emails",
    "todayActions": "Your actions today",
    "upcomingMeetings": "Upcoming meetings",
    "followUp": "Tracking",
    "moreTracking": "More tracking",
    "prospectsTrend": "Prospect trend",
    "recentProspects": "Recent prospects",
    "noProspect": "No prospect.",
    "noUpcomingEvent": "No upcoming event.",
    "period": {
      "week": "This week",
      "month": "This month",
      "all": "All"
    },
    "tiles": {
      "activeProspects": "Active prospects",
      "sentEmails": "Emails sent",
      "publishedContent": "Published content",
      "overdueTasks": "Overdue tasks",
      "newInPeriod": "{{count}} new",
      "toProcess": "to handle"
    }
  },
  "prospects": {
    "documents": {
      "uploadTitle": "Upload a document",
      "uploadFailed": "Upload failed",
      "uploadedTitle": "Document uploaded",
      "uploadedDesc": "Indexing starts in the background.",
      "tooLargeTitle": "File too large",
      "tooLargeDesc": "Maximum size is 200 MB.",
      "dropHere": "Drop a file here or click to browse",
      "maxSize": "PDF, Word, PowerPoint, Excel, TXT, MD, images — 200 MB max",
      "type": "Type",
      "year": "Year",
      "upload": "Upload",
      "creditsLeft": "{{count}} credits",
      "searchTitle": "Search in documents",
      "searchPlaceholder": "Semantic search…",
      "searching": "Searching…",
      "noResults": "No results",
      "searchError": "Search error",
      "empty": "No documents for this prospect.",
      "confirmDelete": "Permanently delete \"{{name}}\"?",
      "deletedTitle": "Document deleted",
      "download": "Download",
      "reindex": "Re-index",
      "statusPending": "Pending",
      "statusProcessing": "Indexing…",
      "statusIndexed": "Indexed",
      "statusFailed": "Failed",
      "statusNoText": "No text",
      "statusQuotaExhausted": "Credits exhausted",
      "types": {
        "facture": "Invoices",
        "devis": "Quotes",
        "proposition": "Proposals",
        "cahier_charges": "Specifications",
        "bon_commande": "Purchase orders",
        "contrat": "Contracts",
        "avenant": "Amendments",
        "nda": "NDA",
        "cr_reunion": "Meeting notes",
        "brief": "Briefs",
        "presentation": "Presentations",
        "rapport": "Reports",
        "etude_cas": "Case studies",
        "autre": "Other"
      }
    },
    "title": "Prospects",
    "count_one": "{{count}} prospect",
    "count_other": "{{count}} prospects",
    "tabs": {
      "pipeline": "Pipeline",
      "list": "List",
      "emails": "Emails"
    },
    "searchPlaceholder": "Search by name, email, company, tag…",
    "empty": "No prospects yet.",
    "swipeHint": "← Swipe to change status →",
    "statusUpdated": "Status updated",
    "statusUpdatedTo": "→ {{label}}",
    "selected_one": "{{count}} prospect selected",
    "selected_other": "{{count}} prospects selected",
    "deletePrompt_one": "Delete {{count}} prospect?",
    "deletePrompt_other": "Delete {{count}} prospects?",
    "deleteDescription": "This action is irreversible. The selected prospects and their associated data will be permanently deleted.",
    "deleted_one": "{{count}} prospect deleted",
    "deleted_other": "{{count}} prospects deleted",
    "bulkAssignOrg": {
      "button_one": "Attach to org. ({{count}})",
      "button_other": "Attach to org. ({{count}})",
      "title_one": "Attach {{count}} prospect to organizations",
      "title_other": "Attach {{count}} prospects to organizations",
      "description": "Pick one or more organizations to associate with the selected prospects.",
      "noOrganization": "No organization yet. Create one in Settings.",
      "strategy": "Strategy",
      "addLabel": "Add to existing",
      "addHint": "Checked organizations are added to those already linked.",
      "replaceLabel": "Replace existing",
      "replaceHint": "Existing links are removed and replaced by your selection.",
      "confirm": "Attach",
      "selectAtLeastOne": "Select at least one organization",
      "success_one": "{{count}} prospect attached to {{orgs}} organization(s)",
      "success_other": "{{count}} prospects attached to {{orgs}} organization(s)",
      "addedDescription": "{{created}} new link(s) created.",
      "replacedDescription": "Links replaced. {{created}} active link(s).",
      "button": "Assign to organization",
      "success": "Prospects assigned",
      "title": "Assign prospects"
    },
    "addProspect": "Add prospect",
    "newProspect": "New prospect",
    "scanCard": "Scan a card",
    "analyzing": "Analyzing…",
    "orPasteLinkedIn": "or paste a LinkedIn link below",
    "fill": "Fill",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Phone",
    "company": "Company",
    "jobTitle": "Job title",
    "source": "Source",
    "meetingContext": "Meeting context",
    "meetingContextPlaceholder": "E.g. Tech Paris Expo 2026, introduced by Marie…",
    "meetingContextSelectEvent": "Select an event…",
    "meetingContextSearchEvent": "Search an event…",
    "meetingContextNoEvent": "No event found.",
    "meetingContextFreeText": "Free text",
    "meetingContextPickEvent": "Pick an event",
    "notes": "Notes",
    "adding": "Adding…",
    "addProspectAction": "Add prospect",
    "selectImage": "Please select an image",
    "imageTooLarge": "Image too large (max 10 MB)",
    "cardAnalyzed": "Business card analyzed successfully",
    "cardAnalysisError": "Error analyzing business card",
    "validLinkedInRequired": "Please enter a valid LinkedIn link",
    "linkedinEnriched": "LinkedIn profile enriched successfully",
    "linkedinEnrichError": "Error enriching LinkedIn profile",
    "filters": "Filters",
    "filtersTrigger": "Open prospect filters",
    "clearFilters": "Clear filters",
    "reset": "Reset",
    "selectedCount": "{{count}} {{label}} selected",
    "filterByStatus": "Filter prospects by status",
    "status": "Status",
    "type": "Type",
    "typeIndividual": "Individual",
    "typeOrganization": "Organization",
    "organizationName": "Organization name",
    "organizationNamePlaceholder": "Ex: Acme Inc.",
    "attachToOrganization": "Attach to an organization",
    "noOrganization": "No organization",
    "tags": "Tags",
    "relations": "Relations",
    "allTypes": "All types",
    "linkedTo": "Linked to {{name}}",
    "searchProspect": "Search a prospect…",
    "whatsappOptOut": "WhatsApp opt-out",
    "whatsappOptOutOnly": "Opt-out only",
    "exportExcel": "Export Excel",
    "results_one": "{{count}} result",
    "results_other": "{{count}} results",
    "sortDate": "Date added",
    "sortName": "Name A→Z",
    "sortSource": "By source",
    "sortStatus": "By status",
    "sortRelation": "By relations",
    "qrCode": "QR Code",
    "qrCodeTitle": "Contact QR code",
    "qrCodeDescription": "Show this QR code at your events. Your contacts can fill in their details directly.",
    "linkCopied": "Link copied!",
    "copied": "Copied",
    "copyLink": "Copy link",
    "download": "Download",
    "selectAll": "Select all",
    "selectProspect": "Select {{name}}",
    "name": "Name",
    "addedOn": "Added on",
    "noProspect": "No prospects yet.",
    "analyzed": "Analyzed",
    "relationCount": "{{count}} relation(s)",
    "noRelation": "No relation",
    "doubleClickRename": "Double-click to rename",
    "validateEscCancel": "↵ confirm · Esc cancel",
    "sendAiEmail": "Send an AI email",
    "relationTypes": {
      "collegue": "Colleague",
      "manager": "Manager",
      "collaborateur": "Collaborator",
      "conjoint": "Spouse",
      "recommande_par": "Recommended by",
      "meme_entreprise": "Same company",
      "partenaire": "Partner",
      "ami": "Friend",
      "autre": "Other"
    },
    "statusLabels": {
      "nouveau": "New",
      "contacte": "Contacted",
      "en_discussion": "In discussion",
      "converti": "Converted",
      "perdu": "Lost"
    },
    "sourceLabels": {
      "gmail": "Gmail",
      "outlook": "Outlook",
      "web": "Web",
      "evenement": "Event",
      "qr": "QR Code",
      "email": "Email",
      "reseaux_sociaux": "Social networks",
      "import": "Import",
      "manuel": "Manual",
      "recherche_ia": "AI search",
      "chat_ia": "AI chat"
    },
    "contactTypes": {
      "prospect": "Prospect",
      "client": "Client",
      "partenaire": "Partner"
    },
    "detail": {
      "tabFiche": "Profile",
      "tabActivity": "Activity",
      "tabDocuments": "Documents",
      "changeStatus": "Change status",
      "tags": "Tags",
      "noTag": "No tag",
      "addTagPlaceholder": "Add a tag…",
      "linkedEvents": "Linked events",
      "registered": "Registered",
      "bio": "Bio",
      "companyDescription": "Company description",
      "foundedIn": "Founded in {{year}}",
      "onlineActivity": "Online activity analysis",
      "interestThemes": "Interest themes",
      "publishedArticles": "Published articles",
      "personalSite": "Personal website",
      "linkedinActivity": "LinkedIn activity",
      "sources": "Sources",
      "linkedinProfile": "LinkedIn profile",
      "addedOn": "Added on {{date}}",
      "notes": "Notes",
      "notesPlaceholder": "Add notes about this prospect…",
      "sentEmails": "Sent emails ({{count}})",
      "noSubject": "No subject",
      "writeAiEmail": "Compose an email with AI",
      "deleteProspect": "Delete this prospect",
      "deleteTitle": "Delete this prospect?",
      "deleteDescription": "{{name}} will be permanently deleted, along with their emails and registrations. This action is irreversible.",
      "viewExchangesIn": "View exchanges in {{provider}}",
      "call": "Call"
    },
    "analyses": {
      "label": "Activity analyses",
      "exportPdf": "PDF",
      "compare": "Compare",
      "selected": "Selected",
      "analyze": "Analyze",
      "reanalyze": "Re-analyze",
      "running": "Analysis in progress via Perplexity AI…",
      "empty": "No analysis yet. Click \"Analyze\" to run an online activity analysis.",
      "analysisOf": "Analysis from {{date}}",
      "themesCount": "{{count}} themes",
      "comparison": "Comparison",
      "older": "Older",
      "recent": "Recent",
      "interestEvolution": "Evolution of interests",
      "new": "New",
      "removed": "Removed",
      "stable": "Stable",
      "oldSummary": "Old summary",
      "newSummary": "New summary",
      "interestThemes": "Interest themes",
      "icebreakers": "Icebreakers",
      "recentPosts": "Recent posts",
      "linkedinActivity": "LinkedIn activity",
      "personalSite": "Personal website",
      "sources": "Sources",
      "deleteTitle": "Delete this analysis?",
      "deleteDescription": "The analysis will be permanently deleted.",
      "delete": "Delete",
      "deleted": "Analysis deleted",
      "errorPrefix": "Error: ",
      "savedToast": "Analysis completed and saved!",
      "exportError": "PDF export error"
    },
    "reports": {
      "label": "Reports",
      "generateAi": "Generate with AI",
      "add": "Add",
      "titlePlaceholder": "Report title…",
      "contentPlaceholder": "Content…",
      "stop": "Stop",
      "cancel": "Cancel",
      "save": "Save",
      "saved": "Report updated",
      "added": "Report added",
      "deleted": "Report deleted",
      "empty": "No report",
      "noContent": "No content",
      "send": "Send",
      "pdf": "PDF",
      "edit": "Edit",
      "saveEdit": "Save",
      "deleteTitle": "Delete this report?",
      "deleteDescription": "The report will be permanently deleted.",
      "noEmail": "This prospect has no email address",
      "untitled": "Untitled",
      "analyzing": "Analyzing prospect data…",
      "generated": "Report generated!",
      "generateError": "Error during generation",
      "noContentGenerated": "No content generated",
      "sendByEmailTitle": "Send the report by email",
      "recipient": "Recipient",
      "subject": "Subject",
      "content": "Content",
      "attachPdf": "Attach the report as PDF",
      "sentTo": "Report sent to {{email}}",
      "sendError": "Error while sending",
      "pdfError": "Error generating PDF",
      "defaultTitle": "Report – {{date}}",
      "aiConfig": {
        "estimatedCost": "Estimated cost",
        "generate": "Generate report",
        "howCalculated": "How is the cost calculated?",
        "language": "Language",
        "model": "AI model",
        "title": "AI configuration"
      }
    },
    "swipeCard": {
      "analyzed": "Analyzed",
      "relations": "{{count}} relation(s)"
    },
    "emailDialog": {
      "title": "Personalized email — {{name}}",
      "objectiveLabel": "Email objective",
      "templates": "Templates ({{count}})",
      "savedTemplates": "Saved templates",
      "noTemplates": "No saved template yet. Generate an email then save it!",
      "noSubject": "No subject",
      "objectives": {
        "prise_contact": "First contact",
        "proposition": "Propose a service",
        "relance": "Follow-up",
        "invitation": "Event invitation",
        "suivi": "Follow-up after meeting",
        "custom": "Custom…"
      },
      "vars": {
        "prenom": "First name",
        "nom": "Last name",
        "nom_complet": "Full name",
        "entreprise": "Company",
        "poste": "Job title",
        "email": "Email"
      },
      "customObjectivePlaceholder": "Describe the goal of your email…",
      "generating": "Generating…",
      "regenerate": "Regenerate",
      "generate": "Generate the email with AI",
      "subject": "Subject",
      "subjectPlaceholder": "Email subject…",
      "body": "Email body",
      "edit": "Edit",
      "preview": "Preview",
      "variable": "Variable",
      "bodyPlaceholder": "The email content will appear here…",
      "templateNamePlaceholder": "Template name…",
      "save": "Save",
      "saveAsTemplate": "Save as template",
      "addSignature": "Append signature",
      "cancel": "Cancel",
      "modify": "Edit",
      "create": "Create",
      "signaturePlaceholder": "Ex:\nJohn Doe\nBusiness Coach\n+1 555 123 4567\nwww.mysite.com",
      "saveSignature": "Save",
      "noSignature": "No signature configured. Click \"Create\" to add one.",
      "noEmailWarning": "⚠️ This prospect has no email address. Sending will not be possible.",
      "scheduleSend": "Schedule sending",
      "pickDate": "Pick a date",
      "schedule": "Schedule",
      "send": "Send",
      "to": "To:",
      "subjectColon": "Subject:",
      "previewNoSubject": "(no subject)",
      "sentVia": "Sent via Thiia",
      "errors": {
        "generation": "Error during generation",
        "generationGeneric": "Unable to generate the email",
        "noProspectEmail": "This prospect has no email address",
        "subjectAndBodyRequired": "Subject and body are required",
        "sendFailed": "Sending error",
        "sendGeneric": "Unable to send the email",
        "fillAllFields": "Please fill all fields and pick a date",
        "futureDateRequired": "The scheduled date must be in the future",
        "scheduleFailed": "Unable to schedule the email",
        "saveFailed": "Error while saving",
        "generationEmpty": "Generation is empty."
      },
      "toasts": {
        "emailSent": "Email sent to {{name}}!",
        "emailScheduled": "Email scheduled for {{date}}",
        "templateSaved": "Template saved!",
        "templateLoaded": "Template \"{{name}}\" loaded — variables replaced",
        "templateDeleted": "Template deleted",
        "signatureSaved": "Signature saved",
        "generationCancelled": "Generation cancelled",
        "generationSuccess": "Email generated successfully"
      },
      "defaultRelance": {
        "subject": "Follow-up on our exchange, {{prenom}}",
        "body": "Hi {{prenom}},\n\nI hope you're doing well. I'm reaching out following our last exchange.\n\nI'd love to know if you've had the chance to think about our discussion and whether I can share any additional information.\n\nFeel free to let me know if you'd like to talk further.\n\nBest regards"
      },
      "customObjectiveRequired": "Please describe your objective.",
      "draft": {
        "autosaveLabel": "Autosave",
        "autosavedAt": "Saved at {{time}}",
        "delete": "Delete draft",
        "empty": "No drafts",
        "emptyError": "Draft is empty.",
        "hint": "Your drafts are saved automatically.",
        "history": "Draft history",
        "listLabel": "Drafts",
        "manageTitle": "Manage drafts",
        "nameLabel": "Draft name",
        "openList": "Open list",
        "restore": "Restore",
        "restorePrompt": "Restore this draft?",
        "restorePromptMany": "Restore these drafts?",
        "restoreVersion": "Restore this version",
        "restored": "Draft restored",
        "save": "Save",
        "saveAction": "Save draft",
        "saveError": "Could not save draft.",
        "saved": "Draft saved",
        "versionRestored": "Version restored",
        "versionsLabel": "Versions"
      },
      "newTemplate": "New template",
      "updateTemplate": "Update template"
    },
    "notesUi": {
      "header": "Notes",
      "stop": "Stop",
      "uploading": "Uploading…",
      "recordVoice": "Record a voice note",
      "importTeams": "Import a Teams transcript",
      "importZoom": "Import a Zoom recording",
      "add": "Add",
      "writePlaceholder": "Write a note…",
      "attachLabel": "Attach",
      "uploadingFile": "Uploading file {{current}}/{{total}}…",
      "cancel": "Cancel",
      "save": "Save",
      "empty": "No note yet",
      "modified": "(edited)",
      "preview": "Preview & Export",
      "sendByEmailPdf": "Send by email with PDF",
      "reopenDraft": "Reopen report draft",
      "draft": "Draft",
      "createAiReport": "Create AI report",
      "transcription": "Transcription",
      "transcribe": "Transcribe",
      "voiceSaved": "Voice note saved",
      "voiceDeleted": "Voice note deleted",
      "noteDeleted": "Note deleted",
      "transcriptionDone": "Transcription complete",
      "transcriptionError": "Transcription error",
      "uploadError": "Upload error",
      "noProspectEmail": "This prospect has no email address",
      "noteSentTo": "Note sent to {{email}}",
      "sendError": "Error while sending",
      "micError": "Cannot access microphone",
      "fileTooLarge": "{{name}} too large (max 200 MB)",
      "transcriptionOf": "Transcription of {{name}} complete",
      "transcriptionErrorOf": "Transcription error for {{name}}",
      "uploadErrorOf": "Upload error for {{name}}",
      "networkErrorOf": "Network error for {{name}}",
      "reportFinalized": "Report finalized and added to the note",
      "office365Expired": "Office 365 connection expired",
      "zoomExpired": "Zoom connection expired",
      "reconnectHint": "Go to Settings > Integrations to reconnect your account.",
      "importError": "Error during import",
      "copy": "Copy",
      "copied": "Copied!",
      "reportSeparator": "## 📋 Report – {{date}}",
      "noteEmailSubject": "Note – {{name}} – {{date}}",
      "teamsTranscriptHeader": "## 🎥 Teams transcript – {{title}}",
      "zoomTranscriptHeader": "## 🎥 Zoom transcript – {{title}}",
      "prospectFallback": "Prospect",
      "cancelTranscription": "Cancel transcription",
      "transcriptionCancelled": "Transcription cancelled",
      "voiceNotesTitle": "Voice notes",
      "recordShort": "Record",
      "attachToNote": "Add files to this note",
      "filesAttached": "{{count}} file(s) added to the note",
      "removeAttachment": "Remove attachment",
      "attachmentRemoved": "Attachment removed",
      "transcriptionFailedHttp": "Transcription failed (HTTP {{status}})"
    },
    "timeline": {
      "voiceNote": "Voice note",
      "emailSent": "Email sent",
      "emailReceived": "Email received",
      "registration": "Registration",
      "report": "Report",
      "activity": "Activity",
      "noSubject": "No subject",
      "event": "Event",
      "empty": "No activity recorded",
      "noEmailAddress": "This prospect has no email address",
      "noEmailAddressHelp": "Add an email address to the prospect to display exchanges.",
      "noEmailAccount": "No email account connected",
      "noEmailAccountHelp": "Connect your Gmail or Outlook account to display emails exchanged with this prospect.",
      "connectionSettings": "Connection settings",
      "play": "Play",
      "pause": "Pause",
      "emailOpened": "Email opened",
      "emailClicked": "Link clicked",
      "dateFormat": "MMM d, yyyy · HH:mm",
      "openInEmails": "Open in emails",
      "reply": "Reply"
    },
    "relationsUi": {
      "header": "Relations ({{count}})",
      "addRelation": "Add a relation",
      "searchPlaceholder": "Search for a prospect…",
      "labelPlaceholder": "Relation name (e.g. Co-founder)",
      "notePlaceholder": "Note (optional)",
      "cancel": "Cancel",
      "add": "Add",
      "alreadyExists": "This relation already exists",
      "addError": "Error while adding",
      "added": "Relation added",
      "deleted": "Relation deleted",
      "types": {
        "collegue": "Colleague",
        "manager": "Manager",
        "collaborateur": "Collaborator",
        "conjoint": "Spouse",
        "recommande_par": "Referred by",
        "meme_entreprise": "Same company",
        "partenaire": "Partner",
        "ami": "Friend",
        "autre": "Other"
      }
    },
    "aiIndexedDesc": "Your prospects have been indexed for AI search.",
    "aiIndexedTitle": "AI indexing complete",
    "aiSearchOff": "AI search off",
    "aiSearchOn": "AI search on",
    "aiSearchPlaceholder": "Search with AI…",
    "autocomplete": {
      "companies": "Companies",
      "organizations": "Organizations",
      "prospects": "Prospects"
    },
    "createOrgNamed": "Create organization \"{{name}}\"",
    "deletePrompt": "Delete this prospect?",
    "deleted": "Prospect deleted",
    "duplicateByName": "Duplicate by name",
    "duplicateFoundDesc": "A similar prospect already exists.",
    "duplicateFoundMatchedBy": "Matched by: {{field}}",
    "duplicateFoundTitle": "Duplicate detected",
    "goToExistingProspect": "Go to existing prospect",
    "loadingMore": "Loading…",
    "organizationAlreadyExists": "This organization already exists",
    "organizationCreated": "Organization created",
    "refresh": "Refresh",
    "refreshed": "Prospects refreshed",
    "searchOrCreateOrg": "Search or create an organization",
    "selected": "{{count}} selected",
    "sheet": {
      "viewExchangesIn": "View exchanges in"
    },
    "sortBy": "Sort by",
    "willAttachToOrg": "Will be attached to organization \"{{name}}\"",
    "insights": {
      "title": "Base insights",
      "byStatus": "By status",
      "byKind": "Individuals vs Organizations",
      "bySource": "Acquisition sources",
      "bySize": "Company size",
      "bySector": "Sectors",
      "topTags": "Most used tags",
      "weekly": "Additions (12 wk)",
      "noSector": "Enrich your organization records to see sectors.",
      "individuals": "Individuals",
      "organizations": "Organizations",
      "kpi": {
        "total": "Total",
        "mix": "People / Orgs",
        "analyzed": "AI-analyzed",
        "newWeek": "This week"
      },
      "export": {
        "xlsx": "Excel (.xlsx)",
        "csv": "CSV (.csv)"
      },
      "sources": {
        "web": "Web",
        "evenement": "Event",
        "qr": "QR code",
        "email": "Email",
        "reseaux_sociaux": "Social",
        "import": "Import",
        "manuel": "Manual",
        "gmail": "Gmail",
        "outlook": "Outlook",
        "recherche_ia": "AI search",
        "chat_ia": "AI chat",
        "unknown": "Unknown"
      },
      "noMatch": "No prospect matches these filters.",
      "filters": {
        "status": "Status",
        "source": "Source",
        "sector": "Sector",
        "matching": "{{n}} results",
        "noSource": "No source",
        "periods": {
          "all": "All time",
          "7d": "Last 7 days",
          "30d": "Last 30 days",
          "90d": "Last 90 days",
          "12m": "Last 12 months"
        }
      },
      "error": "Couldn't load insights",
      "bulkAnalyze": {
        "button": "Analyze {{n}} prospect(s)",
        "buttonAll": "Re-analyze",
        "tooltip": "AI analysis (Perplexity) — 1 credit / prospect",
        "tooltipAll": "All your prospects are already analyzed. You can refresh them.",
        "title": "Analyze my prospects",
        "description": "AI pulls recent activity, interests and conversation hooks for each prospect. Every analysis consumes 1 credit from the \"Analyses\" quota.",
        "toAnalyze": "Prospects to analyze",
        "cost": "Total cost",
        "credits": "{{n}} credit(s)",
        "available": "Available quota",
        "after": "Balance after analysis",
        "reanalyze": "Also re-analyze prospects already analyzed",
        "missing": "You are missing {{n}} analysis credit(s).",
        "rechargeHint": "Top up your quota to analyze your whole base, or run only what your balance allows.",
        "recharge": "Top up my quota",
        "launch": "Launch analysis",
        "launchPartial": "Analyze {{n}} prospect(s)",
        "running": "Analysis in progress…",
        "stopped": "Batch stopped (quota exhausted on the server).",
        "quotaExhausted": "Analysis quota exhausted, batch stopped.",
        "doneOk": "{{n}} prospect(s) successfully analyzed.",
        "donePartial": "{{ok}} analyzed, {{err}} failed.",
        "doneAllFail": "No prospect could be analyzed ({{err}} errors)."
      },
      "analysisCharts": {
        "title": "AI analysis insights",
        "basedOn": "based on {{n}} analyzed",
        "avgInterests": "{{n}} avg. interests",
        "topInterests": "Most frequent interests",
        "noInterests": "No interest identified.",
        "freshness": "Analysis freshness",
        "freshnessHint": "Re-analyze older records to keep your hooks up to date.",
        "topActive": "Most active prospects online",
        "noActive": "No online activity detected yet.",
        "pubs": "{{n}} pub."
      }
    },
    "createdAt": "Created at",
    "searchPlaceholderMobile": "Search a prospect…",
    "workspaceOrg": "Your organization",
    "workspaceOrgNone": "None (personal)"
  },
  "events": {
    "notes": {
      "unknownProspect": "Unknown prospect",
      "empty": "No notes taken during this event yet.",
      "summary": "{{notes}} prospect note(s) · {{recaps}} voice recap(s)",
      "voiceRecaps": "Voice recaps",
      "voiceRecap": "Voice recap",
      "noTranscription": "No transcription available.",
      "prospectNotes": "Prospect notes"
    },
    "search": {
      "loadingSuggestions": "⏳ Thiia is preparing your personalized suggestions…",
      "greeting": "👋 Hi! I'm Thiia. I'll help you find events relevant to your activity.\n\nWhat kind of event are you looking for?",
      "launchingSearch": "🔍 Launching the search for \"{{query}}\"...",
      "refinedSearch": "🔍 Search refined…",
      "noResults": "😕 I couldn't find any matching events. Want to adjust your criteria? For example, a different topic, location or period?",
      "foundResults": "✅ I found **{{count}} event(s)** matching your criteria! See the results below.\n\nYou can ask me to adjust: change location, event type, period, or add keywords.",
      "searchError": "❌ Sorry, an error occurred during the search. Want to try again?",
      "communicationError": "Communication error with Thiia",
      "unknownError": "Unknown error",
      "analysisError": "Analysis error",
      "analysisDone": "Analysis complete!",
      "analysisFailed": "Analysis error: {{message}}",
      "contactsFound": "{{count}} contact(s) identified!",
      "contactsImported": "{{count}} contacts imported!",
      "genericError": "Error: {{message}}",
      "importError": "Import error: {{message}}",
      "saveError": "Error while saving",
      "savedOk": "Search saved!",
      "deletedOk": "Search deleted",
      "reloadingSaved": "🔄 Re-running saved search « {{name}} »…",
      "registeredImported": "✅ Registered and imported: \"{{title}}\"",
      "imported": "\"{{title}}\" imported into your events",
      "contactImported": "{{name}} imported as a prospect",
      "contactNotes": "Contact identified via the event \"{{event}}\"\nRole: {{role}}\n{{relevance}}",
      "contactRelevance": "Relevance: {{value}}",
      "exportedCsv": "{{count}} event(s) exported to CSV",
      "csvHeaders": {
        "title": "Title",
        "date": "Date",
        "endDate": "End date",
        "location": "Location",
        "type": "Type",
        "price": "Price",
        "free": "Free",
        "organizer": "Organizer",
        "format": "Format",
        "language": "Language",
        "capacity": "Capacity",
        "expectedAudience": "Expected audience",
        "pastAttendance": "Past attendance",
        "targetAudience": "Target audience",
        "registrationDeadline": "Registration deadline",
        "url": "URL",
        "source": "Source",
        "description": "Description"
      },
      "yes": "Yes",
      "no": "No",
      "notSpecified": "Not specified",
      "online": "Online",
      "sourcePrefix": "Source",
      "suggestions": {
        "onlyIn": "Only in {{loc}}",
        "onlyInMsg": "Show me only events in {{loc}}",
        "onlyOnline": "Online only",
        "onlyOnlineMsg": "Filter only online events or webinars",
        "onlyFree": "Free only ({{count}})",
        "onlyFreeMsg": "Show me only free events",
        "byOrg": "By {{org}}",
        "byOrgMsg": "Show me only events organized by {{org}}",
        "changeCity": "Change city",
        "changeCityMsg": "Look for the same events in another city",
        "thisWeek": "This week",
        "thisWeekMsg": "Show me only events happening this week"
      },
      "ui": {
        "thiiaEvents": "Thiia – Events",
        "searchInProgress": "Search in progress…",
        "thiiaThinking": "Thiia is thinking…",
        "describeWhat": "Describe what you're looking for…",
        "hideChat": "Hide chat",
        "showChat": "Show chat",
        "results_one": "{{count}} result",
        "results_other": "{{count}} results",
        "save": "Save",
        "nameThisSearch": "Name this search",
        "searchPlaceholder": "E.g. AI conferences Paris",
        "saved": "Saved:",
        "allResults": "All results",
        "relevanceOver50": "Relevance > 50%",
        "sortBy": "Sort by…",
        "sortRelevance": "Relevance",
        "sortDate": "Date (soonest)",
        "sortPrice": "Price (ascending)",
        "noResultsYet": "No results yet",
        "describeInChat": "Describe the events you're looking for in the chat",
        "free": "Free",
        "paid": "Paid",
        "web": "Web",
        "audience": "Audience: {{value}}",
        "previousEditions": "Past editions: {{value}}",
        "publicLabel": "Audience: {{value}}",
        "analyzed": "Analyzed",
        "analyze": "Analyze",
        "contacts": "Contacts",
        "imported": "Imported",
        "register": "Register",
        "import": "Import",
        "aiAnalysis": "AI analysis",
        "aiAnalysisRelevance": "AI analysis — Relevance: {{score}}%",
        "themes": "Topics:",
        "highlights": "Highlights:",
        "speakers": "Speakers:",
        "networking": "Networking:",
        "recommendations": "Recommendations:",
        "pricing": "Pricing:",
        "contactsIdentified": "Identified contacts ({{count}})",
        "importAll": "Import all ({{count}})",
        "prospect": "Prospect",
        "page": "Page {{current}} / {{total}}",
        "results": "{{count}} results"
      }
    },
    "title": "Events Tracked",
    "count_one": "{{count}} event",
    "count_other": "{{count}} events",
    "categories": {
      "all": "All",
      "task": "Tasks",
      "meeting": "Meetings",
      "conference": "Conferences"
    },
    "status": "Status",
    "allStatuses": "All statuses",
    "filterByStatus": "Filter events by status",
    "statusesActive_one": "{{count}} status",
    "statusesActive_other": "{{count}} statuses",
    "clearStatuses": "Clear statuses",
    "tabs": {
      "table": "Table",
      "list": "List",
      "calendar": "Calendar"
    },
    "empty": "No events yet.",
    "deleteEvent": "Delete event",
    "types": {
      "task": "Task",
      "meeting": "Meeting",
      "conference": "Conference",
      "workshop": "Workshop",
      "webinar": "Webinar",
      "meetup": "Meetup",
      "coaching": "Coaching",
      "other": "Other"
    },
    "statuses": {
      "draft": "Draft",
      "registered": "Registered",
      "confirmed": "Confirmed"
    },
    "registrationStatuses": {
      "registered": "Registered",
      "confirmed": "Confirmed",
      "cancelled": "Cancelled",
      "attended": "Attended",
      "no_show": "No show"
    },
    "sheet": {
      "startDateTime": "Start date and time",
      "datePlaceholder": "Date",
      "location": "Location",
      "locationPlaceholder": "Event location",
      "description": "Description",
      "descriptionPlaceholder": "Event description…",
      "cancel": "Cancel",
      "save": "Save",
      "type": "Type",
      "status": "Status",
      "deleteButton": "Delete this event",
      "deleteTitle": "Delete this event?",
      "deleteDescription": "This action is irreversible. The event will be permanently deleted.",
      "deleteConfirm": "Delete",
      "dateFormat": "EEEE, MMMM d, yyyy · HH:mm",
      "breadcrumbList": "Events list",
      "breadcrumbDetail": "Event detail"
    },
    "add": {
      "trigger": "New event",
      "title": "Create an event",
      "fieldTitle": "Title *",
      "titlePlaceholder": "Event name",
      "type": "Type",
      "maxParticipants": "Max participants",
      "maxParticipantsPlaceholder": "Unlimited",
      "date": "Date *",
      "datePlaceholder": "Choose a date",
      "startTime": "Start time",
      "endTime": "End time",
      "video": "Video conference",
      "videoNone": "None",
      "location": "Location",
      "locationPlaceholder": "Address or video link",
      "description": "Description",
      "descriptionPlaceholder": "Event details…",
      "creating": "Creating…",
      "submit": "Create event"
    },
    "calendar": {
      "weekDays": [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
      ],
      "monthFormat": "MMMM yyyy"
    },
    "table": {
      "location": "Location"
    },
    "bulk": {
      "selectAll": "Select all",
      "selectAllFiltered": "Select all {{count}} filtered events",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "deleteSelected": "Delete selected",
      "confirmTitle_one": "Delete {{count}} event?",
      "confirmTitle_other": "Delete {{count}} events?",
      "confirmDescription": "This action is irreversible. The selected events will be permanently deleted.",
      "deletedOk_one": "{{count}} event deleted",
      "deletedOk_other": "{{count}} events deleted",
      "deletedPartial": "{{ok}} deleted, {{fail}} failed",
      "confirmTitle": "Delete selected events?",
      "deletedOk": "Events deleted",
      "selectedCount": "{{count}} selected"
    },
    "registrations": {
      "title": "Registrations",
      "empty": "No registrations yet.",
      "count_one": "{{count}} registration",
      "count_other": "{{count}} registrations",
      "bulk": {
        "confirmTitle_one": "Delete {{count}} registration?",
        "confirmTitle_other": "Delete {{count}} registrations?",
        "confirmDescription": "This action is irreversible. The selected registrations will be permanently deleted.",
        "deletedOk_one": "{{count}} registration deleted",
        "deletedOk_other": "{{count}} registrations deleted",
        "deletedPartial": "{{ok}} deleted, {{fail}} failed",
        "confirmTitle": "Delete selected registrations?",
        "deletedOk": "Registrations deleted"
      },
      "count": "{{count}} registrations"
    },
    "qr": {
      "buttonLabel": "QR Code",
      "titleWithEvent": "QR Code – {{title}}",
      "titleGeneric": "Event QR Code",
      "descriptionWithEvent": "Show this QR code at \"{{title}}\". Participants can register directly.",
      "descriptionGeneric": "Show this QR code to let participants register.",
      "copy": "Copy link",
      "copied": "Copied",
      "copySuccess": "Link copied!",
      "download": "Download",
      "linkLabel": "Registration link",
      "openLink": "Open link"
    },
    "count": "{{count}} events",
    "searchPlaceholderMobile": "Search…",
    "groups": {
      "thisWeek": "This week",
      "nextMonth": "Next month",
      "later": "Later",
      "past": "Past"
    },
    "filters": {
      "seeResults": "See {{count}} events"
    }
  },
  "content": {
    "title": "Content",
    "summary_drafts_one": "{{count}} draft",
    "summary_drafts_other": "{{count}} drafts",
    "summary_scheduled_one": "{{count}} scheduled",
    "summary_scheduled_other": "{{count}} scheduled",
    "summary_published_one": "{{count}} published",
    "summary_published_other": "{{count}} published",
    "communicate": "Communicate",
    "import": "Import",
    "importDialog": {
      "title": "Import a series of posts",
      "description": "Word, Markdown or PDF. Thiia detects the posts and channel, then schedules the most visible slots without overlapping your existing publications.",
      "dropzone": "Drop your document here",
      "analyzing": "Analyzing document…",
      "formats": ".md · .txt · .docx · .pdf",
      "start": "Start",
      "perWeek": "Posts / week",
      "audience": "Target audience",
      "audienceB2b": "Professionals (B2B)",
      "audienceB2c": "General public (B2C)",
      "audienceMixed": "Mixed",
      "organization": "Organization",
      "personal": "Personal",
      "cadenceDetected": "Detected cadence: {{raw}}",
      "weekendNotice": "{{count}} post(s) placed on the weekend (better reach for this audience)",
      "generateVisual": "Generate the described visual",
      "manualSlot": "Slot adjusted manually",
      "noSlot": "No free slot found",
      "imageProgress": "Generating visuals {{done}}/{{total}}…",
      "summary": "{{included}}/{{total}} posts · {{file}}",
      "visualsSuffix": " · {{count}} visual(s)",
      "cancel": "Cancel",
      "schedule": "Schedule",
      "scheduleCount": "Schedule {{count}} posts",
      "unsupportedTitle": "Unsupported format",
      "unsupportedDesc": "Use a .md, .txt, .docx or .pdf file",
      "noPostsTitle": "No post detected",
      "noPostsDesc": "Structure the document with one title per post (e.g. \"## Post 1 — Title\").",
      "readErrorTitle": "Could not read the file",
      "readErrorDesc": "Extraction error",
      "imageFailed": "Image not generated — {{title}}",
      "importedTitle": "{{count}} items imported",
      "importedDesc": "Find them in the editorial calendar.",
      "importFailed": "Import failed",
      "genericError": "Error"
    },
    "allTypes": "All",
    "allStatuses": "Any status",
    "tabs": {
      "list": "List",
      "calendar": "Editorial calendar"
    },
    "empty": "No content yet.",
    "emptyHint": "Use the \"Communicate\" button to get started.",
    "table": {
      "type": "Type",
      "title": "Title",
      "status": "Status",
      "date": "Date",
      "actions": "Actions"
    },
    "actions": {
      "publishLinkedIn": "Publish on LinkedIn",
      "copy": "Copy",
      "copied": "Copied to clipboard!",
      "duplicate": "Duplicate"
    },
    "deleteTitle": "Delete this content?",
    "deleteDescription": "The content will be permanently deleted.",
    "types": {
      "post_linkedin": "LinkedIn post",
      "post_linkedin_short": "LinkedIn",
      "post_instagram": "Instagram post",
      "post_instagram_short": "Instagram",
      "post_facebook": "Facebook post",
      "post_facebook_short": "Facebook",
      "post_twitter": "X / Twitter post",
      "post_twitter_short": "X",
      "post_whatsapp": "WhatsApp message",
      "post_whatsapp_short": "WhatsApp",
      "newsletter": "Newsletter",
      "newsletter_short": "Newsletter",
      "blog_article": "Blog article",
      "blog_article_short": "Blog"
    },
    "statuses": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "published": "Published",
      "archived": "Archived"
    },
    "calendar": {
      "weekDays": [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
      ],
      "monthFormat": "MMMM yyyy",
      "weekOf": "Week of"
    },
    "imageSection": {
      "addImage": "Add image",
      "generateAi": "Generate with AI",
      "dialogTitle": "Generate an image with AI",
      "describe": "Describe the desired image",
      "promptPlaceholder": "Ex: Professional photo of a team meeting, modern corporate style",
      "hint": "Be specific: style, colors, composition, mood…",
      "cancel": "Cancel",
      "generate": "Generate",
      "generating": "Generating…",
      "unsupportedFormat": "Unsupported format",
      "tooLarge": "Image too large (max 10 MB)",
      "imageAdded": "Image added",
      "imageGenerated": "Image generated and added ✨",
      "uploadError": "Upload error",
      "error": "Error",
      "notAuthenticated": "Not authenticated",
      "generationError": "Image generation error",
      "noImage": "No image generated"
    },
    "editor": {
      "placeholder": "Write your content…",
      "linkPrompt": "Link URL",
      "imagePrompt": "Image URL",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strike": "Strikethrough",
      "highlight": "Highlight",
      "h1": "Heading 1",
      "h2": "Heading 2",
      "h3": "Heading 3",
      "bullet": "Bullet list",
      "ordered": "Numbered list",
      "quote": "Quote",
      "divider": "Divider",
      "alignLeft": "Align left",
      "alignCenter": "Center",
      "alignRight": "Align right",
      "link": "Link",
      "image": "Image",
      "undo": "Undo",
      "redo": "Redo"
    },
    "linkedinDialog": {
      "title": "Publish on LinkedIn",
      "publishAs": "Publish as",
      "personalProfile": "Personal profile",
      "companyPage": "Company page",
      "choosePage": "Choose a page",
      "postContent": "Post content",
      "postPlaceholder": "Your LinkedIn post...",
      "charCount": "{{count}} / 3000 characters",
      "imageOptional": "Image (optional)",
      "preview": "Preview",
      "addImage": "Add an image",
      "visibility": "Visibility",
      "public": "🌍 Public",
      "connections": "👥 Connections only",
      "now": "Now",
      "schedule": "Schedule",
      "date": "Date",
      "time": "Time",
      "choose": "Choose",
      "scheduledFor": "📅 Scheduled for {{date}} at {{time}}",
      "copyOpen": "Copy & open LinkedIn",
      "publishOnPage": "Publish on page",
      "publishOnProfile": "Publish on my profile",
      "schedulePost": "Schedule post",
      "selectPage": "Select a company page.",
      "publishedToast": "✅ Post published to your LinkedIn {{label}}!",
      "labelPage": "company page {{name}}",
      "labelPersonal": "personal profile",
      "publishError": "Publish error",
      "scheduleError": "Schedule error",
      "futureDate": "The scheduled date must be in the future.",
      "scheduledToast": "📅 Post scheduled!",
      "scheduledToastDesc": "Your post will be published on {{date}}",
      "copiedToast": "Text copied! Paste it on LinkedIn.",
      "unsupportedFormat": "Unsupported format",
      "imagesOnly": "Only images are accepted.",
      "tooLarge": "Image too large",
      "max10mb": "Max 10 MB.",
      "dateFormatLong": "EEEE, MMMM d, yyyy",
      "dateFormatShort": "MMM d, yyyy",
      "scheduledDateFormat": "MMMM d, yyyy 'at' HH:mm",
      "back": "Back",
      "checklistClose": "Close",
      "checklistDesc": "Follow these steps to publish on LinkedIn.",
      "checklistDone": "Done",
      "checklistFinish": "Finish",
      "checklistTitle": "LinkedIn publication",
      "confirmPublish": "Publish",
      "confirmPublishDesc": "Confirm publishing this content on LinkedIn.",
      "confirmPublishTitle": "Confirm publication",
      "confirmSchedule": "Schedule",
      "confirmScheduleDesc": "Confirm scheduling this content.",
      "confirmScheduleTitle": "Confirm scheduling",
      "previewAndPublish": "Preview and publish",
      "previewAndSchedule": "Preview and schedule",
      "recopy": "Copy again",
      "reopen": "Reopen",
      "step1Desc": "Copy the content to your clipboard.",
      "step1Title": "Copy the content",
      "step2Desc": "Open LinkedIn to create a post.",
      "step2Title": "Open LinkedIn",
      "step3Desc": "Paste the content into the composer.",
      "step3Title": "Paste the content",
      "step4Desc": "Add your media if needed.",
      "step4Title": "Add media",
      "step5Desc": "Publish or schedule your post from LinkedIn.",
      "step5Title": "Publish on LinkedIn"
    },
    "generator": {
      "titleManual": "New publication",
      "titleAi": "Generate content with Thiia",
      "analyzing": "Analyzing…",
      "writing": "Thiia is writing…",
      "ready": "Your content is ready",
      "reviewTitle": "Title",
      "tabPreview": "Preview",
      "tabSource": "Source",
      "refinePlaceholder": "Ask Thiia to adjust… (e.g. make it shorter, add emojis)",
      "saveDraft": "Save as draft",
      "schedule": "Schedule",
      "publishLinkedIn": "Publish on LinkedIn",
      "copyLinkedIn": "Copy & open LinkedIn",
      "copyWhatsApp": "Copy for WhatsApp",
      "copyWhatsAppSuccess": "WhatsApp message copied",
      "copyWhatsAppSuccessDesc": "Paste it directly into WhatsApp — formatting will be preserved.",
      "copyError": "Copy failed",
      "copiedLabel": "Copied!",
      "channelFailed": "Generation failed for this channel",
      "retryChannel": "Retry this channel",
      "resumeChannel": "Resume this channel",
      "cancelGeneration": "Cancel",
      "channelCanceled": "Generation canceled",
      "multiCanceled": "Multi-channel generation canceled",
      "retryAllFailed": "Retry the {{count}} failed channels",
      "multiError": "Generation error",
      "generatingProgress": "Generating… {{done}}/{{total}} channels",
      "generationComplete": "Generation complete: {{done}}/{{total}} succeeded",
      "channelStreaming": "Generating…",
      "channelPending": "Queued…",
      "chars": "characters",
      "cleanWhatsApp": "Clean up WhatsApp formatting",
      "cleaned": "Text cleaned up",
      "whatsappPreviewHint": "Preview of the final rendering in WhatsApp — copying keeps the *bold* / _italic_ syntax.",
      "regenerate": "Regenerate",
      "confirmPublishTitle": "Confirm publication",
      "confirmPublishDesc": "Review your post preview before continuing.",
      "tooLong": "— too long",
      "cancel": "Cancel",
      "continuePublish": "Continue to publish",
      "modeAi": "Generate with Thiia",
      "modeManual": "Write manually",
      "forOrganization": "Which organization",
      "noOrg": "None (personal)",
      "orgDefaultSuffix": " · default",
      "contentType": "Content type",
      "soon": "Coming soon",
      "linkedInFormat": "LinkedIn format",
      "formats": {
        "classic": "Classic post",
        "classicDesc": "Text with or without image",
        "carousel": "Carousel",
        "carouselDesc": "Multi-image slideshow (PDF)",
        "poll": "Poll",
        "pollDesc": "Question + vote options",
        "article": "Article",
        "articleDesc": "Long-form article",
        "video": "Video / Script",
        "videoDesc": "Script for LinkedIn video"
      },
      "mediaAndSources": "Media and sources",
      "filesCounter": "{{files}}/{{maxFiles}} files · {{used}}/{{max}} MB",
      "acceptedHint": "Images {{images}} · Docs PDF, Word, TXT, CSV, Excel · Audio MP3, WAV, M4A · {{maxImg}} MB (image) / {{maxDoc}} MB (doc/audio)",
      "library": "Library",
      "librarySelected_one": "{{count}} selected",
      "librarySelected_other": "{{count}} selected",
      "libraryHiddenCount_one": " · {{count}} hidden",
      "libraryHiddenCount_other": " · {{count}} hidden",
      "hideHidden": "Hide hidden",
      "showHidden": "Show hidden",
      "collapse": "Collapse",
      "chooseMySources": "Choose my sources",
      "libraryHint": "Check the media Thiia should use as sources.",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "hidden": "(hidden)",
      "typeImage": "Image",
      "typeAudio": "Audio",
      "typeDoc": "Doc",
      "dropHere": "Drop your files here",
      "filesInProgress_one": "{{count}} file in progress",
      "filesInProgress_other": "{{count}} files in progress",
      "cancelAll": "Cancel all",
      "statusQueued": "Queued…",
      "statusUploadImage": "Uploading image…",
      "statusUpload": "Uploading…",
      "statusExtracting": "Extracting text…",
      "statusTranscribing": "Transcribing audio…",
      "statusDone": "Done",
      "statusError": "Error",
      "cancelImport": "Cancel this import",
      "notImported_one": "{{count}} file not imported",
      "notImported_other": "{{count}} files not imported",
      "clearAll": "Clear all",
      "retry": "Retry",
      "ignore": "Ignore",
      "mediaAdded": "Added media",
      "removeAll": "Remove all",
      "removeMedia": "Remove this media",
      "typePdf": "PDF",
      "typeCsv": "CSV",
      "typeWord": "Word",
      "typeDocument": "Document",
      "extractedCharsSuffix": " characters extracted",
      "noPreview": "No preview available",
      "removeDocument": "Remove the document",
      "removePhoto": "Remove the photo",
      "addPhoto": "Add a photo",
      "limitReached": "Limit reached — remove a file to add more",
      "attachDocTitle": "Attach a document (PDF, Word, image, text) or audio (mp3, wav, m4a…)",
      "smartAnalysis": "Smart analysis",
      "smartAnalysisDesc": "Thiia analyzes your posts, sent emails and upcoming events to enrich your newsletter.",
      "recentPosts": "Recent posts",
      "sentEmails": "Sent emails",
      "eventsLabel": "Events",
      "reanalyze": "Re-analyze",
      "analyzeMyData": "Analyze my data",
      "analysisReady": "Analysis ready",
      "subjectTheme": "Subject / Theme *",
      "topicPlaceholderPoll": "E.g. What is the biggest challenge for managers in 2026?",
      "topicPlaceholderCarousel": "E.g. 7 mistakes to avoid in your prospecting strategy…",
      "topicPlaceholderVideo": "E.g. 3 tips to succeed at public speaking…",
      "topicPlaceholderLinkedIn": "E.g. The 5 habits of high-performing leaders…",
      "topicPlaceholderNewsletter": "E.g. Monthly newsletter March 2026, news and upcoming events…",
      "topicPlaceholderDefault": "E.g. My feedback on corporate coaching…",
      "desiredTone": "Desired tone",
      "toneWarm": "Professional & warm",
      "toneDynamic": "Dynamic & motivating",
      "toneInspiring": "Inspiring & poetic",
      "toneDirect": "Direct & punchy",
      "toneEducational": "Educational & instructive",
      "generateWithThiia": "Generate with Thiia",
      "titleOptional": "Title (optional)",
      "titleInternalPlaceholder": "Internal title to find this content later…",
      "yourMessage": "Your message *",
      "messagePlaceholder": "Write your post here…",
      "markdownSupported": "Markdown supported (bold, lists, links). No AI generation is applied.",
      "saveDraftBtn": "Save draft",
      "finalize": "Finalize",
      "analyzingData": "Analyzing your posts, emails and events…",
      "writingContent": "Thiia is writing your content…",
      "deleteMediaTitle": "Delete this media?",
      "deleteMediaDesc": "The file <strong>{{name}}</strong> will be permanently removed from your library. This action is irreversible. If you want to keep it in reserve, use the \"Hide\" option instead.",
      "deletePermanently": "Delete permanently",
      "copied": "Text copied! Paste it into LinkedIn."
    },
    "summary_drafts": "{{count}} drafts",
    "summary_published": "{{count}} published",
    "summary_scheduled": "{{count}} scheduled",
    "generate": "Generate",
    "filters": {
      "seeResults": "View {{count}} items"
    }
  },
  "profileCompletion": {
    "label": "Profile {{percent}}%",
    "aria": "Profile {{percent}}% complete, open profile settings"
  },
  "onboarding": {
    "headerTitle": "Welcome to Thiia",
    "headerSubtitle": "Setting up your profile",
    "letsGo": "Let's go! 🚀",
    "validateOne": "Confirm ({{count}} selected)",
    "validateOther": "Confirm ({{count}} selected)",
    "saving": "Saving…",
    "enterApp": "Enter Thiia →",
    "back": "Back",
    "skip": "Skip this question",
    "saveErrorTitle": "Could not save",
    "saveErrorDesc": "Your answers could not be saved. Check your connection and try again.",
    "stepCounter": "Step {{current}} / {{total}}",
    "otherPlaceholder": "Please specify…",
    "summary": {
      "title": "Summary",
      "edit": "Edit",
      "notProvided": "Not provided",
      "preferredLanguage": "Preferred language",
      "businessType": "Line of work",
      "targetAudience": "Target audience",
      "communicationTone": "Communication tone",
      "socialNetworks": "Social networks",
      "toolsUsed": "Tools you use",
      "referralSource": "How you heard about us"
    },
    "skipAll": "Skip",
    "stepIndicator": "{{current}} of {{total}}",
    "singleTitle": "What do you do, and who for?",
    "singleSubtitle": "One sentence is enough. It's what lets the agent start looking for the right contacts right away.",
    "activityPlaceholder": "Career-change coach for executives over 40, in the Paris region…",
    "activityPrefill": "{{activity}} for ",
    "launchAgent": "Launch the agent",
    "editableLater": "You can change this any time in your settings",
    "defaultActivity": "Independent professional looking for new clients",
    "chatKickoff": "My business: {{activity}}. Run a first search for matching contacts right away, then ask me which tone you should write in: Direct, Warm, Institutional, or Like I write.",
    "activities": {
      "coach": "Coach",
      "consultant": "Consultant",
      "trainer": "Trainer",
      "agency": "Agency",
      "techFreelance": "Tech freelancer",
      "other": "Other"
    },
    "nextTitle": "What happens next",
    "next": {
      "oneTitle": "The agent searches",
      "oneDesc": "It scans networks and public signals to spot the people who match your business.",
      "twoTitle": "You validate",
      "twoDesc": "Keep the relevant profiles, discard the rest: the agent learns from your choices.",
      "threeTitle": "Your profile fills in",
      "threeDesc": "Tone, networks, tools: everything adjusts as you go, with no form to fill in."
    },
    "creditsTitle": "Free credits on sign-up",
    "creditsDesc": "Enough to launch a first campaign before choosing a pack.",
    "languages": {
      "fr": "🇫🇷 Français",
      "en": "🇬🇧 English"
    },
    "steps": {
      "welcome": "Hello! 👋 I'm Thiia, your personal AI assistant. I'll ask you a few questions to get to know you better and tailor my help to your needs. Ready?",
      "preferredLanguage": "Which language would you prefer to use Thiia in? 🌐",
      "businessType": "What's your line of work? (e.g. consulting, training, coaching, freelance, mentoring…)",
      "businessTypePlaceholder": "e.g. Digital strategy consultant",
      "targetAudience": "Great! And who's your target audience? Describe the ideal profile of your clients. 🎯",
      "targetAudiencePlaceholder": "e.g. Executives and leaders in career transition",
      "communicationTone": "How do you like to communicate? What tone do you prefer for your professional exchanges?",
      "socialNetworks": "Which social networks are you active on? I'll help you create tailored content. 📱",
      "toolsUsed": "Which tools do you currently use for prospecting or client management? (multi-select) 🛠️",
      "referralSource": "Last question! How did you hear about Thiia? 💬",
      "done": "Perfect! I have everything I need to get started. 🚀 I'll adapt my prospect searches, content suggestions and communication style to your profile. Let's go!"
    },
    "tones": {
      "professionnel": "Professional & formal",
      "chaleureux": "Warm & approachable",
      "dynamique": "Dynamic & motivating",
      "inspirant": "Inspiring & poetic"
    },
    "tools": {
      "hubspot": "HubSpot",
      "salesforce": "Salesforce",
      "pipedrive": "Pipedrive",
      "notion": "Notion",
      "airtable": "Airtable",
      "spreadsheets": "Excel / Google Sheets",
      "salesNav": "LinkedIn Sales Navigator",
      "lemlist": "Lemlist / Waalaxy",
      "brevo": "Brevo / Mailchimp",
      "zoho": "Zoho CRM",
      "none": "No tool yet",
      "other": "Other"
    },
    "referral": {
      "linkedin": "LinkedIn",
      "google": "Google search",
      "wordOfMouth": "Word of mouth",
      "press": "Article / blog / press",
      "socialMedia": "Social media (Instagram, X, Facebook…)",
      "event": "Event / trade show",
      "newsletter": "Email / newsletter",
      "ad": "Advertising",
      "invited": "Invited",
      "other": "Other"
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread_one": "{{count}} unread",
    "unread_other": "{{count}} unread",
    "markAllRead": "Mark all as read",
    "markAllReadShort": "Mark all",
    "empty": "No notifications yet.",
    "new": "New",
    "view": "View",
    "markRead": "Mark as read",
    "bellTooltip": "Notifications",
    "unread": "Unread"
  },
  "emails": {
    "searchPlaceholder": "Search or ask an AI question... (⌘K)",
    "searchPlaceholderShort": "Search...",
    "aiSearchTitle": "AI smart search (Shift+Enter)",
    "showSidebar": "Show sidebar",
    "hideSidebar": "Hide sidebar",
    "compactMode": "Compact mode",
    "comfortableMode": "Comfortable mode",
    "shortcuts": "Keyboard shortcuts (?)",
    "new": "New",
    "partialResults": "Incomplete results: some mailboxes did not answer in time.",
    "partialRetry": "Retry",
    "partialHint": "Narrow the period or refine your keywords to speed up the search.",
    "noMatch": "No email matches the filters",
    "clearFilters": "Clear filters",
    "list": {
      "loading": "Loading…",
      "empty": "No email found",
      "loadMore": "Load more",
      "draft": "Draft",
      "yesterday": "Yesterday"
    },
    "filters": {
      "unread": "Unread",
      "attachments": "Attachments",
      "sender": "Sender",
      "searchContact": "Search a contact…",
      "noContact": "No contact found",
      "clearFilter": "Clear filter",
      "today": "Today",
      "week": "Last 7 days",
      "month": "Last 30 days",
      "quarter": "Last 90 days",
      "allDates": "All dates",
      "sortDate": "Date",
      "sortFrom": "Sender",
      "sortSubject": "Subject",
      "results_one": "{{count}} result",
      "results_other": "{{count}} results",
      "clear": "Clear",
      "filtersAndSort": "Filters & sort",
      "results": "{{count}} results"
    },
    "viewer": {
      "back": "Back",
      "from": "From",
      "to": "To",
      "cc": "Cc",
      "fromShort": "From:",
      "analyze": "Analyze",
      "replyAll": "Reply all",
      "reply": "Reply",
      "forward": "Forward",
      "attachments_one": "{{count}} attachment",
      "attachments_other": "{{count}} attachments",
      "dateFormat": "MMM d, yyyy 'at' HH:mm",
      "addAllProspects": "Add all as prospects",
      "addAsProspect": "Add as prospect",
      "alreadyProspect": "Already a prospect",
      "attachments": "Attachments",
      "bulkAddCount": "{{count}} contacts added",
      "bulkAddDone": "Bulk add completed",
      "download": "Download",
      "duplicateAddAnyway": "Add anyway",
      "duplicateDomainBody": "A prospect already exists with the same domain.",
      "duplicateExisting": "Existing prospect",
      "duplicateNew": "New contact",
      "duplicateTitle": "Potential duplicate detected",
      "prospectAdded": "Prospect added",
      "sameDomainProspect": "Same-domain prospect"
    },
    "composer": {
      "saveDraft": "Draft",
      "newMessage": "New message",
      "reply": "Reply",
      "forward": "Forward",
      "templates": "Templates",
      "noTemplate": "No template saved",
      "saveAsTemplate": "Save as template",
      "templateSaved": "Template saved",
      "templateSavedDesc": "\"{{name}}\" has been saved.",
      "templateLoaded": "Template loaded",
      "templateLoadedDesc": "\"{{name}}\" applied.",
      "templateDeleted": "Template deleted",
      "templateDeletedDesc": "\"{{name}}\" has been deleted.",
      "saveTemplate": "Save template",
      "templateNamePlaceholder": "Template name…",
      "savedContent": "Saved content:",
      "subjectField": "Subject: {{value}}",
      "messageField": "Message: {{value}}",
      "empty": "(empty)",
      "attachmentsCount_one": "{{count}} attachment",
      "attachmentsCount_other": "{{count}} attachments",
      "save": "Save",
      "to": "To",
      "ccOptional": "Cc (optional)",
      "subject": "Subject",
      "bodyPlaceholder": "Write your message...",
      "attachFile": "Attach a file",
      "aiAssist": "AI assistance",
      "aiInstructions": "AI instructions (optional)...",
      "writeReply": "Write reply",
      "compose": "Compose",
      "improve": "Improve",
      "draft": "Draft",
      "updateDraft": "Update draft",
      "cancel": "Cancel",
      "send": "Send",
      "error": "Error",
      "attachmentsCount": "{{count}} attachment(s)"
    },
    "unsubscribe": {
      "clickHere": "click here",
      "footerText": "To stop receiving emails, {{link}}."
    },
    "attachTx": {
      "title": "Attach to a bank transaction",
      "button": "Attach to a transaction",
      "search": "Search by vendor, label or amount",
      "empty": "No transaction to justify. Run a pass in Receipts.",
      "noResult": "No matching transaction.",
      "suggested": "Suggested",
      "confirm": "Validate and attach",
      "done": "Invoice attached to the transaction",
      "unavailable": "Attachment unavailable",
      "org": "Organization",
      "allOrgs": "All organizations",
      "noOrg": "No organization"
    }
  },
  "chat": {
    "heroGreetingSuffix": ", I'm Thiia",
    "heroTagline": "Your AI assistant for prospecting and communication",
    "heroTaglineShort": "Your AI assistant for prospecting",
    "newConversation": "New conversation",
    "searchPlaceholder": "Search…",
    "tabs": {
      "conversations": "Conversations",
      "note": "Note"
    },
    "inputPlaceholder": "Ask a question or request a task…",
    "errors": {
      "generic": "Error",
      "createConversation": "Unable to create the conversation",
      "delete": "Unable to delete",
      "rename": "Unable to rename",
      "archive": "Unable to archive",
      "reset": "Unable to reset",
      "deleteMessage": "Unable to delete the message"
    },
    "toasts": {
      "conversationReset": "Conversation reset",
      "messageDeleted": "Message deleted",
      "uploadCancelled": "Upload cancelled",
      "uploadFailed": "Upload failed"
    },
    "upload": {
      "tooLarge": "The file is too large. The limit depends on your Supabase plan (200 MB on Free, 5 GB on Pro). Please compress or split the file and try again.",
      "badFormat": "Unsupported file format. Accepted formats: MP3, WAV, MP4, WEBM, M4A, PDF, DOC, images.",
      "network": "Network error. Check your connection then re-upload the file.",
      "generic": "Upload failed. Please try again with a smaller file or in another format.",
      "withReason": "Upload failed: {{error}}. Please try again."
    },
    "transcription": {
      "noTranscription": "No transcription received",
      "error": "❌ Transcription error: {{error}}. Please try again.",
      "unknownError": "Unknown error"
    },
    "quickActions": {
      "orChoose": "or choose a quick action",
      "audioReport": "Audio report",
      "communicate": "Communicate",
      "communicateDesc": "Email, post, message",
      "newsletter": "Newsletter",
      "newsletterDesc": "Write a pro send",
      "followUp": "Follow-ups",
      "followUpDesc": "Schedule a follow-up",
      "findProspects": "Find prospects",
      "findProspectsDesc": "Targeted web search",
      "findEvents": "Find events",
      "findEventsDesc": "Trade shows, conferences",
      "addProspect": "Add prospect",
      "addProspectDesc": "New CRM record",
      "myProspects": "My prospects",
      "myProspectsDesc": "View my pipeline",
      "tasksList": "Task list",
      "tasksListDesc": "Organize my actions",
      "suggestions": {
        "findCoachingProspects": "Find me prospects in coaching",
        "summarizeRecent": "Summarize my recent exchanges"
      }
    }
  },
  "calendar": {
    "title": "Calendar",
    "noEventToday": "No event on this day",
    "organization": "Organization",
    "newEvent": "New event",
    "syncWith": "Sync {{providers}}",
    "connectCalendar": "Connect a calendar",
    "loading": "Loading…",
    "syncSuccess": "{{count}} event(s) imported from {{sources}}",
    "syncUpToDate": "Calendars up to date, no new events",
    "syncError": "Sync error",
    "googleError": "Google error",
    "outlookError": "Outlook error",
    "views": {
      "agenda": "Agenda",
      "month": "Month",
      "week": "Week",
      "day": "Day"
    },
    "today": "Today",
    "allOrgs": "All orgs",
    "allAccounts": "All",
    "manualAccounts": "Manual",
    "dateFormat": "EEEE, MMMM d, yyyy"
  },
  "rules": {
    "title": "Rules & Preferences",
    "summary": "{{count}} rule · {{active}} active · {{learned}} learned by Thiia",
    "summary_plural": "{{count}} rules · {{active}} active · {{learned}} learned by Thiia",
    "intro": "Thiia learns from your corrections and feedback. When you edit a post or email, it remembers your preferences automatically. You can also add rules manually.",
    "all": "All",
    "empty": "No rule in this category.",
    "emptyHint": "Add a rule manually or let Thiia learn from your corrections.",
    "add": "Add a rule",
    "addNew": "New rule",
    "category": "Category",
    "ruleTitle": "Title",
    "ruleTitlePlaceholder": "e.g.: Always use first names with prospects",
    "description": "Description / Details",
    "descriptionPlaceholder": "Describe the rule Thiia should follow…",
    "adding": "Adding…",
    "addRuleAction": "Add rule",
    "edit": "Edit",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "titlePlaceholder": "Rule title",
    "contentPlaceholder": "Rule content",
    "learnedBadge": "Learned by Thiia",
    "manualBadge": "Manual",
    "deleteTitle": "Delete this rule?",
    "deleteDescription": "The rule will be permanently deleted.",
    "dateFormat": "MMM d, yyyy",
    "templatesTitle": "Ready-to-use rule templates",
    "templateAdded": "Added",
    "templateAdd": "Add",
    "templateAdding": "Adding…",
    "categories": {
      "tone": {
        "label": "Communication tone",
        "description": "How Thiia addresses your prospects and writes your messages"
      },
      "writing": {
        "label": "Writing style",
        "description": "Writing rules for posts, newsletters and articles"
      },
      "search": {
        "label": "Search criteria",
        "description": "Filters and preferences for automatic prospecting"
      },
      "reports": {
        "label": "Reports",
        "description": "Instructions for generating AI reports (format, structure, tone, length…)"
      },
      "general": {
        "label": "General",
        "description": "General preferences for Thiia"
      },
      "email_learned_pattern": {
        "label": "Email analysis",
        "description": "Patterns learned from imports and contact rejections — used to refine future analyses"
      },
      "email_analysis": {
        "label": "Analysis instructions",
        "description": "Your custom instructions to guide prospect detection in your emails"
      }
    },
    "templates": {
      "session": {
        "title": "Coaching session report",
        "description": "Classic structure for individual sessions"
      },
      "express": {
        "title": "Express report (5 lines max)",
        "description": "Ultra-short format for quick follow-up"
      },
      "client": {
        "title": "Report to send to client",
        "description": "Client-friendly, positive and motivating version"
      },
      "tracking": {
        "title": "Detailed tracking sheet",
        "description": "Complete follow-up with goals and indicators"
      },
      "group": {
        "title": "Group session report",
        "description": "Suited for workshops and group sessions"
      }
    },
    "defaultReportTitle": "Session report format",
    "bulk": {
      "confirmDescription": "This action is irreversible.",
      "confirmTitle": "Delete selected rules?",
      "deleteSelected": "Delete selection",
      "deletedOk": "Rules deleted",
      "deletedPartial": "Some rules could not be deleted",
      "selectAll": "Select all",
      "selectedCount": "{{count}} selected"
    },
    "colActions": "Actions",
    "colCategory": "Category",
    "colDate": "Date",
    "colSource": "Source",
    "colTitle": "Title",
    "collapse": "Collapse",
    "expand": "Expand",
    "filter": {
      "active": "Active",
      "allSources": "All sources",
      "allStatus": "All statuses",
      "clear": "Clear filters",
      "inactive": "Inactive"
    },
    "searchPlaceholder": "Search a rule…"
  },
  "checklists": {
    "title": "Tasks",
    "newList": "New list",
    "namePlaceholder": "Checklist name…",
    "noOrg": "No org",
    "create": "Create",
    "newListTitle": "New list",
    "sectionPlaceholder": "Section name",
    "header": {
      "allOrganizations": "All organizations",
      "assignedToMe": "Assigned to me",
      "assignedToMeTitle": "Tasks assigned to me",
      "viewList": "List",
      "viewAgenda": "Agenda",
      "viewCalendar": "Calendar",
      "viewTable": "Table",
      "viewTags": "Tags",
      "noSection": "No section",
      "groupBy": "Group",
      "groupTasks": "Tasks",
      "groupLists": "Lists",
      "groupCrm": "By record"
    }
  },
  "autoSearch": {
    "title": "Auto monitoring",
    "subtitle": "Results from your automatic searches",
    "creditsOne": "{{count}} search credit",
    "creditsOther": "{{count}} search credits",
    "settings": "Monitoring settings",
    "enabled": "Automatic monitoring",
    "enabledDesc": "Automatically search for new results",
    "frequency": "Frequency",
    "daily": "Daily",
    "weekly": "Weekly",
    "weeklyDay": "Day of week",
    "sendHour": "Digest send time",
    "digestDaily": "Thiia will run your searches every day at {{hour}} and email you a summary.",
    "digestWeekly": "Thiia will run your searches every {{day}} at {{hour}} and email you a summary.",
    "launchNow": "Run now",
    "settingsUpdated": "Settings updated",
    "launchSuccess": "Monitoring started! Results will appear below.",
    "launchError": "Error: {{message}}",
    "launchErrorDefault": "Unable to start monitoring",
    "empty": "No automatic results yet",
    "emptyHint": "Save searches in the Events or People tabs so Thiia can run them automatically.",
    "unreadOne": "{{count}} unread",
    "unreadOther": "{{count}} unread",
    "totalResults": "{{count}} result(s) total",
    "deleteSelected": "Delete ({{count}})",
    "confirmDeleteOne": "Delete {{count}} result?",
    "confirmDeleteMany": "Delete {{count}} results?",
    "deletedOne": "{{count}} result deleted",
    "deletedMany": "{{count}} results deleted",
    "filterAll": "All",
    "filterEvents": "🎯 Events",
    "filterPersons": "👤 People",
    "colSearch": "Search",
    "colType": "Type",
    "colResults": "Results",
    "colDate": "Date",
    "selectAll": "Select all",
    "select": "Select",
    "typeEvent": "Event",
    "typePerson": "Person",
    "delete": "Delete",
    "dateFormat": "MMM d, yyyy 'at' HH:mm",
    "shortDateFormat": "MMM d, yyyy",
    "colEvent": "Event",
    "colLocation": "Location",
    "colName": "Name",
    "colJob": "Job",
    "colCompany": "Company",
    "colCity": "Location",
    "importEvent": "Import into my events",
    "importProspect": "Import as prospect",
    "importedEvent": "\"{{title}}\" imported into your events",
    "importedProspect": "{{name}} added to prospects",
    "importError": "Error: {{message}}",
    "noteBio": "Bio: {{value}}",
    "noteSector": "Sector: {{value}}",
    "noteLocation": "Location: {{value}}",
    "noteRelevance": "Relevance: {{value}}",
    "sourceLabel": "Source: {{url}}",
    "seeResults": "See watch results",
    "confirmDeleteDesc": "This action cannot be undone."
  },
  "templates": {
    "title": "Templates",
    "comingSoon": "Email and content templates will be available soon.",
    "followup": {
      "sectionTitle": "Default follow-up templates",
      "sectionDesc": "A different template per prospect status. Variables:",
      "subject": "Subject",
      "subjectPlaceholder": "e.g. Following up on our exchange, {{prénom}}",
      "body": "Email body",
      "bodyPlaceholder": "e.g. Hello {{prénom}}, I'm following up after our recent conversation…",
      "save": "Save this template",
      "savedToast": "Template \"{{label}}\" saved ✓",
      "showPreview": "Show preview",
      "hidePreview": "Hide preview",
      "previewWith": "Preview — {{name}}",
      "previewFictive": "Preview — sample data",
      "fictiveData": "Sample data",
      "statuses": {
        "nouveau": "New",
        "contacte": "Contacted",
        "en_discussion": "In discussion"
      }
    }
  },
  "personSearch": {
    "title": "People search",
    "subtitle": "Find and qualify contacts with AI search"
  },
  "eventsSearch": {
    "title": "Event search"
  },
  "publicNav": {
    "home": "Home",
    "freeTrial": "Free trial",
    "useCases": "Use cases",
    "legal": "Legal notice",
    "privacy": "Privacy",
    "contact": "Contact"
  },
  "publicFooter": {
    "rights": "© {{year}} Thiia — KREAPP SAS. All rights reserved. Made with ❤️ in France 🇫🇷"
  },
  "useCases": {
    "badge": "Use cases",
    "heroTitle": "Thiia adapts to",
    "heroTitleAccent": "your profession",
    "heroSubtitle": "Discover how entrepreneurs, coaches and freelancers use Thiia daily to grow their business.",
    "challengesTitle": "Your daily challenges",
    "sharedBadge": "For every profile",
    "sharedTitle": "Features",
    "sharedTitleAccent": "shared by all",
    "ctaTitle": "Ready to transform your prospecting?",
    "ctaSubtitle": "Try Thiia for free and see how AI can accelerate your business development.",
    "ctaButton": "Start free",
    "sharedFeatures": [
      "Sovereign French AI (Mistral AI)",
      "Installable app (PWA) with offline mode",
      "Built-in Gmail & Outlook email client",
      "Collaborative chat with real-time annotations",
      "AI document library per prospect",
      "Cloud imports (Google Drive, OneDrive, Dropbox)",
      "Data hosted in France, GDPR compliant",
      "Multi-organization support"
    ],
    "personas": {
      "entrepreneur": {
        "title": "Entrepreneur",
        "subtitle": "Startups, SMEs, executives",
        "description": "You're launching or scaling your business and juggle prospecting, contact management and content creation — with no dedicated marketing team.",
        "challenges": [
          "Quickly identify and qualify B2B prospects",
          "Manage a sales pipeline without a complex CRM",
          "Create professional content regularly",
          "Automate follow-ups and sales tracking"
        ],
        "useCases": [
          {
            "title": "Automated market intelligence",
            "description": "Schedule daily monitoring of your market. Thiia alerts you automatically when a company matches your target (fundraising, hiring, new project)."
          },
          {
            "title": "Smart email prospecting",
            "description": "Analyze your Gmail/Outlook emails to automatically detect commercial opportunities hidden in your existing exchanges."
          },
          {
            "title": "Visual sales pipeline",
            "description": "Track every prospect in an intuitive Kanban: from first contact to signature. Notes, reminders and automatic follow-up sequences."
          },
          {
            "title": "One-click marketing content",
            "description": "Generate LinkedIn posts, newsletters and blog articles tailored to your audience with AI, with direct publishing."
          },
          {
            "title": "Centralized document library",
            "description": "Store quotes, contracts and invoices per client. Import from Google Drive, OneDrive or Dropbox. Find any clause via semantic chat search."
          }
        ],
        "testimonialQuote": "In 3 months, I identified 200 qualified prospects and signed 15 new clients. Thiia does the work of an entire sales team.",
        "testimonialName": "Marc T.",
        "testimonialRole": "Founder, B2B SaaS startup"
      },
      "coach": {
        "title": "Coach & Trainer",
        "subtitle": "Coaching, training, consulting",
        "description": "You support professionals or teams and need to fill your sessions, manage your clients and communicate effectively.",
        "challenges": [
          "Find new clients/learners",
          "Manage workshop and webinar registrations",
          "Personalize follow-up for each client",
          "Maintain a regular online presence"
        ],
        "useCases": [
          {
            "title": "Event and registration management",
            "description": "Create your workshops, webinars and trainings. QR code registration, automatic D-1 and H-1 reminders, and participant tracking."
          },
          {
            "title": "Personalized client follow-up",
            "description": "Complete prospect file with notes, session recordings (Zoom/Teams), transcriptions and email history."
          },
          {
            "title": "Wellbeing and burnout prevention",
            "description": "Daily check-in to monitor your energy. Thiia analyzes your trends and recommends when to slow down — essential for solopreneurs."
          },
          {
            "title": "Specialized writing assistant",
            "description": "Thiia learns your tone, niche and audience. It writes emails, proposals and content perfectly aligned with your style."
          },
          {
            "title": "Collaborative annotations on analyses",
            "description": "Highlight key passages of AI analyses, add comments and discuss with co-coaches or supervisees right inside the conversation."
          }
        ],
        "testimonialQuote": "I doubled my workshop signups thanks to event management and automatic follow-ups. Tracking each client became simple.",
        "testimonialName": "Sophie M.",
        "testimonialRole": "Leadership coach"
      },
      "independant": {
        "title": "Freelancer & Independent",
        "subtitle": "Consultants, freelancers, experts",
        "description": "You're an expert in your field but prospecting isn't your job. You're looking for a simple tool to grow your business without spending all day on it.",
        "challenges": [
          "Prospect without spending too much time",
          "Organize your contacts and forget nothing",
          "Stay visible on professional networks",
          "Manage your activity while preserving balance"
        ],
        "useCases": [
          {
            "title": "Natural-language prospect search",
            "description": "Ask Thiia: \"Find me HR directors in the pharmaceutical industry in Île-de-France\". The AI understands context and delivers qualified results."
          },
          {
            "title": "Automatic email analysis",
            "description": "Connect your inbox. Thiia automatically identifies contacts with commercial potential in your exchanges and adds them to your CRM."
          },
          {
            "title": "Smart tasks and checklists",
            "description": "Create task lists tied to your prospects. Automatic reminders and progress tracking so you never let a deal slip."
          },
          {
            "title": "AI reports and analyses",
            "description": "Generate detailed reports on your prospects: online activity, latest publications, buying signals — all in one click."
          },
          {
            "title": "All your documents at chat's reach",
            "description": "Connect Drive, OneDrive or Dropbox. Your contracts and briefs are indexed automatically: Thiia finds the right clause in seconds."
          }
        ],
        "testimonialQuote": "Finally an all-in-one tool that understands freelancers' needs. I automated 80% of my prospecting and I focus on my missions.",
        "testimonialName": "Thomas D.",
        "testimonialRole": "Independent IT consultant"
      }
    }
  },
  "contactPage": {
    "badge": "Contact",
    "heroTitle": "Let's talk about your",
    "heroTitleAccent": "project",
    "heroSubtitle": "A question, a demo request or a partnership? Our team replies within 24h.",
    "infoTitle": "Our contact details",
    "infoSubtitle": "Don't hesitate to reach out for any question about Thiia, our offers or personalized support.",
    "labelEmail": "Email",
    "labelCompany": "Company",
    "labelAddress": "Address",
    "addressValue": "France 🇫🇷",
    "fieldName": "Full name *",
    "fieldNamePlaceholder": "Your name",
    "fieldEmail": "Email *",
    "fieldEmailPlaceholder": "your@email.com",
    "fieldSubject": "Subject *",
    "fieldSubjectPlaceholder": "Subject of your message",
    "fieldMessage": "Message *",
    "fieldMessagePlaceholder": "Describe your request...",
    "send": "Send message",
    "sending": "Sending...",
    "successTitle": "Message sent!",
    "successDescription": "Thank you for your message. We'll reply as soon as possible.",
    "successAction": "Send another message",
    "fillAllFields": "Please fill in all fields.",
    "sentToast": "Message sent successfully!",
    "sendError": "Sending failed. Try again or contact us directly by email."
  },
  "dashboardInsights": {
    "gmailTitle": "Gmail Insights",
    "outlookTitle": "Outlook Insights",
    "analyzeButton": "Analyze my emails",
    "privacyNotice": "Confidential analysis – your data is not used for AI training",
    "emptyGmail": "Click \"Analyze my emails\" to get an AI summary of your recent exchanges and suggested actions.",
    "emptyOutlook": "Click \"Analyze my emails\" to get an AI summary of your recent Outlook exchanges and suggested actions.",
    "emailsAnalyzed": "📧 {{count}} emails analyzed (last 7 days)",
    "highlights": "Key points",
    "suggestedActions": "Suggested actions",
    "starting": "Starting...",
    "sessionExpired": "Session expired",
    "serverError": "Server error",
    "streamUnavailable": "Stream unavailable",
    "errorTitle": "Error",
    "cancelTitle": "Analysis cancelled",
    "cancelDescription": "Email analysis has been interrupted.",
    "tokenExpiredTitle": "Token expired",
    "tokenExpiredDescription": "Please reconnect Outlook in Settings.",
    "priorityLabel": {
      "high": "Urgent",
      "medium": "Important",
      "low": "Tip"
    }
  },
  "wellbeing": {
    "title": "Well-being",
    "subtitle": "Track your balance and prevent burnout",
    "loadScore": "Load score",
    "stats": "Statistics",
    "checkins": "Check-ins",
    "avgMood": "Avg mood /5",
    "moods": {
      "great": "Great",
      "good": "Good",
      "neutral": "Neutral",
      "stressed": "Stressed",
      "burned_out": "Burned out"
    },
    "levels": {
      "green": "Moderate load",
      "orange": "High load",
      "red": "Overload detected"
    },
    "personalTips": "Personal tips",
    "moodEvolution": "Mood evolution — last 30 days",
    "checkinsHistory": "Check-ins history",
    "noCheckins": "No check-in yet. Head over to the Chat to record your first mood! 💜",
    "antiburnoutResources": "Anti-burnout resources",
    "noneMood": "None",
    "historyDateFormat": "EEEE, MMMM d, yyyy 'at' HH:mm",
    "checkin": {
      "promptUrgent": "💜 It's been a while! How are you really doing?",
      "promptDaily": "💜 How are you today?",
      "notePlaceholder": "A word about your day? (optional)"
    },
    "widget": {
      "title": "Well-being",
      "loadLevel": "Load level",
      "recentMood": "Recent mood",
      "factors": "Detected factors",
      "tips": "💡 Tips"
    },
    "factors": {
      "eventsHigh": "{{count}} events this week (high)",
      "events": "{{count}} events this week",
      "prospectsVeryHigh": "{{count}} active prospects (very high)",
      "prospects": "{{count}} active prospects",
      "lateMessagesHigh": "{{count}} messages sent after 9pm this week",
      "lateMessages": "{{count}} messages sent after 9pm",
      "burnedOut": "You said you feel burned out",
      "stressed": "You said you feel stressed",
      "moodDeclining": "Your mood has been declining recently"
    },
    "tipsList": {
      "eventsHigh": "You have many meetings this week. Block time to rest.",
      "events": "Busy week! Keep slots free to breathe.",
      "prospectsVeryHigh": "Many prospects in motion. Prioritize the most promising ones to stay focused.",
      "lateMessagesHigh": "You often work late. Try disconnecting earlier for better rest.",
      "burnedOut": "Your well-being comes first. Take a real break today.",
      "stressed": "Take a few minutes for breathing or a walk to reduce stress.",
      "moodDeclining": "Your morale seems lower. Talk to a friend or step back from your goals.",
      "default": "All seems well! Keep taking care of yourself. 🌟"
    },
    "notifications": {
      "redTitle": "⚠️ Critical load score",
      "orangeTitle": "🟠 Load rising",
      "redBody": "Your load score is at {{score}}%. {{tip}}",
      "orangeBody": "Your load score reached {{score}}%. Slow down before it gets worse.",
      "defaultTip": "Take care of yourself."
    },
    "resources": {
      "pomodoro": {
        "title": "Pomodoro technique",
        "description": "Work for 25 minutes, then take a 5-minute break. After 4 cycles, take 15-30 minutes off.",
        "category": "Productivity",
        "actionLabel": "Plan with Thiia",
        "chatPrompt": "Help me organize my day with the Pomodoro technique. Suggest a schedule that fits my tasks."
      },
      "disconnect": {
        "title": "Digital disconnect",
        "description": "Set screen-free hours. Turn off notifications after 8pm to protect your mental recovery.",
        "category": "Disconnect"
      },
      "mindfulness": {
        "title": "Mindfulness",
        "description": "5 minutes of meditation or deep breathing per day significantly reduces stress and anxiety.",
        "category": "Mental",
        "actionLabel": "Guided exercise by Thiia",
        "chatPrompt": "Guide me through a 5-minute breathing or mindfulness exercise to reduce my stress."
      },
      "aiAnxiety": {
        "title": "AI-related anxiety",
        "description": "AI is a tool, not a replacement. Focus on what you do best: empathy, creativity, human relationships.",
        "category": "AI & Well-being",
        "actionLabel": "Talk about it with Thiia",
        "chatPrompt": "I sometimes feel anxious about AI. Help me understand how to use it well without feeling threatened."
      },
      "overtime": {
        "title": "Limit overtime",
        "description": "Set an end-of-day time and stick to it. Chronic overload leads to burnout within weeks.",
        "category": "Boundaries"
      },
      "talk": {
        "title": "Talk to someone",
        "description": "Share your struggles with a loved one, peer, or professional. Isolation amplifies stress.",
        "category": "Support"
      },
      "prioritize": {
        "title": "Prioritize rather than pile up",
        "description": "Identify your top 3 priorities each morning. Delegate or postpone the rest. Better to make progress on a few than stagnate on everything.",
        "category": "Organization",
        "actionLabel": "Prioritize with Thiia",
        "chatPrompt": "Help me identify my top 3 priorities for the day and organize the rest of my tasks."
      },
      "journaling": {
        "title": "Journaling",
        "description": "Write down 3 positive things from your day every evening. This practice improves well-being and resilience.",
        "category": "Habits",
        "actionLabel": "Journaling with Thiia",
        "chatPrompt": "Help me with my journaling exercise: I want to write 3 positive things from my day and reflect on what I learned."
      }
    }
  },
  "scheduledEmails": {
    "title": "Scheduled emails",
    "filterAll": "All",
    "filterPending": "Scheduled",
    "filterSent": "Sent",
    "filterFailed": "Failed",
    "status": {
      "pending": "Scheduled",
      "sent": "Sent",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "emailCancelled": "Email cancelled",
    "emailDeleted": "Email deleted",
    "emailUpdated": "Email updated",
    "dateFutureError": "The date must be in the future",
    "dateUpdated": "Email date updated",
    "emptyTitle": "No {{label}} emails",
    "emptyHelp": "Schedule an email from a prospect's page to see it here.",
    "noSubject": "No subject",
    "step": "Step {{n}}",
    "deletedProspect": "Deleted prospect",
    "scheduledFor": "Scheduled for ",
    "sentOn": "Sent on ",
    "plannedFor": "Planned for ",
    "rescheduleTitle": "Reschedule sending",
    "datePlaceholder": "Date",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "preview": "Preview",
    "reschedule": "Reschedule",
    "cancelSending": "Cancel sending",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete this email?",
    "deleteConfirmDesc": "This action is irreversible. The email will be permanently removed from history.",
    "editTitle": "Edit email",
    "previewTitle": "Email preview",
    "recipient": "Recipient",
    "company": "Company",
    "statusLabel": "Status",
    "date": "Date",
    "subject": "Subject",
    "subjectPlaceholder": "Email subject",
    "body": "Message body",
    "bodyPlaceholder": "Email content...",
    "noContent": "No content",
    "save": "Save",
    "edit": "Edit",
    "actionsFor": "Actions for {{name}}",
    "colActions": "Actions",
    "colDate": "Send date",
    "colProspect": "Recipient",
    "colSource": "Source",
    "colSubject": "Subject",
    "collapse": "Collapse",
    "collapseAll": "Collapse all",
    "collapseAllHint": "Collapse all groups",
    "details": "Details",
    "expand": "Expand",
    "expandAll": "Expand all",
    "expandAllHint": "Expand all groups",
    "groupBulkSend": "Bulk send",
    "groupInnerSortChrono": "Chronological",
    "groupInnerSortHint": "Sort emails within the group",
    "groupInnerSortRecent": "Most recent first",
    "groupRecipients": "Recipients",
    "groupSortHint": "Sort groups",
    "openMenu": "Open menu",
    "openMenuFor": "Open menu for {{name}}",
    "openProspectHistory": "View prospect history",
    "sortActiveLabel": "Active sort",
    "sortByDate": "By date",
    "sortByDateHelp": "Sort by send date.",
    "sortGroupsFirst": "Groups first",
    "sortGroupsFirstHelp": "Show bulk sends first.",
    "sortGroupsRecent": "Recent groups",
    "sortGroupsRecentHelp": "Sort groups from most recent to oldest.",
    "sortHelpLabel": "Sort help",
    "sortHelpTitle": "Sort options",
    "sortReset": "Reset sort",
    "sortResetHint": "Return to default sort.",
    "sourceImmediate": "Immediate",
    "sourceImmediateHint": "Email sent without delay.",
    "sourceScheduled": "Scheduled",
    "sourceScheduledHint": "Email scheduled for later sending."
  },
  "linkedinHistory": {
    "title": "LinkedIn history"
  },
  "contactsPage": {
    "title": "Contact book",
    "countOne": "{{count}} email contact",
    "countOther": "{{count}} email contacts",
    "addButton": "Add",
    "newContact": "New contact",
    "emailLabel": "Email *",
    "nameLabel": "Name",
    "namePlaceholder": "John Doe",
    "adding": "Adding…",
    "contactExists": "This contact already exists",
    "contactAdded": "Contact added ✓",
    "instructionsTitle": "Email analysis instructions",
    "instructionsSaved": "Instructions saved ✓",
    "serverError": "Server error",
    "analyzeError": "Analysis error",
    "notAuthenticated": "Not authenticated",
    "starting": "Starting...",
    "errorGeneric": "Error",
    "rejectTitle": "Reject this contact",
    "rejectQuestion": "Why do you reject {{name}}?",
    "rejectPlaceholder": "Ex: It's a supplier, not a prospect. / Internal contact at my company. / Unsolicited cold outreach...",
    "rejectHelp": "This reason will be saved to improve future analyses.",
    "cancel": "Cancel",
    "reject": "Reject",
    "rejectedToast": "Contact rejected",
    "rejectedToastDesc": "The reason will be considered for future analyses.",
    "rejectedTag": "Rejected",
    "alreadyProspect": "Already a prospect",
    "detectTitle": "Detect prospects from your emails",
    "detectSubtitle": "Analyze your recent emails to identify contacts who aren't customers yet",
    "viewRules": "View rules",
    "mobileTitle": "Detected contacts",
    "mobileSubtitle": "From your emails · {{count}} profiles",
    "whyLabel": "Why",
    "importOptions": "Import options",
    "filterToSort": "To sort",
    "filterAlreadyProspects": "Already prospects",
    "filterDismissed": "Dismissed",
    "dismiss": "Dismiss",
    "privacyNote": "Confidential analysis – your data is not used for AI training",
    "customInstructions": "Custom instructions for the AI",
    "instructionsPlaceholder": "Ex: Treat as prospect anyone mentioning a budget over $5000 or requesting an audit. Ignore @mycompany.com contacts as they're colleagues...",
    "instructionsHelp": "These instructions guide the AI in detecting your prospects",
    "save": "Save",
    "analyzeGmail": "Analyze Gmail",
    "analyzeOutlook": "Analyze Outlook",
    "connectMailbox": "Connect Gmail or Outlook",
    "contactsIdentifiedOne": "{{count}} contact identified!",
    "contactsIdentifiedOther": "{{count}} contacts identified!",
    "noNewProspect": "No new prospect detected",
    "emailsAnalyzed": "{{count}} emails analyzed",
    "newCount": "{{count}} new",
    "alreadyCount": "{{count}} already existing",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "import": "Import",
    "importError": "Import error",
    "prospectImported": "Prospect imported ✓",
    "prospectsImported": "{{count}} prospect(s) imported ✓",
    "type": "Type:",
    "typeProspect": "Prospect",
    "typeClient": "Client",
    "typePartner": "Partner",
    "typeOther": "Other…",
    "typeCustomPlaceholder": "Specify…",
    "tags": "Tags:",
    "tagsPlaceholder": "gmail-import, to follow up",
    "searchContact": "Search a contact…",
    "filterAll": "All",
    "filterNew": "New",
    "filterExisting": "Existing",
    "filterRejected": "Rejected",
    "sortEmailsDesc": "Emails ↓",
    "sortEmailsAsc": "Emails ↑",
    "sortNameAsc": "Name A-Z",
    "sortNameDesc": "Name Z-A",
    "noProspectDetected": "No potential prospect detected in your recent emails.",
    "noResults": "No results for these filters.",
    "tableName": "Name",
    "tableEmail": "Email",
    "tableReason": "AI reason",
    "tableEmails": "Emails",
    "tableActions": "Actions",
    "viewInMailbox": "View in mailbox",
    "previous": "Previous",
    "next": "Next",
    "paginationOf": "{{from}}-{{to}} of {{total}}",
    "listSearchPlaceholder": "Search a name or email…",
    "listEmpty": "No contacts yet.",
    "listNoResults": "No contact matches your search.",
    "listResults": "{{count}} result(s)",
    "deleteTitle": "Delete this contact?",
    "deleteDesc": "{{email}} will be removed from your contact book.",
    "delete": "Delete",
    "accountsLabel": "Analyze an account",
    "detectSectionTitle": "Detect contacts from my emails",
    "sourceHint": "These contacts are detected automatically from your emails.",
    "analyzeCta": "Analyze my emails",
    "criteriaCta": "Criteria"
  },
  "tour": {
    "buttons": {
      "back": "Back",
      "close": "Close",
      "last": "Finish",
      "next": "Next",
      "skip": "Skip"
    },
    "welcome": {
      "title": "Welcome to Thiia 👋",
      "description": "Discover the key features of your AI prospecting agent in a few quick steps."
    },
    "chatCta": {
      "title": "The Thiia Chat",
      "description": "Your main entry point: ask questions, run searches, or have Thiia act on your behalf."
    },
    "history": {
      "title": "Conversation history",
      "description": "Find all your conversations, organize them in folders and search inside them."
    },
    "annotations": {
      "title": "Annotations",
      "description": "Select text in any message to add contextual notes for your AI."
    },
    "prospectSearch": {
      "title": "Prospect search",
      "description": "Just ask: \"Find me 10 SME tech executives in Lyon\" — Thiia handles the rest."
    },
    "prospects": {
      "title": "Prospect Base",
      "description": "Your built-in CRM: Kanban pipeline, detailed profiles and AI-enriched notes."
    },
    "searchHub": {
      "title": "Search & Watch",
      "description": "Real-time semantic search for people, companies and events."
    },
    "emails": {
      "title": "Emails",
      "description": "Read, reply and generate AI emails from Gmail or Outlook directly inside Thiia."
    },
    "settingsGeneral": {
      "title": "General settings",
      "description": "Profile, organization, language and account customization."
    },
    "settingsIntegrations": {
      "title": "Integrations",
      "description": "Connect Gmail, Outlook, LinkedIn, HubSpot, Zoom and more.",
      "mailbox": "Mailbox & calendar (Gmail or Outlook)",
      "linkedin": "LinkedIn (post publishing)",
      "connected": "Connected",
      "notConnected": "Not connected",
      "connectHint": "You can connect your services right now from the cards next to this panel, then continue the tour.",
      "allConnectedHint": "Everything is connected 🎉 You can continue the tour."
    },
    "finish": {
      "title": "Ready to prospect with Thiia 🚀",
      "description": "You're all set! Start your first conversation to put Thiia to work.",
      "secondary": "View documentation"
    }
  },
  "settings": {
    "title": "Settings",
    "signOut": "Sign out",
    "privacy": {
      "legalDocs": "Legal documents",
      "legal": "Legal notice",
      "privacyPolicy": "Privacy policy",
      "terms": "Terms of use",
      "portabilityTitle": "Right to data portability",
      "portabilityDesc": "In accordance with Article 20 of the GDPR, you can export all your personal data in a structured and readable format (JSON). This export includes your profile, prospects, notes, emails, events, content and conversations.",
      "exportAll": "Export all my data",
      "exportDone": "Export complete",
      "exportDoneDesc": "Your data has been downloaded as JSON.",
      "aiPrivacyTitle": "AI privacy",
      "aiPrivacyDesc": "Your data is <strong>never used to train artificial intelligence models</strong>. Thiia uses Mistral AI, a sovereign French engine. Data sent to the AI is processed ephemerally and is neither stored nor reused by the model provider.",
      "deleteTitle": "Right to erasure",
      "deleteDesc": "In accordance with Article 17 of the GDPR, you may request the deletion of all your personal data. This action is <strong>irreversible</strong>: your profile, prospects, notes, emails, events, content and conversations will be permanently deleted.",
      "deleteAccount": "Delete my account and data",
      "deleteConfirmTitle": "Permanently delete your account?",
      "deleteConfirmDesc1": "This action is <strong>irreversible</strong>. All your data will be deleted: profile, prospects, notes, emails, events, content and conversations.",
      "deleteConfirmDesc2": "We recommend <strong>exporting your data</strong> before proceeding.",
      "typeToConfirm": "Type <strong>DELETE</strong> to confirm:",
      "deletePlaceholder": "DELETE",
      "deletePermanently": "Delete permanently",
      "accountDeleted": "Account deleted",
      "accountDeletedDesc": "All your data has been erased. You will be signed out.",
      "securityCenter": "Security center",
      "subprocessors": "Sub-processors",
      "portabilityShort": "Export all your personal data in JSON format.",
      "portabilityMore": "Learn more",
      "noticeTitle": "GDPR notice (first contact)",
      "noticeShort": "Notice added at the bottom of your first-contact emails.",
      "noticeSubject": "Your offer / subject",
      "noticeContact": "GDPR contact email",
      "noticePreview": "Preview of the inserted notice",
      "dataTitle": "Your data",
      "exportRowDesc": "Prospects, emails, meeting notes, documents and rules, as JSON (around {{size}}). If preparation takes over a minute, the file is emailed to you.",
      "prepareExport": "Prepare export",
      "exportProgress": "Preparing your export… {{percent}}%",
      "trainingTitle": "Model training",
      "trainingBadge": "Off by default",
      "trainingDesc": "Your data is never used to train models.",
      "recordingRetention": "Recording retention",
      "recordingRetentionDesc": "Meeting audio is deleted after transcription.",
      "recording0": "Deleted after transcription",
      "recording7": "Kept for 7 days",
      "recording30": "Kept for 30 days",
      "recording90": "Kept for 90 days",
      "deleteRowDesc": "Deleting removes your account, its data and your access to the app. It runs server-side in a single transaction: it either fully completes or is rolled back. It cannot be undone."
    },
    "video": {
      "title": "Default video conferencing",
      "description": "Choose the default video conferencing provider for your meetings. You can always change it case by case.",
      "defaultProvider": "Default provider",
      "none": "None",
      "updated": "Video preference updated",
      "defaultProviderHint": "Used when Thiia creates a meeting from a prospect"
    },
    "organizations": {
      "title": "Mes organisations",
      "countOther": "{{count}} organizations",
      "intro": "Ajoutez vos entreprises et associations. L’organisation par défaut est utilisée dans les exports PDF et les emails.",
      "empty": "No organization added",
      "default": "Par défaut",
      "setDefault": "Définir par défaut",
      "addCompany": "Add a company or association",
      "deleteTitle": "Delete this organization?",
      "deleteDesc": "The organization \"{{name}}\" will be deleted. Associated email accounts will not be deleted.",
      "countOne_one": "{{count}} organisation",
      "countOne_other": "{{count}} organisations",
      "countOne": "{{count}} organisations"
    },
    "integrations": {
      "accountsOther": "{{count}} accounts",
      "default": "Par défaut",
      "setDefault": "Définir par défaut",
      "organization": "Organisation",
      "noOrganization": "Aucune organisation",
      "addAccount": "Ajouter un compte",
      "syncCalendars": "Synchroniser les agendas",
      "readOnly": "Accès sécurisé — Thiia peut lire et envoyer des emails, mais ne modifie ni ne supprime rien dans votre boîte.",
      "connect": "Connect {{provider}}",
      "disconnected": "Disconnected",
      "disconnectedDesc": "Account {{email}} disconnected.",
      "defaultUpdated": "Default account updated",
      "connected": "{{provider}} connected ✓",
      "connectedDesc": "Account {{email}} added.",
      "connectError": "{{provider}} connection error",
      "notConfigured": "{{provider}} OAuth not configured.",
      "tokenError": "Could not exchange token",
      "calendarSynced": "Calendar synced ✓",
      "calendarSyncedDesc": "{{count}} event(s) imported.",
      "analysisDone": "Analysis complete ✓",
      "importPartial": "Partial import ⚠️",
      "importError": "Import error",
      "analysisError": "Analysis error",
      "emailsAnalyzed": "{{count}} emails analyzed",
      "prospectsCreated": "{{count}} prospect(s) created",
      "duplicatesSkipped": "{{count}} duplicate(s) skipped",
      "failures": "{{count}} failure(s)",
      "noNewProspects": "no new prospect detected",
      "outlookReadOnly": "Accès sécurisé — Thiia lit vos emails et votre agenda Microsoft, sans rien modifier ni supprimer.",
      "fetchRecordings": "Fetch Teams recordings",
      "recordingsFetched": "Recordings fetched ✓",
      "recordingsFetchedDesc": "{{count}} recording(s) saved.",
      "linkedin": {
        "name": "LinkedIn",
        "description": "Connect your LinkedIn account to publish posts directly.",
        "subtitle": "LinkedIn",
        "explanation": "Connect your LinkedIn account to share posts and import contacts.",
        "connect": "Connect LinkedIn",
        "connected": "LinkedIn account connected",
        "connectedDesc": "Your posts can be published automatically.",
        "apiConnected": "API connected",
        "apiSection": "API connection",
        "connectedAs": "Connected as {{name}}",
        "connectedNoName": "Connected",
        "defaultUser": "User",
        "connectError": "Could not start LinkedIn connection.",
        "notConfigured": "Not configured",
        "notConfiguredDesc": "Add your LinkedIn URLs to enable sharing.",
        "startError": "Error starting connection.",
        "disconnected": "LinkedIn account disconnected",
        "disconnect": "Disconnect",
        "saved": "LinkedIn URLs saved.",
        "linkRemoved": "Link removed.",
        "personalProfile": "Personal profile",
        "companyPage": "Company page",
        "saveUrls": "Save URLs",
        "successMessage": "LinkedIn connected successfully.",
        "orgsFetchWarning": "Company pages unavailable",
        "orgsFetchWarningDesc": "The connection succeeded, but your company pages could not be retrieved. Please try again later.",
        "history": "History",
        "dialogTitle": "Manage LinkedIn",
        "scopeNote": "Publishing and reading"
      },
      "zoom": {
        "name": "Zoom",
        "description": "Connect your Zoom account to retrieve your meeting recordings and transcripts.",
        "connected": "Zoom account connected",
        "connectedDesc": "Your meetings can be created automatically.",
        "disconnectedDesc": "Connect Zoom to create meetings.",
        "recordingsTitle": "Recordings",
        "recordingsDesc": "Access your Zoom recordings here.",
        "readOnly": "Read-only",
        "dialogTitle": "Manage Zoom",
        "disconnect": "Disconnect"
      },
      "hubspot": {
        "description": "Sync contacts, deals, tasks and activities between HubSpot and Thiia.",
        "account": "Account",
        "contacts": "Contacts",
        "deals": "Deals",
        "tasks": "Tasks",
        "autoSyncSection": "Auto sync",
        "dailySync": "Daily sync",
        "importDeals": "Import deals",
        "importTasks": "Import tasks",
        "pushActivities": "Push notes & emails",
        "lastSync": "Last sync: {{date}}",
        "lastSyncFormat": "MMM d, yyyy 'at' HH:mm",
        "permissionsNote": "Read/write contacts, read deals & tasks, push activities to the timeline.",
        "syncContacts": "Sync contacts",
        "syncContactsDone": "Contacts synced",
        "syncContactsDoneDesc": "{{imported}} imported · {{updated}} updated · {{exported}} exported",
        "syncExtras": "Sync deals & tasks",
        "syncExtrasDone": "Deals & tasks synced",
        "syncExtrasDoneDesc": "{{deals}} deals · {{tasks}} tasks",
        "connected": "HubSpot connected ✓",
        "connectError": "HubSpot error",
        "notConfigured": "HubSpot OAuth not configured.",
        "name": "HubSpot",
        "scopeNote": "Thiia never deletes anything"
      },
      "searchPlaceholder": "Search for an integration...",
      "noResults": "No integration matches your search.",
      "resetFilters": "Reset filters",
      "categories": {
        "all": "All",
        "emailCalendar": "E-mail et agenda",
        "video": "Video conferencing",
        "social": "Social networks",
        "storage": "Storage",
        "documents": "Document editors",
        "crm": "CRM",
        "import": "Data import",
        "voice": "Commandes vocales",
        "finance": "Banking & accounting"
      },
      "gmail": {
        "name": "Gmail",
        "description": "Read, send emails and sync your Google calendar from Thiia."
      },
      "office365": {
        "name": "Outlook / Office 365",
        "description": "Read your emails and sync your Microsoft calendar and meetings."
      },
      "imap": {
        "name": "IMAP/SMTP email",
        "description": "Connect a custom mailbox via IMAP and SMTP."
      },
      "googleMeet": {
        "name": "Google Meet",
        "description": "Generate Google Meet links for your appointments."
      },
      "defaultVideo": {
        "name": "Default video provider",
        "description": "Choose your default video conferencing tool."
      },
      "instagram": {
        "description": "Publish and schedule Instagram posts directly from Thiia."
      },
      "facebook": {
        "description": "Connect your Facebook page to publish and analyze your audience."
      },
      "googleDrive": {
        "name": "Google Drive",
        "description": "Import documents from Google Drive to enrich your prospects.",
        "scopeNote": "Read-only",
        "orgUpdated": "Organization updated",
        "explanation": "Google Drive is available through your connected Google accounts. Link each account to an organization to keep documents separate.",
        "noOrgsHint": "Create organizations to link each Google account to a distinct entity.",
        "connectViaEmail": "Connect your Google account in the Email & Calendar section to enable Google Drive automatically."
      },
      "onedrive": {
        "description": "Connect OneDrive to sync your Microsoft professional files."
      },
      "dropbox": {
        "description": "Import documents stored on Dropbox into Thiia."
      },
      "googleDocs": {
        "description": "Open exported documents directly in Google Docs to edit them online."
      },
      "documents": {
        "hint": "Once connected, your Word/PDF exports from chat can open directly in the online editor."
      },
      "microsoftWord": {
        "name": "Microsoft Word Online",
        "description": "Your Word exports from chat can be dropped into OneDrive and opened in Word Online.",
        "scopeNote": "Read/write files",
        "connectError": "Word Online connection error",
        "exchangeError": "Could not exchange the OAuth code.",
        "connected": "Word Online connected",
        "notConfigured": "Azure is not configured.",
        "accountDisconnected": "Account disconnected",
        "reconnect": "Reconnect / add an account",
        "connectCta": "Connect Word Online"
      },
      "gamma": {
        "name": "Gamma.app",
        "description": "Automatically generate presentations, documents or visual posts from your exports.",
        "scopeNote": "Requires a Gamma Pro plan",
        "apiKeyRequired": "API key required",
        "saved": "Gamma.app saved",
        "enterKeyToTest": "Enter an API key to test",
        "keyValid": "API key valid ✓",
        "keyInvalid": "Invalid API key",
        "checkKeyOnSite": "Check your key on gamma.app",
        "disconnected": "Gamma.app disconnected",
        "apiKey": "API key",
        "keepCurrentKey": "Leave empty to keep the current key",
        "hide": "Hide",
        "show": "Show",
        "test": "Test",
        "getKeyLink": "Get a key on gamma.app",
        "defaultFormat": "Default format",
        "formatPresentation": "Presentation",
        "formatDocument": "Document",
        "formatSocial": "Social post",
        "defaultTheme": "Default theme",
        "optional": "(optional)",
        "myTemplates": "My templates",
        "oneNamePerLine": "(one name per line)",
        "templatesPlaceholder": "e.g.:\nOasis\nAtmosphere\nMy corporate template",
        "templatesHint": "These names will appear in the theme selector when exporting to Gamma.",
        "update": "Update",
        "saveCta": "Save"
      },
      "chatgptImport": {
        "description": "Import prospects from a ChatGPT conversation."
      },
      "voice": {
        "name": "Voice commands",
        "description": "Create voice tokens and control Thiia by voice."
      },
      "connectedShort": "Connected",
      "notConnected": "Not connected",
      "dateRange": {
        "14_days": "Last 14 days",
        "this_month": "This month",
        "3_months": "Last 3 months",
        "6_months": "Last 6 months",
        "this_year": "This year",
        "last_year": "Last year",
        "2_years": "Last 2 years"
      },
      "whatsapp": {
        "description": "Connect your own WhatsApp Business number to send messages automatically.",
        "name": "WhatsApp Cloud API",
        "dialogTitle": "Manage WhatsApp Cloud API",
        "scopeNote": "Custom number",
        "savedToast": "WhatsApp configuration saved",
        "genericError": "Error",
        "phoneNumberId": "Phone Number ID",
        "accessToken": "Access Token (permanent System User)",
        "configured": "Configured",
        "businessAccountId": "Business Account ID (WABA) — optional",
        "webhookVerifyToken": "Webhook Verify Token — optional",
        "activeLabel": "Active",
        "activeDesc": "Allow sending via this configuration",
        "credentialsNote": "Your credentials are encrypted and visible only to you (RLS).",
        "save": "Update",
        "saveNew": "Save",
        "test": "Test connection",
        "testOk": "Meta connection validated",
        "testFail": "Validation failed",
        "helpText": "Get these credentials from Meta for Developers → your app → WhatsApp → API Setup.",
        "helpLink": "Meta for Developers",
        "requiredError": "Phone Number ID and Access Token are required for the initial setup.",
        "phoneLabel": "Number",
        "verifiedNameLabel": "Verified name",
        "qualityLabel": "Quality",
        "latencyLabel": "Latency"
      },
      "accountsOne_one": "{{count}} compte",
      "accountsOne_other": "{{count}} comptes",
      "disconnect": "Déconnecter",
      "accountsOne": "{{count}} comptes",
      "status": {
        "summary": "{{connected}} integrations connected, {{toReconnect}} to reconnect",
        "expiredOn": "{{name}}: token expired on {{date}}",
        "expired": "{{name}}: token expired",
        "reconnect": "Reconnect"
      },
      "soon": {
        "title": "Coming soon",
        "hint": "No action available yet"
      },
      "state": {
        "connected": "Connected",
        "notConnected": "Not connected",
        "soon": "Coming soon"
      },
      "actions": {
        "connect": "Connect",
        "manage": "Manage",
        "reconnect": "Reconnect"
      },
      "lastSyncShort": "Synced {{date}}",
      "readOnlyShort": "Read-only",
      "noDeleteShort": "Thiia deletes nothing",
      "moreAccounts": "+{{count}}",
      "manageAccount": "Manage account",
      "googleMeetCard": {
        "description": "Google Meet is automatically available with your connected Google account. No separate connection is required.",
        "scopeNote": "Included with Google",
        "action": "Connect Google"
      },
      "clearFilter": "Clear",
      "qonto": {
        "name": "Qonto",
        "description": "Automatically attach supplier invoices to your Qonto account transactions.",
        "scopeNote": "Read-only + attachment upload",
        "scope": "Organization",
        "globalScope": "All accounts",
        "login": "Qonto login",
        "secret": "Secret key",
        "connect": "Connect",
        "disconnect": "Disconnect",
        "connected": "Qonto connected",
        "securityNote": "Your credentials are stored server-side and are never readable from the browser.",
        "primaryMailbox": "Invoice mailbox",
        "noPrimaryMailbox": "No primary mailbox",
        "primaryMailboxHint": "Invoice search starts with this mailbox.",
        "saveMailbox": "Save mailbox",
        "mailboxSaved": "Mailbox saved"
      },
      "amazon": {
        "name": "Amazon Business",
        "description": "Automatically retrieve invoices for your Amazon Business orders.",
        "scopeNote": "Read-only orders and invoices",
        "scope": "Organization",
        "globalScope": "All accounts",
        "region": "Amazon region",
        "regions": {
          "eu": "Europe",
          "na": "North America",
          "fe": "Far East"
        },
        "clientId": "Client ID",
        "clientSecret": "Client secret",
        "refreshToken": "Refresh token",
        "test": "Test connection",
        "testOk": "Amazon credentials are valid",
        "connect": "Connect",
        "connected": "Amazon Business connected",
        "disconnect": "Disconnect",
        "alreadyConnected": "This organization is already linked to Amazon Business.",
        "reassignHint": "An Amazon connection already exists for: {{from}}. You can link it to this organization without re-entering your credentials.",
        "reassign": "Link this connection to this organization",
        "reassigned": "Amazon connection linked",
        "oauthScope": "Permissions requested from Amazon",
        "oauthScopeHint": "Leave \"profile\" if unsure. If Amazon denies order access, enter the permissions listed in your Amazon security profile.",
        "securityNote": "Your credentials are stored server-side and are never readable from the browser.",
        "authorize": "Authorize with Amazon",
        "authorizing": "Authorizing…",
        "authorizeHint": "Enter the client ID and secret, then authorize: the token is generated automatically.",
        "redirectUri": "Redirect URL to declare in Amazon",
        "copy": "Copy",
        "copied": "URL copied",
        "popupBlocked": "The Amazon window was blocked by the browser.",
        "authCancelled": "Amazon authorization cancelled.",
        "callbackDone": "Authorization complete, you can close this window."
      }
    },
    "tabs": {
      "general": "General",
      "appearance": "Appearance",
      "integrations": "Integrations",
      "autosearch": "Auto monitoring",
      "rules": "Rules & Preferences",
      "templates": "Templates",
      "linkedin": "LinkedIn",
      "subscription": "Billing",
      "quotas": "Credits & Packs",
      "privacy": "Privacy & GDPR"
    },
    "appearance": {
      "fontsTitle": "Polices",
      "fontSans": "Texte courant (sans serif)",
      "fontSansDesc": "Paragraphes, menus et boutons.",
      "fontSerif": "Titres (serif)",
      "fontSerifDesc": "Titres et accroches éditoriales.",
      "fontMono": "Code (monospace)",
      "fontMonoDesc": "Blocs de code et données techniques.",
      "scaleTitle": "Échelle typographique",
      "scaleDesc": "Redimensionne proportionnellement toute l’interface.",
      "previewLabel": "Aperçu",
      "previewHeading": "The elegance of refined typography",
      "previewBody": "Your preferences apply instantly across the whole app. Save to keep them across sessions.",
      "saveCta": "Save theme",
      "resetCta": "Reset",
      "savedTitle": "Theme saved",
      "savedDesc": "Your typography preferences were saved.",
      "resetTitle": "Theme reset",
      "resetDesc": "Defaults have been restored.",
      "errorTitle": "Error",
      "errorDesc": "Could not save your preferences right now.",
      "discardCta": "Discard changes",
      "discardedDesc": "Your changes have been discarded.",
      "discardedTitle": "Changes discarded",
      "previewBadge": "Preview",
      "previewBtnPrimary": "Primary button",
      "previewBtnSecondary": "Secondary button",
      "previewHint": "Live preview of your changes.",
      "previewInputLabel": "Sample field",
      "previewInputPlaceholder": "Type some text…",
      "unsavedDesc": "You have unsaved changes.",
      "unsavedTitle": "Unsaved changes"
    },
    "language": {
      "title": "Interface language",
      "description": "Choose the display language for the application.",
      "saved": "Language updated"
    },
    "general": {
      "languageTitle": "Preferred language",
      "languageHelp": "Choose Thiia's display language. Your choice is saved to your profile and applied automatically on all your devices — change it here anytime, no need to redo the onboarding.",
      "languageSavedTitle": "Preferred language saved",
      "languageSavedDescription": "Your preferred language is now: {{lng}}.",
      "languageSaveError": "Could not save your preferred language.",
      "languageUnavailableTitle": "Language unavailable",
      "languageUnavailableDescription": "The language \"{{requested}}\" stored in your profile is no longer available. Automatically falling back to {{fallback}}.",
      "myProfile": "My profile",
      "displayName": "Display name",
      "currentEmail": "Current email",
      "newEmailPlaceholder": "New email…",
      "change": "Change",
      "emailConfirmHelp": "A confirmation email will be sent to both addresses.",
      "changePassword": "Change password",
      "currentPassword": "Current password",
      "currentPasswordRequired": "Enter your current password",
      "currentPasswordInvalid": "Current password is incorrect",
      "currentPasswordNoEmail": "No email address found for this account",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "update": "Update",
      "passwordMin": "Minimum 6 characters",
      "businessType": "Votre activité",
      "businessPlaceholder": "E.g. Digital strategy consultant",
      "audience": "Audience cible",
      "audiencePlaceholder": "E.g. Executives in career transition",
      "tone": "Communication tone",
      "tones": {
        "professionnel": "Professional & formal",
        "chaleureux": "Warm & friendly",
        "dynamique": "Dynamic & motivating",
        "inspirant": "Inspiring & poetic"
      },
      "socialNetworks": "Réseaux sociaux connectés",
      "noneConfigured": "None configured",
      "appearance": "Email & export appearance",
      "pdfExports": "PDF & exports",
      "primaryColor": "Primary color",
      "accentColor": "Accent color",
      "pdfPrimaryHelp": "Titles, numbers, header",
      "pdfAccentHelp": "Subtitles, bullets, separators",
      "emails": "Emails",
      "emailHeaderColor": "Header color",
      "emailHeaderHelp": "Top banner of the email",
      "emailAccentHelp": "Separators, links",
      "templatePreview": "Template preview",
      "emailSignature": "Email signature",
      "signatureHelp": "Added automatically to your emails.",
      "includeUnsubscribeFooterLabel": "Unsubscribe footer",
      "includeUnsubscribeFooterHelp": "Show the GDPR text and unsubscribe link at the bottom of outreach emails.",
      "preview": "Preview",
      "profileUpdated": "Profile updated ✓",
      "logoUpdated": "Logo updated ✓",
      "logoRemoved": "Logo removed",
      "avatarUpdated": "Profile photo updated ✓",
      "avatarRemoved": "Profile photo removed",
      "uploadAvatar": "Upload photo",
      "avatarHelp": "JPG, PNG or WEBP. 2 MB max.",
      "remove": "Remove",
      "passwordUpdated": "Password updated ✓",
      "emailConfirmSent": "Confirmation email sent",
      "emailConfirmDesc": "Check your new inbox to confirm the change.",
      "passwordTooShort": "Password must contain at least 6 characters.",
      "passwordMismatch": "Passwords do not match.",
      "imageOnly": "Please select an image (PNG, JPG, SVG…)",
      "error": "Error",
      "tourCta": "Start tour",
      "tourHelp": "Rediscover the main features.",
      "tourTitle": "Guided tour",
      "noSocialNetwork": "Aucun réseau connecté",
      "connectNetwork": "Connecter un réseau",
      "restartOnboarding": "Refaire l’onboarding"
    },
    "search": {
      "placeholder": "Search a setting…",
      "empty": "No setting found.",
      "heading": "Settings",
      "items": {
        "aiPrivacy": "AI privacy",
        "appearance": "App appearance",
        "audience": "Target audience",
        "autosearch": "Watch configuration",
        "avatar": "Profile picture",
        "businessType": "Your business",
        "deleteAccount": "Delete my account",
        "displayName": "Display name",
        "email": "Account email address",
        "emailAnalysis": "Email analysis",
        "emailAppearance": "Email and PDF appearance",
        "emailSignature": "Email signature",
        "export": "GDPR data export",
        "followups": "Follow-up templates by status",
        "gdprNotice": "GDPR notice on first contact",
        "intChatgpt": "ChatGPT import",
        "intDrive": "Google Drive",
        "intDropbox": "Dropbox",
        "intGamma": "Gamma",
        "intGmail": "Gmail",
        "intHubspot": "HubSpot",
        "intImap": "IMAP / SMTP",
        "intLinkedin": "LinkedIn",
        "intMeet": "Google Meet",
        "intOffice365": "Office 365 / Outlook",
        "intOnedrive": "OneDrive",
        "intVideo": "Default video tool",
        "intVoice": "Voice commands",
        "intWhatsapp": "WhatsApp",
        "intWord": "Microsoft Word",
        "intZoom": "Zoom",
        "language": "Interface language",
        "legalDocs": "Legal documents",
        "meetingDuration": "Meeting duration",
        "needSignals": "Need signals",
        "notifAnnouncements": "Announcements digest",
        "notifBriefing": "Daily briefing time",
        "notifChecklists": "Daily task email",
        "notifMentions": "Mention emails",
        "onboarding": "Restart onboarding",
        "organizations": "Default organization",
        "password": "Password",
        "patterns": "Learned patterns",
        "quotas": "Credit packs",
        "retention": "Data retention period",
        "rules": "Agent rules",
        "socialNetworks": "Social networks",
        "subscription": "Subscription",
        "timezone": "Time zone",
        "tone": "Communication tone",
        "tour": "Welcome tour"
      }
    },
    "saveBar": {
      "pending_one": "1 field changed",
      "pending_other": "{{count}} fields changed",
      "cancel": "Cancel",
      "save": "Save"
    },
    "account": {
      "profileTitle": "Profile",
      "profileHint": "Used in emails and generated documents",
      "photo": "Photo",
      "photoDesc": "Shown in the app and on shared reports",
      "replace": "Replace",
      "businessDesc": "Thiia uses it to calibrate the tone of your messages",
      "socialLink": "Manage in Integrations",
      "securityTitle": "Account security",
      "emailLabel": "Email address",
      "edit": "Edit",
      "changeCta": "Change",
      "passwordChanged": "Changed {{count}} months ago",
      "passwordChangedRecent": "Changed this month",
      "passwordChangedUnknown": "Change date unknown",
      "sessions": "Active sessions",
      "sessionsValue": "{{count}} device",
      "view": "View",
      "sessionsTitle": "Active sessions",
      "sessionsHelp": "Only the device you are currently using can be shown.",
      "thisDevice": "This device",
      "lastSignIn": "Last sign-in",
      "prefsTitle": "Preferences",
      "language": "Interface language",
      "defaultOrg": "Default organization",
      "defaultOrgDesc": "Applied to new prospects and reports",
      "noOrg": "No organization",
      "tour": "Welcome tour",
      "redoOnboarding": "Redo onboarding",
      "restart": "Restart",
      "emailDialogTitle": "Change email address",
      "passwordDialogTitle": "Change password",
      "saved": "Preference saved",
      "saveError": "Could not save"
    },
    "ai": {
      "rules": {
        "title": "Generation rules",
        "hint": "Thiia applies these rules to everything it writes.",
        "filters": {
          "reports": "Reports",
          "emails": "Emails",
          "prospecting": "Prospecting"
        },
        "suggested": "Suggested by Thiia",
        "suggestedDesc": "Structures reports into summary, key points, decisions, actions and next steps.",
        "accept": "Enable",
        "decline": "Dismiss",
        "empty": "No rules yet.",
        "newRule": "New rule",
        "newRuleDesc": "Tell Thiia how to write, search or summarise.",
        "add": "Add"
      },
      "emailAnalysis": {
        "title": "Email analysis",
        "hint": "These instructions guide Thiia when detecting prospects in your emails.",
        "instructions": "Analysis instructions",
        "noInstructions": "No instructions yet.",
        "placeholder": "E.g. treat as a prospect anyone mentioning a budget above €5,000…",
        "auto": "Analyse automatically",
        "autoDesc": "Thiia analyses your new emails without being asked."
      },
      "patterns": {
        "title": "What the AI has learned",
        "count": "{{count}} patterns",
        "deduced": "Learned from your exchanges",
        "manual": "Added manually",
        "forget": "Forget",
        "empty": "Thiia hasn't learned anything from your exchanges yet."
      },
      "templates": {
        "title": "Templates and appearance",
        "hint": "Follow-ups by status, email signature and logo on documents."
      }
    },
    "watch": {
      "results": {
        "title": "Results",
        "hint": "Monitoring results live on their own page."
      },
      "config": {
        "title": "Configuration",
        "enabledDesc": "Thiia looks for signals about your prospects and target accounts.",
        "schedule": "Day and time",
        "scheduleDesc": "The digest lands in your results at this time.",
        "emailNotification": "Email notification",
        "lastRun": "Last run: {{date}}",
        "neverRun": "Never run from this screen."
      },
      "scope": {
        "title": "Scope",
        "prospects": "Tracked prospects",
        "all": "All prospects",
        "active": "Active only",
        "manual": "Manual selection",
        "signals": "Signal types",
        "signalsCount": "{{count}} of {{total}}"
      },
      "signals": {
        "funding": "Funding round",
        "hiring": "Hiring",
        "news": "Press coverage",
        "event": "Event",
        "job_change": "Job change",
        "publication": "Publication"
      }
    }
  },
  "billing": {
    "title": "Billing",
    "subtitle": "View your invoices and manage your payment methods.",
    "refresh": "Refresh",
    "history": "History",
    "stripePortal": "Stripe portal",
    "noInvoices": "No invoices available.",
    "invoiceNumber": "Invoice #",
    "date": "Date",
    "amount": "Amount",
    "status": "Status",
    "actions": "Actions",
    "view": "View",
    "pdf": "PDF",
    "statusPaid": "Paid",
    "statusOpen": "Pending",
    "statusDraft": "Draft",
    "statusVoid": "Void",
    "error": "Error",
    "dateLocale": "en-US",
    "subscriptionSection": "Subscription",
    "planLabel": "Current plan",
    "planAmount": "Amount",
    "nextPayment": "Next payment",
    "paymentMethod": "Payment method",
    "seatsUsed": "Seats used",
    "managePayment": "Manage payment",
    "changePlan": "Change plan",
    "noSubscription": "No active subscription.",
    "cancelAtPeriodEnd": "Cancels at period end",
    "object": "Item",
    "subscriptionInvoice": "Subscription invoice",
    "creditPurchase": "Credit purchase"
  },
  "quotasPage": {
    "credits": "Remaining credits",
    "refresh": "Refresh",
    "addToCart": "+{{count}} ({{price}} €)",
    "addToCartMinutes": "+{{count}} min ({{price}} €)",
    "cart": "Cart",
    "creditsLine": "×{{size}} = {{total}} credits",
    "creditsLineMinutes": "×{{size}} min = {{total}} min",
    "total": "Total",
    "pay": "Pay €{{amount}}",
    "buyPacks": "Buy packs",
    "popular": "Popular",
    "buy": "Buy",
    "purchaseHistory": "Purchase history",
    "noPurchases": "No credit purchases.",
    "pack": "Pack",
    "amount": "Amount",
    "date": "Date",
    "customLot": "Custom bundle",
    "purchaseConfirmed": "Purchase confirmed!",
    "creditsAdded": "Your credits have been added.",
    "error": "Error",
    "labels": {
      "note_report": "Reports",
      "chat_question": "Chat questions",
      "agentic_task": "Automated tasks",
      "audio_transcription": "Transcriptions",
      "content_post": "Posts",
      "content_newsletter": "Newsletters",
      "search": "Searches",
      "analysis": "Analyses",
      "checklist": "Checklists",
      "document_indexing": "Docs uploaded",
      "veille": "Auto watch",
      "images_generated": "Generated images"
    },
    "recharge": "Top up",
    "cartEmpty": "Your cart is empty."
  },
  "reportConfig": {
    "title": "AI Report",
    "customizeHint": "Customize the format via",
    "settingsLink": "Settings → Rules → Reports",
    "audioWarningOne": "The audio file \"{{name}}\" has no transcription yet.",
    "audioWarningMany": "{{count}} audio files have no transcription.",
    "aiModel": "AI Model",
    "language": "Report language",
    "customInstructions": "Custom instructions",
    "modified": "Modified",
    "savedPresets": "Saved presets",
    "presetDeleted": "Preset deleted",
    "presetSaved": "Preset saved",
    "instructionsPlaceholder": "Instructions for report generation…",
    "reset": "Reset",
    "presetNamePlaceholder": "Preset name…",
    "saveAsPreset": "Save as preset",
    "compareWith": "Compare with another model",
    "generating": "Generating…",
    "writing": "Writing…",
    "chooseVersion": "Choose this version",
    "cancel": "Cancel",
    "compareN": "Compare ({{n}} models)",
    "generate": "Generate",
    "back": "← Back",
    "preview": "Preview",
    "edit": "Edit",
    "landscape": "Landscape",
    "landscapeTitle": "Landscape mode (PDF)",
    "copy": "Copy",
    "copied": "Copied!",
    "pdf": "PDF",
    "pdfDownloaded": "PDF downloaded",
    "pdfError": "PDF export error",
    "word": "Word",
    "wordDownloaded": "Word downloaded",
    "wordError": "Word export error",
    "draft": "Draft",
    "finalize": "Finalize",
    "draftAutoSaved": "Draft auto-saved",
    "draftSaved": "Draft saved",
    "draftSaveError": "Save error",
    "sessionExpired": "Session expired",
    "errorPrefix": "Error",
    "generationError": "Generation error",
    "initializing": "Initializing…",
    "draftTitle": "Draft – {{date}}",
    "instructionsDefault": "Instructions:\n- Write a synthetic, structured and actionable report\n- Structure with clear sections: Context, Key points, Important elements, Action items\n- If audio transcripts are provided, analyze them in depth to extract relevant information\n- Highlight strategic insights for the business relationship\n- Identify commitments, decisions and next steps mentioned\n- Use a professional and warm tone\n- Markdown format\n- If non-audio files are attached, mention them in the context",
    "modelDescriptions": {
      "mistralMedium": "Sovereign Mistral — fast, balanced",
      "mistralLarge": "Sovereign Mistral — maximum quality",
      "gemini3Flash": "Fast and balanced",
      "gemini31Pro": "Latest Google model, advanced reasoning",
      "gemini25Flash": "Good quality/speed ratio",
      "gemini25Pro": "Accurate, multimodal",
      "gpt52": "Latest OpenAI, enhanced reasoning",
      "gpt5": "Excellent reasoning",
      "gpt5Mini": "Good reasoning, fast"
    },
    "advancedMode": "Advanced mode",
    "advancedModeHint": "Choose model, custom instructions and comparison",
    "mistralBadge": "Generated with Mistral — sovereign AI, no training on your data",
    "cost": {
      "estimatedCost": "Estimated cost",
      "credits": "credits",
      "breakdown": "Tier {{tier}} (~{{tokens}} tokens) × factor ×{{factor}}",
      "tooltipTiers": "Base cost (by transcription size)",
      "tooltipFactors": "Model factor",
      "learnMore": "Learn more →"
    },
    "refine": {
      "title": "Modify this version",
      "placeholder": "E.g. shorten the budget section, add a Priority column…",
      "apply": "Apply",
      "applying": "Applying the modification…",
      "undo": "Previous version",
      "redo": "Next version",
      "error": "Could not apply the modification",
      "chips": {
        "shorten": "Shorten",
        "formal": "More formal",
        "table": "As a table",
        "actions": "Clarify actions",
        "expand": "Expand",
        "bullets": "As bullets",
        "summary": "Add a summary",
        "owners": "Add owners",
        "dates": "Add due dates",
        "sections": "Add sections"
      },
      "prompts": {
        "shorten": "Shorten the report by about 30% while keeping all essential information.",
        "formal": "Rewrite the report with a more formal, professional tone without changing the content.",
        "table": "Present the next steps as a table (Action, Owner, Due date, Expected outcome).",
        "actions": "Clarify and complete the next steps section: explicit owner and due date for each action.",
        "expand": "Expand the report: add context, concrete details and missing decision points, without inventing information.",
        "bullets": "Turn long paragraphs into short, readable bullet lists without losing information.",
        "summary": "Add a \"Summary\" section at the top of the report with 3 to 5 bullets covering the key points.",
        "owners": "Add an \"Owner\" column/mention for every action and assign it to the right person based on the content.",
        "dates": "Add explicit due dates or deadlines for each next step.",
        "sections": "Structure the report with clear headings (Context, Key points, Decisions, Next steps)."
      },
      "quotaError": "AI quota exhausted: the modification could not be applied. Your current version is preserved. Buy credits, then retry just this modification.",
      "retry": "Retry modification",
      "dismiss": "Dismiss"
    },
    "compareVersions": {
      "title": "Compare versions",
      "button": "Compare",
      "current": "current",
      "restore": "Restore",
      "legend": "Each column is compared to the previous one: additions highlighted, deletions struck through."
    },
    "backToProspect": "Back to prospect",
    "editor": {
      "bold": "Bold",
      "italic": "Italic",
      "h2": "Heading",
      "h3": "Subheading",
      "bullets": "Bullet list",
      "numbered": "Numbered list",
      "quote": "Quote",
      "undo": "Undo",
      "redo": "Redo"
    }
  },
  "legalPages": {
    "back": "Back",
    "lastUpdated": "Last updated: April 1, 2026",
    "legal": {
      "title": "Legal notice",
      "s1Title": "1. Site editor",
      "s1Intro": "The website <0>Thiia Prospect</0> is published by:",
      "s1Items": {
        "name": "<0>Company name:</0> KREAPP — SAS, simplified joint-stock company",
        "siren": "<0>SIREN:</0> 914 378 344",
        "siret": "<0>SIRET (head office):</0> 914 378 344 00016",
        "capital": "<0>Share capital:</0> €1,000",
        "address": "<0>Head office:</0> 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France",
        "ape": "<0>APE code:</0> 6201Z — Computer programming",
        "registered": "<0>Registration date:</0> 06/10/2022",
        "president": "<0>President:</0> Samir SALIBI"
      },
      "s2Title": "2. Hosting",
      "s2Body": "The site is hosted by <0>Supabase Inc.</0> and <1>Lovable GmbH</1>. Data is processed in compliance with the GDPR and hosted within the European Union.",
      "s3Title": "3. Intellectual property",
      "s3Body": "All content on the site (texts, images, logos, software, database) is the exclusive property of KREAPP or its partners and is protected by French and international intellectual property laws. Any reproduction, representation or distribution, in whole or in part, without prior written authorization is prohibited.",
      "s4Title": "4. Liability",
      "s4Body": "KREAPP strives to ensure the accuracy of the information published on the site, but cannot be held responsible for errors, omissions or results obtained from the use of this information. Use of the Thiia Prospect service is subject to the general terms of use.",
      "s5Title": "5. Contact",
      "s5Body": "For any question related to the legal notice, you can contact us at the head office address mentioned above or by email at: <0>hello@thiia.app</0>."
    },
    "privacy": {
      "title": "Privacy policy",
      "s1Title": "1. Data controller",
      "s1Body": "The data controller is <0>KREAPP</0>, a SAS with capital of €1,000, registered under SIREN 914 378 344, with its head office at 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France, represented by Samir SALIBI, President.",
      "s2Title": "2. Data collected",
      "s2Intro": "When using Thiia Prospect, we collect the following data:",
      "s2Items": {
        "identity": "<0>Identification data:</0> last name, first name, email address, password (encrypted)",
        "pro": "<0>Professional data:</0> company name, industry, target audience, social networks",
        "prospects": "<0>Prospecting data:</0> information about your prospects (name, email, company, notes, interaction history)",
        "comms": "<0>Communication data:</0> content of analyzed emails (with your consent), conversations with the AI assistant",
        "tech": "<0>Technical data:</0> IP address, browser type, pages visited, login timestamps"
      },
      "s3Title": "3. Purposes of processing",
      "s3Items": {
        "account": "Account management and authentication",
        "service": "Providing AI-assisted prospecting services",
        "enrich": "Analysis and enrichment of your professional contacts",
        "content": "Content generation and personalized recommendations",
        "notifs": "Sending notifications and reminders related to your activity",
        "improve": "Service improvement and bug fixes"
      },
      "s4Title": "4. Legal basis for processing",
      "s4Items": {
        "contract": "<0>Contract performance:</0> processing necessary to provide the service (Art. 6.1.b GDPR)",
        "consent": "<0>Consent:</0> for analyzing your emails and using non-essential cookies (Art. 6.1.a GDPR)",
        "interest": "<0>Legitimate interest:</0> service improvement, security, fraud prevention (Art. 6.1.f GDPR)"
      },
      "s5Title": "5. AI data confidentiality",
      "s5Body": "<0>Your data is never used to train artificial intelligence models.</0> Thiia Prospect uses Mistral AI, a French sovereign AI engine. Data sent to the AI for analysis is processed ephemerally and is neither stored nor reused by the model provider. Full confidentiality of your data is guaranteed.",
      "s6Title": "6. Retention period",
      "s6Items": {
        "account": "<0>Account data:</0> kept for the duration of your subscription, then 3 years after account deletion",
        "prospects": "<0>Prospecting data:</0> kept as long as your account is active",
        "logs": "<0>Technical logs:</0> 12 months maximum",
        "ai": "<0>AI conversations:</0> kept until you delete them"
      },
      "s7Title": "7. Data sharing",
      "s7Intro": "Your personal data is never sold. It may be shared with:",
      "s7Items": {
        "supabase": "<0>Supabase:</0> hosting and database (EU)",
        "mistral": "<0>Mistral AI:</0> AI processing (France)",
        "stripe": "<0>Stripe:</0> payment processing (GDPR compliant)",
        "google": "<0>Google / Microsoft:</0> only if you connect your email or calendar accounts (with your explicit consent)"
      },
      "s8Title": "8. Transfers outside the EU",
      "s8Body": "We prioritize hosting within the European Union. When a transfer outside the EU is necessary (e.g. Stripe for payments), it is governed by standard contractual clauses approved by the European Commission or by an adequacy decision.",
      "s9Title": "9. Your rights",
      "s9Intro": "In accordance with the GDPR, you have the following rights:",
      "s9Items": {
        "access": "<0>Right of access:</0> obtain a copy of your personal data",
        "rectify": "<0>Right of rectification:</0> correct inaccurate or incomplete data",
        "erase": "<0>Right to erasure:</0> request deletion of your data",
        "portability": "<0>Right to portability:</0> receive your data in a structured format",
        "object": "<0>Right to object:</0> object to the processing of your data",
        "limit": "<0>Right to restriction:</0> restrict the processing of your data",
        "withdraw": "<0>Right to withdraw consent:</0> withdraw your consent at any time"
      },
      "s9Contact": "To exercise your rights, contact us at: <0>hello@thiia.app</0>",
      "s9Cnil": "In case of dispute, you can lodge a complaint with the <0>CNIL</0> (French data protection authority) — <1>www.cnil.fr</1>.",
      "s10Title": "10. Cookies",
      "s10Body": "Thiia Prospect only uses cookies strictly necessary for the operation of the service (authentication, session preferences). No advertising or tracking cookies are used.",
      "s11Title": "11. Security",
      "s11Body": "We implement appropriate technical and organizational measures to protect your data: encryption in transit (TLS) and at rest, secure authentication, row-level security (RLS) policies in the database, and regular audits.",
      "s12Title": "12. Policy changes",
      "s12Body": "This privacy policy may be updated at any time. In case of substantial changes, you will be notified by in-app notification or email."
    },
    "terms": {
      "title": "Terms of use",
      "s1Title": "1. Purpose",
      "s1Body": "These general terms of use (TOU) govern access to and use of the <0>Thiia Prospect</0> platform, published by KREAPP, a SAS with capital of €1,000, SIREN 914 378 344, head office: 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France.",
      "s2Title": "2. Service access",
      "s2Body": "Access to Thiia Prospect requires the creation of a user account. The user agrees to provide accurate information and to maintain the confidentiality of their credentials. Any access to the account is presumed to be made by the account holder.",
      "s3Title": "3. Service description",
      "s3Intro": "Thiia Prospect is an intelligent prospecting agent offering:",
      "s3Items": {
        "chat": "A conversational AI assistant for sales prospecting",
        "crm": "Prospect management and tracking (CRM)",
        "search": "Search and enrichment of professional contacts",
        "email": "Email analysis and content generation",
        "calendar": "Event and calendar management",
        "social": "Publishing on professional social networks"
      },
      "s4Title": "4. Credits and pay-as-you-go",
      "s4Body": "Thiia Prospect works without a subscription. Access to features is based on the purchase of credits consumed as you use the service (searches, analyses, email sending, content generation, etc.). Payments are handled by Stripe and made on a one-off basis when buying each credit pack. Pricing and the credit cost of each action are disclosed before purchase. Purchased credits are not renewed automatically: no charge is made without an explicit action from the user. Unused credits remain available as long as the account is active and are non-refundable.",
      "s5Title": "5. User obligations",
      "s5Intro": "The user agrees to:",
      "s5Items": {
        "lawful": "Use the service in accordance with its purpose and applicable laws",
        "spam": "Not use the service for spam or harassment purposes",
        "gdpr": "Respect applicable data protection regulations (GDPR) for their own prospects' data",
        "security": "Not attempt to bypass the security measures of the service",
        "resell": "Not resell or redistribute access to the service without authorization"
      },
      "s6Title": "6. Intellectual property",
      "s6Body": "All elements of the service (software, design, algorithms, brands) are the exclusive property of KREAPP. The user retains ownership of their data. By using the service, the user grants KREAPP a limited license to process their data solely for the purpose of providing the service.",
      "s7Title": "7. Personal data",
      "s7Body": "The processing of personal data is described in our <0>Privacy policy</0>. Data is never used to train AI models.",
      "s8Title": "8. Limitation of liability",
      "s8Body": "KREAPP makes reasonable efforts to ensure the availability and reliability of the service. However, the service is provided \"as is\". KREAPP does not guarantee that the service will be free from interruptions or errors. KREAPP shall in no event be liable for indirect damages resulting from the use of the service.",
      "s9Title": "9. Termination",
      "s9Body": "The user may terminate their account at any time from their account settings. KREAPP reserves the right to suspend or terminate an account in case of violation of these TOU, after notification. Upon termination, user data will be retained for 30 days, then deleted.",
      "s10Title": "10. Applicable law and jurisdiction",
      "s10Body": "These TOU are governed by French law. In case of dispute, and after attempting amicable resolution, the competent courts of Versailles shall have sole jurisdiction.",
      "s11Title": "11. Contact",
      "s11Body": "For any question relating to the TOU: <0>hello@thiia.app</0>"
    }
  },
  "docsPage": {
    "toc": "Contents",
    "sectionsCount": "{{count}} sections",
    "title": "Documentation",
    "subtitle": "Complete guide to get the most out of Thiia",
    "searchPlaceholder": "Search the documentation…",
    "noResults": "No results for \"{{query}}\". Try other keywords.",
    "footerQuestion": "Still have a question?",
    "footerContact": "Ask <0>Thiia in the chat</0> directly, or contact us at <1>hello@thiia.app</1>"
  },
  "auth": {
    "home": "Home",
    "pageHeading": "Sign in or create your Thiia account",
    "tagline": "Your AI prospecting and communication assistant",
    "emailConfirmed": "Email confirmed successfully!",
    "emailConfirmedDesc": "Your account is activated. Sign in to get started.",
    "invitationReceived": "You have received an invitation",
    "invitationJoinLogin": "Sign in to join your team",
    "invitationJoinSignup": "Create your account to join your team",
    "forgotTitle": "Forgot password",
    "loginTitle": "Sign in",
    "signupTitle": "Create an account",
    "forgotDesc": "Enter your email to receive a reset link",
    "loginDesc": "Find your Thiia space",
    "signupInviteDesc": "Create your account to accept the invitation",
    "signupDesc": "Start prospecting with AI",
    "emailPlaceholder": "Email",
    "namePlaceholder": "Your name",
    "passwordPlaceholder": "Password",
    "confirmPasswordPlaceholder": "Confirm password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "forgotLink": "Forgot password?",
    "sending": "Sending...",
    "sendLink": "Send the link",
    "loading": "Loading...",
    "signIn": "Sign in",
    "signUp": "Sign up",
    "cooldown": "Try again in {{s}}s",
    "captcha": {
      "label": "Anti-bot verification",
      "requiredTitle": "Verification required",
      "requiredDesc": "Please complete the anti-bot challenge before continuing.",
      "testKeyNotice": "hCaptcha test mode is active. Set VITE_HCAPTCHA_SITE_KEY (and the matching secret in Supabase) to enable real protection."
    },
    "acceptTermsLabel": "I accept Thiia's <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
    "acceptTermsRequiredTitle": "Acceptance required",
    "acceptTermsRequiredDesc": "You must accept the Terms of Service and Privacy Policy to continue.",
    "backToLogin": "← Back to sign in",
    "noAccount": "No account yet? Sign up",
    "haveAccount": "Already have an account? Sign in",
    "emailSent": "Email sent!",
    "emailSentDesc": "Check your inbox to reset your password.",
    "error": "Error",
    "passwordsDiffer": "Passwords do not match",
    "passwordsDifferDesc": "Please enter the same password twice.",
    "accountCreated": "Account created!",
    "accountCreatedDesc": "Check your email to confirm your registration.",
    "invitationAccepted": "Invitation accepted! 🎉",
    "invitationAcceptedDesc": "Your account has been linked to your administrator.",
    "invitationError": "Invitation error",
    "invitationErrorDesc": "Unable to accept the invitation",
    "continueWithGoogle": "Continue with Google",
    "continueWithLinkedIn": "Continue with LinkedIn",
    "continueWithMicrosoft": "Continue with Microsoft",
    "magicLinkCta": "Send magic link",
    "magicLinkNeedEmail": "Please enter your email.",
    "magicLinkSentDesc": "Check your inbox to sign in.",
    "magicLinkSentTitle": "Magic link sent",
    "orContinueWith": "Or continue with",
    "password": {
      "digit": "At least one digit",
      "length": "At least 10 characters",
      "lower": "At least one lowercase letter",
      "medium": "Medium",
      "noSpace": "No spaces",
      "special": "At least one special character",
      "strong": "Strong",
      "upper": "At least one uppercase letter",
      "veryStrong": "Very strong",
      "weak": "Weak",
      "weakDesc": "Please choose a stronger password.",
      "weakTitle": "Password too weak"
    }
  },
  "resetPassword": {
    "invalidLink": "Invalid or expired reset link.",
    "backToLogin": "Back to sign in",
    "title": "New password",
    "cardTitle": "Reset",
    "cardDesc": "Choose your new password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "updating": "Updating...",
    "submit": "Update password",
    "passwordsMismatch": "Passwords do not match.",
    "passwordTooShort": "Password must be at least 6 characters.",
    "updated": "Password updated!",
    "updatedDesc": "You can now sign in.",
    "error": "Error",
    "emailPlaceholder": "your@email.com",
    "expiredDesc": "This reset link has expired.",
    "expiredTitle": "Link expired",
    "refreshLink": "Send a new link",
    "resend": "Resend",
    "resending": "Sending…",
    "resentDesc": "A new link has been sent to you.",
    "resentInline": "Link resent",
    "resentTitle": "Link resent"
  },
  "clients": {
    "convertedToast": {
      "desc": "Prospect is now a client.",
      "title": "Client converted"
    },
    "movedBackToast": {
      "desc": "Client moved back to prospects.",
      "title": "Moved to prospects"
    }
  },
  "organizations": {
    "alreadyExists": "This organization already exists",
    "create": "Create organization",
    "createDescription": "Add a new organization to your workspace.",
    "createTitle": "New organization",
    "created": "Organization created",
    "name": "Name",
    "namePlaceholder": "Organization name",
    "personal": "Personal",
    "title": "Organizations"
  },
  "searchHub": {
    "subtitle": "Search companies, people and events",
    "tabs": {
      "companies": "Companies",
      "events": "Events",
      "people": "People",
      "auto": "Automatic results"
    },
    "title": "Prospecting"
  },
  "announcements": {
    "title": "What's new",
    "subtitle": "Stay up to date with the latest platform improvements.",
    "empty": "No announcements yet.",
    "unread": "unread",
    "pinned": "Pinned",
    "readMore": "Read more",
    "seeAll": "See all",
    "bellTooltip": "See what's new",
    "categories": {
      "feature": "New Feature",
      "improvement": "Improvement",
      "fix": "Fix",
      "milestone": "Milestone",
      "announcement": "Announcement"
    },
    "audience": {
      "owner_network": "My network (all my coaches)",
      "users": "Specific users",
      "all": "All users"
    },
    "status": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "published": "Published",
      "archived": "Archived"
    },
    "admin": {
      "title": "What's New",
      "subtitle": "Communicate updates to your coaches — display at login and optional email.",
      "new": "New announcement",
      "edit": "Edit announcement",
      "empty": "No announcements yet.",
      "ownersOnly": "Reserved for administrators.",
      "publish": "Publish",
      "publishAndEmail": "Publish + send email",
      "sendEmail": "Send email",
      "preview": "Preview",
      "saveDraft": "Save as draft",
      "saved": "Announcement saved",
      "published": "Announcement published",
      "deleted": "Announcement deleted",
      "deleteTitle": "Delete this announcement?",
      "deleteDesc": "It will disappear for all recipients. This action is irreversible.",
      "titleRequired": "Title required",
      "emailSent": "Email sent",
      "emailSentAt": "Sent",
      "emailPending": "Pending",
      "emailAlreadySent": "Email already sent on",
      "col": {
        "title": "Title",
        "category": "Category",
        "status": "Status",
        "updated": "Updated",
        "email": "Email"
      }
    },
    "preview": {
      "title": "Announcement preview",
      "tabInApp": "In-app",
      "tabEmail": "Email",
      "audienceCount": "{{count}} recipient(s)",
      "scheduled": "Scheduled",
      "subject": "Subject",
      "markedRead": "Simulate as read",
      "warnTitle": "Missing title",
      "warnBody": "Empty content",
      "untitled": "(untitled)"
    },
    "form": {
      "title": "Title",
      "titlePh": "e.g. New Insights module",
      "summary": "Summary (1 sentence)",
      "category": "Category",
      "audience": "Audience",
      "userIds": "User IDs (comma-separated)",
      "imageUrl": "Image (URL, optional)",
      "body": "Content",
      "bodyPh": "Describe what's new…",
      "ctaLabel": "Button label (optional)",
      "ctaLabelPh": "See what's new",
      "ctaUrl": "Button URL",
      "publishAt": "Publish at (optional)",
      "expiresAt": "Expires at (optional)",
      "pinned": "Pin",
      "pinnedHelp": "Shown first in the banner.",
      "sendEmail": "Send email on publish",
      "sendEmailHelp": "Recipients who haven't opted out will receive an email."
    }
  },
  "workspace": {
    "account": "Account",
    "backShort": "Back",
    "backToMine": "Back to my account",
    "banner": "You are viewing {{name}}'s account",
    "bannerActions": "Actions",
    "bannerReadOnly": "Read only",
    "collaboratorOn": "Collaborator on",
    "switchTitle": "Switch workspace",
    "viewingOther": "You are viewing another workspace",
    "yourAccount": "Your account"
  },
  "checklistComponents": {
    "filterBar": {
      "search": "Search a task…",
      "clearSearch": "Clear search",
      "type": "Type",
      "filterByType": "Filter by type",
      "allTypes": "All types",
      "filterByDueDate": "Filter by due date",
      "dueAll": "All due dates",
      "dueOverdue": "Overdue",
      "dueToday": "Today",
      "dueWeek": "This week",
      "dueMonth": "This month",
      "dueNoDate": "No date",
      "dueShortAll": "Due",
      "dueShortWeek": "Week",
      "dueShortMonth": "Month",
      "assignee": "Assignee",
      "filterByAssignee": "Filter by assignee",
      "allAssignees": "All assignees",
      "me": "Me",
      "thiia": "Thiia",
      "thiiaAi": "Thiia (AI)",
      "collaborators": "Collaborators",
      "filterByTag": "Filter by tag",
      "tags": "Tags",
      "tagCount": "{{count}} tags",
      "searchTag": "Search a tag…",
      "noTags": "No tag",
      "clearSelection": "Clear selection",
      "manageTags": "Manage tags",
      "sort": "Sort",
      "sortManual": "Manual order",
      "sortDueAsc": "Due date ascending",
      "sortDueDesc": "Due date descending",
      "sortManualShort": "Manual",
      "sortDueAscShort": "Due ↑",
      "sortDueDescShort": "Due ↓",
      "showArchived": "Show archived",
      "hideArchived": "Hide archived",
      "archivedShown": "Archived shown",
      "resetFilters": "Reset filters",
      "newSection": "New section",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "exportExcel": "Export to Excel",
      "newTask": "New task",
      "moreActions": "More actions",
      "newFolder": "New folder",
      "archiveCompleted": "Archive completed",
      "filters": "Filters",
      "searchOption": "Search…",
      "noResult": "No result",
      "selectedCount": "{{count}} selected",
      "status": "Status",
      "statusActive": "All tasks",
      "statusArchived": "Archived included"
    },
    "widget": {
      "defaultTitle": "My tasks",
      "showAll": "Show all ({{count}})",
      "new": "New",
      "create": "Create",
      "createOne": "Create a checklist",
      "noChecklist": "No checklist yet.",
      "checklistNamePlaceholder": "Checklist name…",
      "searchTaskPlaceholder": "Search a task…",
      "clear": "Clear",
      "me": "Me",
      "collaborator": "Collaborator",
      "selectTask": "Select task",
      "reorder": "Reorder",
      "expandSubtasks": "Expand subtasks",
      "collapseSubtasks": "Collapse subtasks",
      "toggleAllFor": "Toggle all for {{label}}",
      "addSubtask": "Add a subtask",
      "moveToOtherChecklist": "Move to another checklist",
      "moveTo": "Move to",
      "editTask": "Edit task",
      "deleteTask": "Delete task",
      "deleteTaskWithSubtasks": "Delete task and subtasks",
      "subtaskPlaceholder": "New subtask…",
      "addTaskPlaceholder": "Add a task…",
      "badgeAll": "Done",
      "badgeNone": "To do",
      "badgeMixed": "In progress",
      "openChecklist": "Open checklist {{title}}",
      "openProspectSheet": "Open prospect sheet",
      "doubleClickToRename": "Double-click to rename",
      "uncheckAll": "Uncheck all",
      "completeRest": "Complete remaining",
      "checkAll": "Check all",
      "restoreChecklist": "Restore checklist",
      "archiveChecklist": "Archive checklist",
      "restore": "Restore",
      "archive": "Archive",
      "deleteChecklistTitle": "Delete checklist?",
      "deleteChecklistDescPermanent": "This action is permanent and will remove all tasks.",
      "deleteChecklist": "Delete checklist",
      "delete": "Delete",
      "noOrg": "No organization",
      "organization": "Organization",
      "none": "None",
      "overdueCount": "{{count}} overdue",
      "setDueDate": "Set a due date",
      "editDueDate": "Edit due date",
      "removeDueDate": "Remove due date",
      "noTaskToExport": "No task to export",
      "tasksExported": "{{count}} tasks exported",
      "tasksUpdated": "{{count}} tasks updated",
      "tasksReassigned": "{{count}} tasks reassigned",
      "tasksDeleted": "{{count}} tasks deleted",
      "tasksArchived": "{{count}} tasks archived",
      "tasksRestored": "{{count}} tasks restored",
      "sendEmail": "Send email",
      "scheduleEmail": "Schedule email",
      "createEvent": "Create event",
      "addNote": "Add note",
      "doWithThiia": "Do with Thiia",
      "doneByThiia": "Done by Thiia",
      "failed": "Failed",
      "quotaExhausted": "Quota exhausted",
      "buyCreditsPack": "Buy a credit pack to continue.",
      "actionFailed": "Action failed",
      "confirmSend": "Confirm send?",
      "thiiaWillSendEmail": "Thiia will send the email for this task.",
      "send": "Send",
      "cancel": "Cancel",
      "noMatch": "No matching task",
      "goToChecklists": "View all tasks"
    }
  },
  "miscComponents": {
    "addEventDialog": {
      "chooseType": "What type of event would you like to create?",
      "hostingTitle": "I'm hosting this event",
      "hostingDesc": "You are the host: manage invitations, RSVP, check-in and recap.",
      "attendingTitle": "I'm attending this event",
      "attendingDesc": "You are invited: track the date, place and your notes.",
      "hostingHeader": "Create an event (host)",
      "attendingHeader": "Add an event you're attending",
      "continue": "Continue",
      "meetingLinkCreated": "Meeting link created",
      "meetingLinkError": "Could not create link",
      "invitee": "Guest",
      "invitationsPartial": "Some invitations could not be sent",
      "rsvp": "Your response",
      "rsvpGoing": "Going",
      "rsvpMaybe": "Maybe",
      "rsvpDeclined": "Not going",
      "organization": "Organization",
      "chooseOrganization": "Choose an organization",
      "defaultSuffix": "default",
      "when": "When",
      "duration": "Duration",
      "minutes": "Minutes",
      "hours": "Hours",
      "days": "Days",
      "useDuration": "Use a duration",
      "useEndTime": "Use an end time",
      "organizer": "Organizer",
      "organizerName": "Organizer name",
      "organizerPlaceholder": "Name shown to guests",
      "eventLink": "Event link",
      "recurrence": "Recurrence",
      "repeat": "Repeat",
      "noRecurrence": "None",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "until": "Until",
      "noEnd": "No end",
      "format": "Format",
      "online": "Online",
      "inPerson": "In person",
      "videoconference": "Video conference",
      "suggested": "Suggested:",
      "chooseService": "Choose a service",
      "noLink": "No link",
      "googleAccount": "Google account",
      "chooseAccount": "Choose an account",
      "autoMeetingNote": "The meeting link will be created automatically when the event is saved.",
      "connectProviders": "Connect Google or Microsoft in settings to generate a link automatically.",
      "locationAddress": "Address / Location",
      "addressPlaceholder": "Enter an address",
      "addressHint": "Guests will see this address in the invitation.",
      "guests": "Guests",
      "removeAll": "Remove all",
      "addProspects": "Add prospects",
      "selectedProspects": "{{count}} prospect(s) selected",
      "searchProspect": "Search for a prospect...",
      "noProspect": "No prospect found",
      "noName": "No name",
      "remove": "Remove",
      "filteredByOrg": "List filtered by the chosen organization.",
      "creatingMeet": "Creating link..."
    },
    "publishLinkedInDialog": {
      "tokenExpiredTitle": "LinkedIn session expired",
      "tokenExpiredDesc": "Reconnect your LinkedIn account to publish.",
      "syncedWithEditor": "Synced with editor",
      "displayMode": "Display mode",
      "editText": "Edit text",
      "editionTab": "Editing",
      "previewTitle": "LinkedIn preview",
      "previewTab": "Preview",
      "companyPageLabel": "Company page",
      "personalProfileLabel": "Personal profile",
      "justNow": "just now",
      "linksNotClickable": "Links are not clickable in the preview.",
      "linkedinActivationHint": "Enable LinkedIn publishing in settings.",
      "andMore": "and more",
      "fixAll": "Fix all",
      "viewDetail": "View detail",
      "seeLess": "See less",
      "seeMore": "See more",
      "ratio": "Ratio",
      "recommended": "recommended",
      "previewBadge": "Preview",
      "croppedFor": "Cropped for",
      "notPublishedYet": "Not published yet",
      "detectedLinks": "Detected links",
      "toFix": "To fix",
      "urlsNotClickable": "These URLs are not clickable on LinkedIn.",
      "prefixAllTitle": "Prefix all URLs",
      "fix": "Fix"
    },
    "richTextEditor": {
      "addLink": "Add link",
      "bold": "Bold",
      "bulletList": "Bullet list",
      "clearFormatting": "Clear formatting",
      "ctaButtonDefault": "Learn more",
      "ctaButtonText": "Button text",
      "ctaTitle": "Insert call-to-action button",
      "ctaUrl": "Button URL",
      "customColor": "Custom color",
      "fontFamily": "Font",
      "heading1": "Heading 1",
      "heading2": "Heading 2",
      "heading3": "Heading 3",
      "insertCta": "Insert button",
      "insertImage": "Insert image",
      "italic": "Italic",
      "lineHeight": "Line height",
      "link": "Link",
      "linkUrl": "Link URL",
      "max5mb": "Max size: 5 MB",
      "notAuthenticated": "You must be signed in.",
      "orderedList": "Numbered list",
      "quote": "Quote",
      "redo": "Redo",
      "reset": "Reset",
      "selectImage": "Choose an image",
      "separator": "Separator",
      "strike": "Strikethrough",
      "textColor": "Text color",
      "tooLarge": "File too large",
      "underline": "Underline",
      "undo": "Undo",
      "unsupportedFormat": "Unsupported format",
      "uploadError": "Upload error"
    },
    "calendarPage": {
      "joinTeams": "Join Teams",
      "joinZoom": "Join Zoom",
      "joinMeet": "Join Meet",
      "joinWebex": "Join Webex",
      "joinJitsi": "Join Jitsi",
      "joinGoToMeeting": "Join GoToMeeting",
      "joinGoTo": "Join GoTo",
      "joinBlueJeans": "Join BlueJeans",
      "joinWhereby": "Join Whereby",
      "join8x8": "Join 8x8",
      "joinLifesize": "Join Lifesize",
      "joinDaily": "Join Daily",
      "joinAround": "Join Around",
      "joinLivestorm": "Join Livestorm",
      "joinClickMeeting": "Join ClickMeeting",
      "joinSkype": "Join Skype",
      "joinDiscord": "Join Discord",
      "joinSlack": "Join Slack",
      "joinMeeting": "Join meeting",
      "linkCopied": "Link copied!",
      "copyLinkFail": "Copy failed",
      "copyLink": "Copy link",
      "copyLinkAria": "Copy meeting link",
      "busySlotHidden": "Details hidden (busy slot)",
      "tasks": "Tasks",
      "showDoneTasks": "Show done tasks",
      "hideDoneTasksTitle": "Hide done tasks",
      "hideDoneTasks": "Hide done",
      "doneTasks": "Done",
      "hideBusyTitle": "Hide busy slots",
      "showBusyTitle": "Show busy slots",
      "busy": "Busy",
      "noTasksToExport": "No tasks to export",
      "tasksExported": "{{count}} tasks exported ({{label}})",
      "exportTasksTitle": "Export tasks to Excel",
      "excel": "Excel",
      "visible": "visible",
      "visibleTasks": "Visible tasks only",
      "thisWeekLabel": "this week",
      "thisWeek": "Tasks of this week",
      "thisMonthLabel": "this month",
      "thisMonth": "Tasks of this month",
      "next30DaysLabel": "next 30 days",
      "next30Days": "Tasks of next 30 days",
      "customRange": "Custom range...",
      "fromTo": "From / To",
      "startLabel": "Start",
      "endLabel": "End",
      "selectRange": "Select a range",
      "invalidRange": "End date must be after start",
      "export": "Export",
      "viewError": "View error",
      "reload": "Reload",
      "openDetails": "Details",
      "syncedFromGoogle": "Synced from Google Calendar",
      "googleCalendar": "Google Calendar",
      "syncedFromOutlook": "Synced from Outlook",
      "outlookCalendar": "Outlook",
      "editEvent": "Edit event",
      "edit": "Edit",
      "deleteConfirmTitle": "Delete event?",
      "delete": "Delete",
      "deleteEvent": "Delete event",
      "openActionsMenu": "Actions",
      "actions": "Actions",
      "details": "Details",
      "showMoreDays": "Show {{count}} more day(s)"
    }
  },
  "agentWatches": {
    "title": "Thiia watches",
    "subtitle": "Recurring tasks Thiia runs automatically (e.g. \"Analyze my LinkedIn every Tuesday and suggest 3 posts\"). Create one here or ask Thiia in chat.",
    "pageSubtitle": "Recurring tasks Thiia runs automatically for you. Create one by asking in chat (e.g. \"Analyze my LinkedIn every Tuesday at 6am and suggest 3 posts\").",
    "newButton": "New",
    "details": "Details",
    "loading": "Loading…",
    "empty": "No active watch. Ask Thiia in chat.",
    "emptyLong": "No watch yet. Ask Thiia in chat to create a recurring task she will run for you.",
    "paused": "Paused",
    "pausedLong": "Paused",
    "nextRun": "next",
    "nextRunLabel": "Next",
    "localTime": "Local time",
    "changeTimezone": "Change timezone",
    "deleteTitle": "Delete",
    "deleteConfirm": "Delete watch \"{{title}}\"?",
    "deleteConfirmHard": "Permanently delete watch \"{{title}}\"?",
    "deleted": "Watch deleted",
    "paused_toast": "Watch paused",
    "resumed_toast": "Watch resumed",
    "invalidTz": "Invalid timezone",
    "tzUpdateFail": "Could not update timezone",
    "tzUpdated": "Timezone updated: {{tz}}",
    "noRunYet": "No run yet.",
    "lastReport": "Last report",
    "viewLastReport": "View last report",
    "reports": "Reports",
    "reportsDesc": "Last 3 reports generated by Thiia.",
    "testNow": "Test",
    "testNowHint": "Run once now to verify the watch works (won't shift the next scheduled run).",
    "testRunning": "Testing “{{title}}”…",
    "testSuccess": "✅ Test of “{{title}}” succeeded — see the report.",
    "testFailed": "❌ Test of “{{title}}” failed: {{error}}",
    "testAlreadyRunning": "A run is already in progress for this watch — please wait a few seconds.",
    "badge": {
      "test": "Test"
    },
    "cron": {
      "everyDay": "Every day at {{time}}",
      "everyDaily": "Every day at {{time}} ({{tz}})",
      "everyDay_": "Every {{day}} at {{time}} ({{tz}})",
      "dayOfMonth": "On the {{dom}} of each month at {{time}}",
      "dayOfMonthTz": "On the {{dom}} of each month at {{time}} ({{tz}})",
      "everyDow": "Every {{day}} at {{time}}",
      "yearly": "Every year in month {{month}}, {{time}}",
      "days": {
        "short": {
          "0": "Sun",
          "1": "Mon",
          "2": "Tue",
          "3": "Wed",
          "4": "Thu",
          "5": "Fri",
          "6": "Sat"
        },
        "long": {
          "0": "Sunday",
          "1": "Monday",
          "2": "Tuesday",
          "3": "Wednesday",
          "4": "Thursday",
          "5": "Friday",
          "6": "Saturday"
        }
      }
    },
    "dialog": {
      "title": "New Thiia watch",
      "desc": "Configure a recurring task Thiia will run automatically for you.",
      "fieldTitle": "Title",
      "titlePh": "Ex: Weekly LinkedIn watch",
      "goal": "Goal",
      "optional": "(optional)",
      "goalPh": "What Thiia should monitor or produce…",
      "action": "Action",
      "frequency": "Frequency",
      "cronPh": "0 6 * * 2",
      "cronRequired": "Cron expression required",
      "cronInvalid": "Invalid cron",
      "timezone": "Timezone",
      "nextRun": "Next run",
      "cancel": "Cancel",
      "continue": "Continue",
      "confirmTitle": "Confirm watch creation",
      "confirmDesc": "Review the summary below before validating.",
      "modify": "Edit",
      "create": "Create watch",
      "creating": "Creating…",
      "created": "Watch created",
      "createFail": "Could not create watch",
      "recap": {
        "title": "Title",
        "goal": "Goal",
        "action": "Action",
        "frequency": "Frequency",
        "timezone": "Timezone",
        "nextRun": "Next run"
      },
      "presets": {
        "daily8": "Every day at 8am",
        "daily8Hint": "Perfect for a morning briefing",
        "weeklyTue6": "Every Tuesday at 6am",
        "weeklyTue6Hint": "Recommended for LinkedIn",
        "weeklyMon9": "Every Monday at 9am",
        "weeklyMon9Hint": "Weekly kick-off",
        "monthly1": "The 1st of each month at 9am",
        "monthly1Hint": "Monthly review",
        "custom": "Custom cron",
        "customHint": "Enter your expression"
      },
      "actions": {
        "linkedinLabel": "LinkedIn analysis + post drafts",
        "linkedinDesc": "Thiia analyzes your LinkedIn activity then prepares post ideas and drafts."
      }
    },
    "history": {
      "title": "Run history",
      "description": "Every run of this watch: status, duration, recipient, email delivery and errors.",
      "viewHistory": "History ({{count}})",
      "recipient": "Recipient: {{email}}",
      "noRecipient": "No recipient resolved",
      "emailSentAt": "Email sent on {{time}}",
      "emailNotSent": "No email sent",
      "emailSkippedTest": "Test mode — email not sent",
      "resultsCount": "{{count}} result(s)",
      "showItems": "Show {{count}} result(s)",
      "hideItems": "Hide results"
    },
    "edit": {
      "title": "Edit rule",
      "desc": "Adjust the goal, frequency, timezone and report recipient of this watch.",
      "recipient": "Report recipient email",
      "emailInvalid": "Invalid email address",
      "saved": "Rule updated",
      "saveFail": "Could not save the rule",
      "button": "Edit",
      "instructions": "Detailed instructions",
      "instructionsPlaceholder": "E.g.: only keep offers in Paris area, exclude internships, prefer official sources…",
      "instructionsHint": "These instructions take priority for Thiia on every run.",
      "recency": "Freshness",
      "recencyOptions": {
        "day": "Last day",
        "week": "Last 7 days",
        "month": "Last 30 days",
        "year": "Last 12 months"
      },
      "maxItems": "Max number of results",
      "maxItemsHint": "Between 1 and 20 results per run.",
      "sources": "Preferred sources",
      "sourcesPlaceholder": "e.g. boamp, francetravail.fr, apec…",
      "sourcesAdd": "Add a source",
      "sourcesHint": "Domains or platforms to prioritise during the search. Leave empty to filter on no source.",
      "sourcesAuthWalled": "These platforms require authentication and will return almost no results through web search: {{list}}.",
      "sourcesResolved": "Domains actually filtered on the last run: {{list}}",
      "sourcesUnmapped": "Unrecognised labels, ignored by the filter: {{list}}",
      "keywords": "Priority keywords",
      "keywordsPlaceholder": "e.g. transformation, coaching, tender…",
      "keywordsAdd": "Add a keyword",
      "keywordsHint": "Terms emphasised in the search. Leave empty to prioritise no term."
    },
    "versions": {
      "button": "Versions",
      "title": "Version history",
      "desc": "Every change to the rule is archived. Restore a previous version in one click.",
      "empty": "No archived version yet. Versions appear after the first change.",
      "restore": "Restore",
      "restored": "Version v{{n}} restored",
      "restoreFail": "Could not restore this version",
      "confirmTitle": "Restore this version?",
      "confirmDesc": "The rule will be replaced by version v{{n}} (title, goal, instructions, frequency, timezone). The current version will be archived."
    },
    "items": {
      "untitled": "(untitled)",
      "whyRelevant": "Why it is recommended",
      "sourceExplanation": "Source",
      "confidence": {
        "high": "High confidence",
        "medium": "Medium confidence",
        "low": "Low confidence"
      },
      "urlStatus": {
        "verified": "Verified link",
        "same_domain": "Source page",
        "unverified": "Unverified link",
        "search_fallback": "Web search"
      }
    }
  },
  "chatComponents": {
    "sources": {
      "title": "Sources",
      "copy": "Copy",
      "copyAll": "Copy all sources",
      "copied": "Sources copied",
      "copiedShort": "Copied",
      "copyFailed": "Copy failed",
      "showMore": "Show all ({{count}})",
      "showLess": "Show less"
    },
    "giveReformulateInstructions": "Please provide reformulation instructions.",
    "templateSaveFailed": "Failed to save template.",
    "templateSaved": "Template saved.",
    "templateUpdateFailed": "Failed to update template.",
    "signatureSaved": "Signature saved.",
    "subjectBodyRequired": "Subject and body are required.",
    "subjectBodyDateRequired": "Subject, body and date are required.",
    "scheduleDateFuture": "Schedule date must be in the future.",
    "invalidEmail": "Invalid email address.",
    "throttleTooltip": "Space out sends to avoid being flagged as spam.",
    "trackClicksTooltip": "Track clicks on links in the email.",
    "actionBlockUnparsed": "Unparsable action block",
    "activityAnalysisDone": "Activity analysis done",
    "addToNote": "Add to note",
    "addedToNote": "Added to note",
    "analysisCopied": "Analysis copied",
    "annotateComment": "Annotate / comment",
    "archive": "Archive",
    "badAnswer": "Bad answer",
    "companySearchFailed": "Company search failed",
    "copied": "Copied",
    "copy": "Copy",
    "copyAllCitations": "Copy all citations",
    "copyAllUrls": "Copy all URLs",
    "copyEmail": "Copy email",
    "copyForMail": "Copy for email",
    "copyImage": "Copy image",
    "copyImpossible": "Copy failed",
    "copyMessage": "Copy message",
    "copyMessageLink": "Copy message link",
    "copyPhone": "Copy phone",
    "copyRichForMail": "Copy (formatted) for email",
    "createBranch": "Create branch",
    "dataCopied": "Data copied",
    "delete": "Delete",
    "deleteBranchConfirmDesc": "This branch and all its messages will be deleted.",
    "deleteBranchConfirmTitle": "Delete branch?",
    "deleteConvConfirmDesc": "This conversation and all its messages will be deleted.",
    "deleteConvConfirmTitle": "Delete conversation?",
    "deleteMessage": "Delete message",
    "deleteMessageConfirm": "Delete this message?",
    "download": "Download",
    "editMessage": "Edit message",
    "emailCopied": "Email copied",
    "employees": "employees",
    "enrichErrorPrefix": "Enrichment error",
    "enrichSuccess": "Enrichment succeeded",
    "errorPrefix": "Error",
    "eventAnalysisDone": "Event analysis done",
    "exportAnalyzedExcel": "Export (Excel)",
    "exportWordQA": "Export Q&A to Word",
    "goodAnswer": "Good answer",
    "import": "Import",
    "leader": "leader",
    "linkedin": "LinkedIn",
    "moveTo": "Move to",
    "newFolder": "New folder",
    "noConversation": "No conversation",
    "noResult": "No result",
    "noSourceAvailable": "No source available",
    "openInMailer": "Open in mail client",
    "openMailer": "Open mail client",
    "openProspectSheet": "Open prospect sheet",
    "outOfFolder": "Out of folder",
    "phoneCopied": "Phone copied",
    "pinnedMessage": "Pinned message",
    "preview": "Preview",
    "previewAndExport": "Preview & export",
    "publishOnLinkedIn": "Publish on LinkedIn",
    "quoteInReply": "Quote in reply",
    "regenerateAnswer": "Regenerate answer",
    "rename": "Rename",
    "resendPrompt": "Resend prompt",
    "resetConv": "Reset conversation",
    "retrySearch": "Retry search",
    "richCopySuccess": "Copied with formatting",
    "runInSubConversation": "Run in sub-conversation",
    "runThisAction": "Run this action",
    "searchCancelled": "Search cancelled",
    "searchErrorPrefix": "Search error",
    "searchSaved": "Search saved",
    "seeCode": "See code",
    "selectAllToggle": "Select all",
    "serviceOverloaded": "Service overloaded, please retry.",
    "share": "Share",
    "shareByEmail": "Share by email",
    "site": "site",
    "skipCacheRetry": "Retry without cache",
    "sortEvents": "Sort events",
    "sortResults": "Sort results",
    "subfolder": "Subfolder",
    "toggleSelectAllEvents": "Select / deselect all",
    "unarchive": "Unarchive",
    "viewActive": "Active",
    "viewArchived": "Archived",
    "viewCards": "Cards",
    "viewList": "List",
    "viewTable": "Table",
    "wordExported": "Word document exported",
    "yesterday": "yesterday",
    "searchErrorPrefix2": "Search error",
    "searchDeleted": "Search deleted",
    "scoringErrorPrefix": "Scoring error",
    "resetConversation": "Reset conversation",
    "voiceMode": "Voice mode",
    "generateImageQuality": "Image generation quality",
    "backToMainConv": "Back to main conversation",
    "reinjectConclusion": "Reinject conclusion",
    "cancelUpload": "Cancel upload"
  },
  "ownerComponents": {
    "aiUsage": {
      "aiCalls": "AI calls",
      "alerts": {
        "coachCallsExceeded": "A coach has exceeded their calls quota.",
        "coachCallsWarning": "A coach is nearing their calls quota.",
        "coachCostExceeded": "A coach has exceeded their cost quota.",
        "coachCostWarning": "A coach is nearing their cost quota.",
        "globalCallsExceeded": "Global calls quota exceeded.",
        "globalCallsWarning": "Global calls quota almost reached.",
        "globalCostExceeded": "Global cost quota exceeded.",
        "globalCostWarning": "Global cost quota almost reached."
      },
      "alertsBtn": "Alerts",
      "all": "All",
      "allUsers": "All users",
      "attention": "Attention",
      "breakdownByModel": "Breakdown by model",
      "breakdownByType": "Breakdown by type",
      "calls": "Calls",
      "callsCount": "Call count",
      "callsPerDay": "Calls per day",
      "configureThresholds": "Configure thresholds",
      "cost": "Cost",
      "date": "Date",
      "error": "Error",
      "estimatedCost": "Estimated cost",
      "estimatedCostShort": "Est. cost",
      "exceeded": "Exceeded",
      "exportCsv": "Export CSV",
      "function": "Function",
      "functions": "Functions",
      "globalThresholds": "Global thresholds",
      "inAppNotifications": "In-app notifications",
      "inputTokens": "Input tokens",
      "last30Days": "Last 30 days",
      "last7Days": "Last 7 days",
      "last90Days": "Last 90 days",
      "model": "Model",
      "modelDetail": "Model detail",
      "models": "Models",
      "monthlyCalls": "Monthly calls",
      "monthlyCost": "Monthly cost",
      "noData": "No data",
      "noLogs": "No logs",
      "noUsagePeriod": "No usage over the period",
      "ok": "OK",
      "outputTokens": "Output tokens",
      "perUserThresholds": "Per-user thresholds",
      "pricePerCall": "Price per call",
      "recentLogs": "Recent logs",
      "saveThresholds": "Save thresholds",
      "saving": "Saving…",
      "status": "Status",
      "thresholdExceeded": "Threshold exceeded",
      "thresholdsSaved": "Thresholds saved",
      "title": "AI usage",
      "tokens": "Tokens",
      "tokensIn": "Tokens (in)",
      "tokensOut": "Tokens (out)",
      "user": "User",
      "users": "Users"
    },
    "incidentDialog": {
      "created": "Incident created",
      "description": "Description",
      "editTitle": "Edit incident",
      "error": "An error occurred",
      "newTitle": "New incident",
      "severity": "Severity",
      "severityCritical": "Critical",
      "severityHigh": "High",
      "severityLow": "Low",
      "severityMedium": "Medium",
      "status": "Status",
      "statusInvestigating": "Investigating",
      "statusOpen": "Open",
      "titleLabel": "Title",
      "titleRequired": "Title is required",
      "updated": "Incident updated",
      "statusResolved": "Resolved",
      "statusClosed": "Closed",
      "category": "Category",
      "catDataBreach": "Data breach",
      "catUnauthorizedAccess": "Unauthorized access",
      "catServiceOutage": "Service outage",
      "catMalware": "Malware",
      "catConfigError": "Configuration error",
      "catThirdParty": "Third party",
      "catOther": "Other",
      "affectedUsers": "Affected users",
      "detectedAt": "Detected at",
      "resolvedAt": "Resolved at",
      "affectedDataTypes": "Affected data types",
      "affectedDataTypesPlaceholder": "e.g. emails, passwords…",
      "cnilRequired": "CNIL notification required",
      "notifiedAt": "Notified at",
      "cnilRef": "CNIL reference",
      "cnilRefPlaceholder": "CNIL case number",
      "usersNotifiedAt": "Users notified at",
      "mitigationActions": "Mitigation actions",
      "rootCause": "Root cause",
      "cancel": "Cancel",
      "save": "Save"
    },
    "imap": {
      "testSuccessTitle": "Connection successful",
      "testSuccessDesc": "The account is correctly configured.",
      "missingFields": "Missing fields",
      "missingFieldsDesc": "Please fill in all required fields.",
      "passwordRequired": "Password required",
      "passwordRequiredDesc": "Enter the account password.",
      "invalidEmail": "Invalid email",
      "invalidEmailDesc": "Enter a valid email address.",
      "accountUpdated": "Account updated",
      "accountAdded": "Account added",
      "error": "Error",
      "orgUpdated": "Organization updated",
      "sendFailed": "Send failed",
      "testEmailSent": "Test email sent",
      "title": "IMAP email accounts",
      "subtitle": "Set up your IMAP/SMTP accounts to send and receive emails.",
      "add": "Add",
      "noAccounts": "No account configured",
      "default": "Default",
      "linkedOrg": "Linked organization",
      "noOrgShort": "None",
      "noOrg": "No organization",
      "setDefault": "Set as default",
      "sendTestEmail": "Send test email",
      "edit": "Edit",
      "delete": "Delete",
      "editAccount": "Edit account",
      "addAccount": "Add account",
      "editAccountDesc": "Update account information.",
      "addAccountDesc": "Add an IMAP/SMTP account.",
      "provider": "Provider",
      "officialGuide": "Official guide",
      "emailAddress": "Email address",
      "emailPlaceholder": "name@example.com",
      "displayName": "Display name",
      "displayNamePlaceholder": "e.g. Support",
      "username": "Username",
      "password": "Password",
      "keepCurrentPassword": "Leave blank to keep current password",
      "imapServer": "IMAP server",
      "port": "Port",
      "sslImap": "SSL/TLS (IMAP)",
      "smtpServer": "SMTP server",
      "sslSmtp": "SSL/TLS (SMTP)",
      "linkedOrgOptional": "Linked organization (optional)",
      "orgFilterHelp": "Filter emails by organization.",
      "setAsDefault": "Set as default",
      "test": "Test",
      "update": "Update",
      "save": "Save"
    },
    "voiceCommands": {
      "activated": "Activated",
      "activationFailed": "Activation failed",
      "deactivationFailed": "Deactivation failed",
      "deactivated": "Deactivated",
      "copied": "Copied",
      "browserUnsupported": "Browser not supported",
      "showTokenFirst": "Show your personal code first",
      "micError": "Microphone error",
      "noResponse": "No response",
      "errorPrefix": "Error",
      "heading": "Voice commands",
      "activatedBadge": "Active",
      "introText": "Control Thiia by voice from your devices.",
      "activateOneClick": "One-click activation",
      "activateDesc": "Generate a personal code to use voice commands.",
      "activateButton": "Activate",
      "personalCode": "Personal code",
      "codeCopied": "Code copied",
      "copy": "Copy",
      "hideCode": "Hide code",
      "testNow": "Test now",
      "testDesc": "Speak a command to check recognition.",
      "generateFirst": "Generate a code first to test the voice command.",
      "speakToThiia": "Speak to Thiia",
      "stop": "Stop",
      "youSaid": "You said:",
      "thiiaReplies": "Thiia replies:",
      "installOnPhone": "Install on your phone",
      "chooseDevice": "Choose your device to see the setup instructions.",
      "iphone": "iPhone",
      "android": "Android",
      "iphoneStep1Title": "Install the shortcut",
      "iphoneStep1Desc": "Open the Shortcuts app and create a new shortcut to send a POST request.",
      "iphoneStep2Title": "Configure the URL",
      "iphoneStep2Desc": "Use the URL and the authorization code provided below.",
      "iphoneStep3Title": "Add to Home Screen",
      "iphoneStep3Desc": "You can now launch the command directly from your screen or with Siri.",
      "urlCopied": "URL copied to clipboard",
      "copyUrl": "Copy URL",
      "copyAuthCode": "Copy Auth Code",
      "thenSay": "Then you can say \"Hey Siri, [shortcut name]\" followed by your request.",
      "androidStep1Title": "Install Tasker or HTTP Request app",
      "androidStep1Desc": "Use an app capable of making HTTP calls from a widget or assistant.",
      "androidStep2Title": "Scan the QR Code",
      "androidStep2Desc": "This QR code contains the pre-configured URL and your unique token.",
      "androidStep3Title": "Configure the trigger",
      "androidStep3Desc": "Associate this request with a widget or a voice gesture.",
      "qrAlt": "Configuration QR Code",
      "scanWithApp": "Scan this code with your phone to configure the command automatically.",
      "qrAfterCode": "Generate a personal code above to display the configuration QR code.",
      "manageAccess": "Manage authorized devices",
      "createdOn": "Created on {{date}}",
      "lastUsed": "Last used on {{date}}",
      "deactivate": "Deactivate",
      "regenerateCode": "Regenerate a new code",
      "lastCommands": "Last commands",
      "errorLabel": "Error",
      "advancedConfig": "Advanced configuration (API)"
    },
    "docTemplate": {
      "themeNotLoaded": "Global theme is not loaded yet.",
      "globalThemeApplied": "Global theme applied.",
      "styleSaved": "Style guide saved.",
      "nameRequired": "Template name is required.",
      "templateUpdated": "Template updated successfully.",
      "templateCreated": "Template created successfully.",
      "saveFirst": "Please save the template before uploading files.",
      "fileTooLarge": "File is too large (max 10MB).",
      "fileUploaded": "File uploaded.",
      "fileDeleted": "File deleted.",
      "uploadCoverFirst": "Please upload a cover PDF first.",
      "coverNotFound": "Could not retrieve the PDF file.",
      "analyzeFailed": "Document analysis failed.",
      "noteWizardEdit": "Modified via dynamic fields wizard",
      "fieldsUpdated": "Dynamic fields updated.",
      "historyLoadFailed": "Could not load history.",
      "confirmRestoreTitle": "Restore this version?",
      "confirmRestoreDesc": "The current fields configuration will be replaced by this version's.",
      "restore": "Restore",
      "noteBeforeRestore": "State before restoring a previous version",
      "versionRestored": "Version restored successfully.",
      "editTemplate": "Edit template",
      "newTemplate": "New template",
      "sheetDesc": "Configure PDF/Word files and the style guide for your documents.",
      "name": "Template name",
      "namePlaceholder": "e.g. Standard Template",
      "descriptionOptional": "Description (optional)",
      "descriptionPlaceholder": "Details about when to use this template...",
      "defaultTemplate": "Default template",
      "defaultTemplateDesc": "Automatically used for new documents if no other template is selected.",
      "save": "Save",
      "createTemplate": "Create template",
      "pages": "Pages and files",
      "fileLoaded": "File loaded",
      "replace": "Replace",
      "upload": "Upload",
      "coverDynamicFields": "Dynamic fields",
      "fieldsConfigured": "{{count}} fields configured",
      "markFieldsHint": "Click 'Edit' to mark fillable areas on the PDF.",
      "modificationHistory": "Modification history",
      "history": "History",
      "edit": "Edit",
      "styleGuide": "Style guide",
      "import": "Import",
      "fromAnotherTemplate": "From another template",
      "noTemplateAvailable": "No other template available",
      "styleImportedFrom": "Style imported from {{name}}",
      "fromGlobalTheme": "From global theme",
      "importJsonFile": "Import JSON file",
      "export": "Export",
      "preview": "Preview",
      "noValidColor": "No valid color found in the file.",
      "colorsImported": "{{count}} colors imported.",
      "invalidJson": "Invalid JSON: {{message}}",
      "syncGlobalTheme": "Sync with global theme",
      "syncGlobalThemeDesc": "Primary and Accent colors will follow your application settings.",
      "globalTag": "(Global)",
      "headingFont": "Heading font",
      "bodyFont": "Body font",
      "saveStyle": "Save style",
      "close": "Close",
      "wizardDesc": "Select text areas on your document to turn them into dynamic fields.",
      "wizardError": "An error occurred in the wizard",
      "retry": "Retry",
      "dynamicFieldsHistory": "Fields history",
      "historyDesc": "Find previous versions of the fields configuration.",
      "noVersions": "No versions recorded.",
      "coverBackFieldsCount": "{{coverCount}} fields (cover) · {{backCount}} fields (back)"
    }
  },
  "prospectComponents": {
    "whatsAppComposer": {
      "unknownError": "Unknown error",
      "error": "Error",
      "confirmDeleteTemplate": "Delete this template?",
      "templateDeleted": "Template deleted",
      "saveFailed": "Save failed",
      "templateSaved": "Template saved",
      "errNoOrg": "No organization configured",
      "errSelectOrg": "Select an organization",
      "errInvalidSenderNumber": "Invalid sender number",
      "errWrongTemplateField": "Wrong template field",
      "errTemplateNameFormat": "Invalid Meta template name (lowercase, digits and _)",
      "errEmptyMessage": "Message is empty",
      "errMessageTooLong": "Message too long",
      "warnNoTemplate24h": "Without a template, sending is only allowed within 24 h of the last reply.",
      "errNoRecipient": "No recipient",
      "errNoValidNumber": "No valid number",
      "warnInvalidPhones": "Some numbers are invalid",
      "warnOptedOut": "Some recipients have opted out",
      "errScheduleFuture": "Schedule date must be in the future",
      "sentScheduledTitle": "Send scheduled",
      "sentDoneTitle": "Send completed",
      "descScheduled": "{{count}} message(s) scheduled",
      "skippedPart": "{{count}} skipped",
      "descSent": "{{count}} message(s) sent",
      "failedPart": "{{count}} failed",
      "sendFailedTitle": "Send failed",
      "retryDoneTitle": "Retry completed",
      "retryDoneDesc": "{{ok}} succeeded · {{ko}} failed",
      "koPart": "{{count}} failure(s)",
      "retryFailedTitle": "Retry failed",
      "messageResent": "Message resent",
      "newFailure": "New failure",
      "failureTitle": "Failure",
      "titleBulk": "Bulk WhatsApp send",
      "titleSingle": "WhatsApp send",
      "sheetDescription": "Compose and send a WhatsApp message.",
      "noOrgAlertPart1": "First configure a WhatsApp organization in ",
      "noOrgAlertSettings": "Settings",
      "noOrgAlertPart2": " to get started.",
      "sendFrom": "Send from",
      "chooseOrg": "Choose an organization",
      "templatesCount": "{{count}} template(s)",
      "clear": "Clear",
      "saveCurrentAsTemplate": "Save as template",
      "save": "Save",
      "searchTemplate": "Search template…",
      "loading": "Loading…",
      "noTemplatesYet": "No templates yet",
      "noTemplatesMatch": "No matching templates",
      "metaTemplate": "Meta template",
      "removeFavorite": "Remove from favorites",
      "markFavorite": "Add to favorites",
      "deleteTitle": "Delete",
      "metaTemplateNameLabel": "Meta template name",
      "metaTemplateNamePlaceholder": "e.g. welcome_client",
      "metaTemplateHelp": "Must match exactly an approved template in Meta Business.",
      "messageLabel": "Message",
      "messagePlaceholder": "Write your message…",
      "variablesLabel": "Variables",
      "previewPerRecipient": "Preview per recipient",
      "missingVarsCount": "{{count}} missing variable(s)",
      "prospectFallback": "Prospect",
      "noValueEmpty": "(empty)",
      "emptyMessage": "(empty message)",
      "blockingErrors": "Blocking errors",
      "scheduleSend": "Schedule send",
      "dateTime": "Date and time",
      "timezone": "Timezone",
      "browserTz": "Browser timezone",
      "yourTz": "Your timezone",
      "scheduleHelp": "The send will run at the scheduled time.",
      "scheduleFutureError": "Date must be in the future",
      "sendResults": "Send results",
      "sentCount": "{{count}} sent",
      "scheduledCount": "{{count}} scheduled",
      "failedCount": "{{count}} failed",
      "retryFailedCount": "Retry {{count}} failure(s)",
      "statusScheduled": "Scheduled",
      "statusOptOut": "Opt-out",
      "statusSent": "Sent",
      "statusFailed": "Failed",
      "retry": "Retry",
      "close": "Close",
      "cancel": "Cancel",
      "scheduleFor": "Schedule for",
      "sendTo": "Send to",
      "confirmSchedule": "Confirm scheduling",
      "confirmScheduleBody": "You are about to schedule this send.",
      "confirmScheduleFooter": "You can cancel before the send date.",
      "optedOutExcluded": "Opted-out recipients will be excluded.",
      "saveTemplateTitle": "Save as template",
      "saveTemplateDesc": "This template will be available for future sends.",
      "nameRequired": "Name required",
      "nameExample": "e.g. Follow-up D+7",
      "category": "Category",
      "categoryExample": "e.g. Prospecting",
      "description": "Description",
      "descriptionPlaceholder": "Internal notes…",
      "savedContent": "Saved content"
    }
  },
  "legalDocs": {
    "effectiveDate": "1 April 2026",
    "footerHeading": "Legal documents",
    "kind": {
      "contract": "Contractual document",
      "info": "Legal information"
    },
    "index": {
      "securityPolicy": "Security policy",
      "gdprObligations": "Your GDPR obligations"
    },
    "layout": {
      "documents": "Documents",
      "inThisDoc": "In this document",
      "goToSection": "Jump to a section",
      "effectiveSince": "In force since {{date}}",
      "nextDoc": "Next document",
      "downloadPdf": "Download as PDF",
      "pdf": "PDF",
      "versionHistory": "Version history",
      "versionHistoryLine": "Version {{version}} — in force since {{date}}."
    },
    "plain": {
      "heading": "In plain words, before the legal text",
      "disclaimer": "This summary has no contractual value.",
      "legal": {
        "l1": "Thiia is published by KREAPP SAS, a French company.",
        "l2": "Data is hosted in the European Union.",
        "l3": "A contact address is provided for any question.",
        "l4": "The site's content belongs to its publisher."
      },
      "terms": {
        "l1": "You buy credit packs once: there is no subscription.",
        "l2": "Credits never expire and nothing renews by itself.",
        "l3": "You remain responsible for the messages sent from Thiia.",
        "l4": "Your prospect data is never resold."
      },
      "privacy": {
        "l1": "Your data is used to deliver the service, nothing else.",
        "l2": "The AI we use is not trained on your data.",
        "l3": "You can export or delete your data at any time.",
        "l4": "Sub-processors are listed and hosted in Europe."
      }
    },
    "terms": {
      "noResale": {
        "title": "No resale of data"
      },
      "credits": {
        "title": "Credit packs and validity",
        "body": "Access to Thiia's features is purchased as credit packs paid once. There is no subscription, no per-user cost and no automatic renewal.",
        "starter": "Starter pack",
        "starterValue": "€29 once",
        "pro": "Pro pack",
        "proValue": "€59 once",
        "enterprise": "Enterprise pack",
        "enterpriseValue": "€99 once",
        "validity": "Credit validity",
        "validityValue": "No expiry",
        "renewal": "Renewal",
        "renewalValue": "None"
      }
    },
    "docs": {
      "sections": {
        "tutoriels": {
          "title": "Tutorials & Guide",
          "badge": "Popular",
          "intro": "Master Thiia in minutes with our step-by-step guides for the most frequent use cases."
        },
        "demarrage": {
          "title": "Quick start",
          "badge": "Essential",
          "intro": "Everything you need to know to get started with Thiia and set up your workspace."
        },
        "chat": {
          "title": "Chat with Thiia",
          "intro": "The conversational AI assistant at the heart of your Thiia experience."
        },
        "annotations": {
          "title": "Annotations & Highlighting",
          "badge": "New",
          "intro": "Collaborate effectively by annotating AI responses directly in the chat."
        },
        "documents-prospect": {
          "title": "Prospect documents",
          "badge": "Beta",
          "intro": "Centralize and query your documents (PDFs, contracts, invoices) using AI."
        },
        "cloud-drives": {
          "title": "Cloud Imports (Drive...)",
          "badge": "New",
          "intro": "Connect your favorite storage services to import your documents in one click."
        },
        "recherche": {
          "title": "Smart search",
          "intro": "Find relevant prospects, companies and events with AI."
        },
        "prospects": {
          "title": "Prospect management",
          "intro": "Organise your sales pipeline and track your relationships."
        },
        "emails": {
          "title": "Emails & Sequences",
          "intro": "Manage your communications directly from Thiia with AI assistance."
        },
        "evenements": {
          "title": "Events & Networking",
          "intro": "Organise your participation in trade shows and manage your contacts on-site."
        },
        "taches": {
          "title": "Tasks & Checklists",
          "intro": "Never lose track of your priority actions."
        },
        "contenu": {
          "title": "Content creation",
          "intro": "Generate LinkedIn posts, newsletters and articles in seconds."
        },
        "bienetre": {
          "title": "Wellbeing & Energy",
          "intro": "Because your success also depends on your personal balance."
        },
        "integrations": {
          "title": "Integrations & API",
          "intro": "Connect Thiia to your existing tools for a seamless workflow."
        },
        "parametres": {
          "title": "Settings & Account",
          "intro": "Set up your profile, organizations and preferences."
        }
      }
    },
    "privacy": {
      "rightsExport": {
        "title": "Rights and Data Portability",
        "intro": "You have the right to access, rectify, or export your personal data at any time.",
        "dpoLabel": "Data Protection Officer:",
        "cnilLabel": "Supervisory Authority (CNIL):"
      },
      "noResale": {
        "title": "No Resale of Data"
      },
      "subprocessors": {
        "title": "Sub-processors"
      },
      "cookies": {
        "title": "Cookies and Analytics",
        "tableTitle": "List of Cookies Used",
        "table": {
          "headers": {
            "name": "Name",
            "purpose": "Purpose",
            "duration": "Duration",
            "provider": "Provider"
          },
          "rows": {
            "ga": "Google Analytics - statistical monitoring of website traffic.",
            "gid": "Google Analytics - identification of unique users.",
            "gat": "Google Analytics - used to throttle request rate."
          },
          "duration13m": "13 months",
          "duration24h": "24 hours",
          "duration1min": "1 minute"
        }
      },
      "legalBasis": {
        "title": "Legal Bases for Processing",
        "intro": "In accordance with the GDPR, we process your data based on the following legal grounds:"
      },
      "fullRights": {
        "title": "Your Rights Under GDPR",
        "intro": "You have several rights regarding your personal data:"
      },
      "securityGovernance": {
        "title": "Security and AI Governance",
        "intro": "For more details on our security practices and AI governance, please consult the following documents:",
        "links": {
          "overview": "Security Overview",
          "policy": "Information Security Policy (PSSI)",
          "aiPolicy": "AI Ethics and Governance Policy",
          "aiia": "AI Impact Assessment (AIIA)",
          "incident": "Security Incident Management Procedure"
        }
      }
    }
  },
  "adminPages": {
    "common": {
      "back": "Back",
      "error": "Error",
      "email": "Email",
      "reset": "Reset",
      "cancel": "Cancel",
      "delete": "Delete",
      "name": "Name",
      "actions": "Actions",
      "edit": "Edit",
      "save": "Save",
      "refresh": "Refresh",
      "loading": "Loading...",
      "previous": "Previous",
      "next": "Next"
    },
    "orgSettings": {
      "title": "Organization Settings",
      "description": "Manage rules, templates, and sources specific to each organization.",
      "globalConfig": "Global Configuration (Default)",
      "editingFor": "Editing for:"
    },
    "whatsappHistory": {
      "organization": "Organization",
      "cancelFailed": "Cancellation failed",
      "sendCanceled": "Send canceled successfully",
      "title": "WhatsApp History",
      "total": "Total messages",
      "delivered": "Delivered",
      "scheduled": "Scheduled",
      "failed": "Failed",
      "searchPlaceholder": "Search by name, number or content...",
      "queued": "Queued",
      "sent": "Sent",
      "read": "Read",
      "canceled": "Canceled",
      "allOrganizations": "All organizations",
      "noMessagesYet": "No WhatsApp messages sent yet.",
      "noMessagesMatchFilters": "No messages match your filters.",
      "prospect": "Prospect",
      "templateLabel": "Template: {{sid}}",
      "optOutAfterScheduling": "Opted out after scheduling",
      "cancelScheduledSend": "Cancel scheduled send",
      "pageInfo": "Page {{page}} of {{totalPages}} ({{count}} messages)",
      "messageDetails": "Message Details",
      "recipient": "Recipient",
      "viewProspect": "View prospect",
      "sender": "Sender",
      "message": "Message",
      "template": "Template",
      "cancelReason": "Cancellation reason",
      "twilioSid": "Twilio SID",
      "scheduledFor": "Scheduled for"
    },
    "ownerDashboard": {
      "paymentSuccessTitle": "Payment successful!",
      "paymentSuccessDesc": "Your subscription has been updated.",
      "paymentCancelTitle": "Payment cancelled",
      "paymentCancelDesc": "No changes were made to your account.",
      "inviteCreatedTitle": "Invitation created",
      "inviteCreatedEmailFailedDesc": "The invitation was created but the email could not be sent.",
      "inviteSentTitle": "Invitation sent",
      "inviteSentDesc": "An invitation has been sent to {{email}}.",
      "userCreatedTitle": "User created",
      "userCreatedDesc": "{{name}} has been successfully created.",
      "bulkDeleteSuccessTitle": "Deletion successful",
      "bulkDeleteCoachesDesc": "{{count}} users have been deleted.",
      "bulkDeleteInvitationsDesc": "{{count}} invitations have been deleted.",
      "resendSuccessTitle": "Invitation resent",
      "resendSuccessDesc": "The invitation for {{email}} has been resent.",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "statusInvited": "Invited",
      "title": "Team Management",
      "subtitle": "Manage your coaches, monitor their activity and subscriptions.",
      "addUser": "Add User",
      "inviteTab": "Invite",
      "directCreateTab": "Direct Create",
      "userEmailLabel": "Email Address",
      "sending": "Sending...",
      "sendInvitation": "Send Invitation",
      "userNameLabel": "Full Name",
      "tempPasswordLabel": "Temporary Password",
      "creating": "Creating...",
      "createAccount": "Create Account",
      "infoCard": "Information",
      "totalUsers": "Total Users",
      "activeUsers": "Active",
      "pendingInvitations": "Pending Invitations",
      "usersTitle": "Users",
      "refreshSubscriptions": "Refresh Subscriptions",
      "searchPlaceholder": "Search by name or email...",
      "statusFilter": "Status",
      "allStatuses": "All Statuses",
      "profileFilter": "Profile",
      "allProfiles": "All Profiles",
      "subscriptionFilter": "Subscription",
      "allSubscriptions": "All",
      "subscribed": "Subscribed",
      "noSubscription": "No Subscription",
      "selectedCount": "{{count}} user selected",
      "deleteUsersTitle": "Delete Users",
      "deleteUsersDesc": "Are you sure you want to delete the selected users? This action is irreversible.",
      "noUsersYet": "No users yet.",
      "noUsersMatchFilters": "No users match your filters.",
      "selectAll": "Select all",
      "subAbbrev": "Sub.",
      "createdOn": "Created on",
      "lastSignIn": "Last sign-in",
      "selectRow": "Select row",
      "subscribedUntil": "Subscribed until {{date}}",
      "noActiveSubscription": "No active subscription",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "invitationsTitle": "Pending Invitations",
      "selectedCountF": "{{count}} invitation selected",
      "deleteInvitationsTitle": "Delete Invitations",
      "deleteInvitationsDesc": "Are you sure you want to delete the selected invitations?",
      "sentOn": "Sent on",
      "expiresOn": "Expires on",
      "resendInvitationTitle": "Resend Invitation",
      "deleteInvitationTitle": "Delete Invitation",
      "deleteInvitationDesc": "Are you sure you want to delete this invitation?",
      "accessColumn": "Access"
    },
    "ownerSettings": {
      "settingsSaved": "Settings saved successfully",
      "selectImage": "Please select an image",
      "logoUpdated": "Logo updated",
      "logoRemoved": "Logo removed",
      "stripeSaved": "Stripe configuration saved",
      "title": "Platform Settings",
      "subtitle": "Manage your personal information, company details, and payment configuration.",
      "myProfile": "My Profile",
      "displayName": "Display Name",
      "myCompany": "My Company",
      "logo": "Company Logo",
      "change": "Change",
      "upload": "Upload",
      "companyName": "Company Name",
      "siret": "SIRET Number",
      "address": "Headquarters Address",
      "phone": "Business Phone",
      "website": "Website",
      "subscription": "Your Subscription",
      "subscriptionDesc": "Your subscription is managed directly through our secure billing platform.",
      "stripeConfig": "Stripe Configuration",
      "stripeIntro": "To accept payments, you must configure your Stripe keys. Find them on your",
      "stripeDashboardLink": "Stripe dashboard",
      "secretKeyLabel": "Secret Key",
      "configured": "Configured",
      "notConfigured": "Not configured",
      "secretKeyExplanation1": "For security reasons, the secret key must be set as an",
      "edgeFunctionSecret": "Edge Function secret",
      "secretKeyExplanation2": "in Supabase.",
      "secretKeyExplanation3": "Please create a secret named",
      "secretKeyExplanation4": "with your Stripe secret API key.",
      "publicKeyLabel": "Publishable Key",
      "optional": "(Optional)",
      "priceIdLabel": "Default Price ID",
      "priceIdDesc": "The Stripe price ID (e.g., price_...) used for new subscriptions.",
      "update": "Update",
      "security": "Security & Access",
      "securityDesc": "Admin access is restricted. Contact support for any changes to permissions.",
      "saveChanges": "Save Changes"
    }
  },
  "prospectDetail": {
    "backToClients": "Back to clients",
    "backToProspects": "Back to prospects",
    "notFound": "Prospect not found",
    "form": {
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "company": "Company",
      "jobTitle": "Job title",
      "linkedin": "LinkedIn",
      "emailPlaceholder": "email@example.com",
      "phonePlaceholder": "+1 555 000 0000",
      "linkedinPlaceholder": "https://linkedin.com/in/...",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit"
    },
    "viewExchangesInProvider": "View exchanges in {{provider}}",
    "reactivateWhatsApp": "Reactivate WhatsApp",
    "whatsappOptOut": "WhatsApp opt-out",
    "twitterX": "Twitter / X",
    "addedByPrefix": "· by {{name}}",
    "client": "Client",
    "emailDirect": "Direct email",
    "call": "Call",
    "sendWhatsApp": "Send WhatsApp",
    "linkedin": "LinkedIn",
    "confirmOptOutTitle": "Mark this prospect as WhatsApp opt-out?",
    "confirmOptOutDescription": "{{name}} will no longer receive WhatsApp messages. You can reactivate them anytime from this menu.",
    "confirmOptOut": "Confirm opt-out",
    "delete": "Delete",
    "deleteTitle": "Delete this prospect?",
    "deleteDescription": "{{name}} will be permanently deleted, along with their emails and registrations. This action is irreversible.",
    "cancel": "Cancel",
    "proposeMeeting": "Propose a meeting",
    "proposeMeetingShort": "Meeting",
    "addEmailToPropose": "Add an email to this prospect",
    "proposeMeetingTitle": "Propose a meeting",
    "chooseDuration": "Choose a duration",
    "duration60": "1 hour",
    "duration90": "1h 30",
    "durationMinutes": "{{count}} minutes",
    "emailAi": "AI email",
    "sendWhatsAppTitle": "Send a WhatsApp message",
    "tabs": {
      "fiche": "Profile",
      "activity": "Activity",
      "tasks": "Tasks",
      "notes": "Notes",
      "documents": "Docs",
      "exchanges": "Exchanges",
      "infos": "Info",
      "overview": "Overview",
      "emails": "Emails",
      "analyses": "AI analyses"
    },
    "tasksTitle": "Prospect tasks",
    "contactInfo": "Contact information",
    "changeStatus": "Change status",
    "statusShort": {
      "discussion": "Discussion"
    },
    "tagsLabel": "Tags",
    "addTag": "Add a tag",
    "addTagPlaceholder": "Add a tag…",
    "noTag": "No tag",
    "linkedEvents": "Linked events",
    "registered": "Registered",
    "bio": "Bio",
    "companyDescription": "Company description",
    "foundedIn": "· Founded in {{year}}",
    "onlineActivity": "Online activity analysis",
    "interestThemes": "Interest themes",
    "publishedArticles": "Published articles",
    "personalSite": "Personal website",
    "linkedinActivity": "LinkedIn activity",
    "relevanceAi": "AI relevance",
    "sentEmails": "{{count}} emails sent",
    "sentEmails_one": "{{count}} email sent",
    "sentEmails_other": "{{count}} emails sent",
    "noSubject": "(No subject)",
    "noContent": "No content",
    "importedNotes": "Imported notes",
    "scoreBadge": "Score {{score}}%",
    "moreActions": "More actions",
    "latestExchanges": "Latest exchanges",
    "noMailboxConnected": "No mailbox connected"
  },
  "chatQuestionnaire": {
    "title": "A few details",
    "progress": "Question {{current}} / {{total}}",
    "previous": "Previous",
    "next": "Next",
    "skip": "Skip",
    "send": "Send",
    "placeholder": "Your answer…",
    "otherPlaceholder": "Other answer (optional)…",
    "noAnswer": "(not provided)",
    "multiHint": "You can pick several",
    "recapHeader": "Here are my answers:"
  },
  "pricing": {
    "title": "You pay for what the agent produces, not for a seat each month",
    "subtitle": "A classic CRM bills every user every month, including the months when nobody prospects. Thiia is bought as a pack of eleven business credit types, used at your clients' pace.",
    "pillNoSubscription": "No subscription",
    "pillNoSeat": "No per-user cost",
    "pillNoExpiry": "Credits never expire",
    "priceSuffix": "€ — one time",
    "buy": "Buy this pack",
    "showAll": "See the eleven counters",
    "hideAll": "Hide the eleven counters",
    "unitMin": "min",
    "groupProspecting": "Prospecting",
    "groupRelation": "Client relationship",
    "groupDigital": "Digital communication",
    "quotaSearches": "Searches",
    "quotaWatches": "Automatic monitoring",
    "quotaReports": "Reports",
    "quotaAnalyses": "Analyses",
    "quotaChat": "Chat questions",
    "quotaNewsletters": "Newsletters",
    "quotaChecklists": "Checklists",
    "quotaTranscription": "Transcription",
    "quotaPublications": "Publications",
    "quotaDocuments": "Documents",
    "quotaImages": "Generated images",
    "packStarterName": "Starter Pack",
    "packStarterTarget": "To try the agent on a first campaign, with no commitment",
    "packProName": "Pro Pack",
    "packProTarget": "The pace of a freelancer prospecting every week",
    "packProBadge": "Popular",
    "packEnterpriseName": "Enterprise Pack",
    "packEnterpriseTarget": "A firm or team handling a shared portfolio continuously",
    "topupTitle": "Top up à la carte, whenever you need it",
    "topupIntro": "An empty counter doesn't force you to buy a whole pack again: every credit is topped up separately, counter by counter. Browsing, sorting, re-reading and organising cost nothing.",
    "topupClosing": "Credits stay yours: no reset at the end of the month.",
    "topupSearches": "40 searches",
    "topupWatches": "60 automatic monitorings",
    "topupReports": "20 reports",
    "topupAnalyses": "20 analyses",
    "topupChat": "100 chat questions",
    "topupNewsletters": "10 newsletters",
    "topupChecklists": "40 checklists",
    "topupTranscription": "480 min of transcription",
    "topupPublications": "25 publications",
    "topupDocuments": "50 documents",
    "topupImages": "20 generated images",
    "trustFreeCredits": "Free credits on signup",
    "trustNoRecurring": "No recurring charge",
    "trustNoExpiry": "Credits never expire",
    "trustFrance": "Data hosted in France",
    "teaserTitle": "Credit packs, bought once",
    "teaserSubtitle": "Eleven business counters, used at your own pace. No subscription, no per-user cost.",
    "teaserLink": "See the full pack details",
    "teaserStarterHighlight": "30 prospect searches",
    "teaserProHighlight": "500 chat questions",
    "teaserEnterpriseHighlight": "150 prospect searches"
  },
  "faq": {
    "title": "Frequently asked questions",
    "q1": "Why no monthly subscription?",
    "a1": "Because a subscription also bills you for the months you don't prospect. With Thiia you buy a credit pack once and use it at the pace of your activity, with no automatic charge and no time commitment.",
    "q2": "What happens when a counter runs out?",
    "a2": "Only the actions tied to that counter are paused: the other ten keep working. You top up that single counter à la carte, without buying a whole pack again.",
    "q3": "Do credits expire?",
    "a3": "No. Your credits stay yours as long as your account is active: no reset at the end of the month, no expiry date.",
    "q4": "Which actions consume no credits?",
    "a4": "Browsing, sorting, re-reading and organising are free and unlimited: prospect records, kanban, calendar, incoming emails, documents already generated. Only what the agent produces consumes a credit.",
    "q5": "Can I share credits with my team?",
    "a5": "Yes. Credits belong to the organization: every invited collaborator draws from the same shared pool, with no extra per-user cost and a per-person history.",
    "q6": "How do I pay and get my invoice?",
    "a6": "Payment is secured by Stripe (credit card, Apple Pay, Google Pay). Credits are added instantly and a KREAPP SAS invoice is emailed to you."
  },
  "docs": {
    "title": "Documentation",
    "contact": "Contact us",
    "openApp": "Open THIIA",
    "openMenu": "Open the menu",
    "onThisPage": "On this page",
    "previous": "Previous",
    "next": "Next",
    "backToIndex": "Back to documentation",
    "search": {
      "placeholder": "Search the documentation",
      "empty": "No article matches."
    },
    "helpful": {
      "question": "Was this page helpful?",
      "yes": "Yes",
      "no": "No"
    },
    "notFound": {
      "title": "Article not found",
      "body": "This documentation page does not exist or has been moved."
    },
    "index": {
      "title": "THIIA documentation",
      "subtitle": "Everything the agent does, explained article by article."
    },
    "groups": {
      "start": {
        "label": "Getting started",
        "summary": "First steps, chatting with the agent, settings and integrations."
      },
      "prospection": {
        "label": "Prospecting",
        "summary": "Find contacts, qualify them and track your annotations."
      },
      "relation": {
        "label": "Customer relations",
        "summary": "Emails, events, tasks, documents and your energy tracking."
      },
      "communication": {
        "label": "Digital communication",
        "summary": "Prepare and publish your content."
      },
      "billing": {
        "label": "Credits and billing",
        "summary": "Credit usage, compliance and security."
      }
    },
    "cost": {
      "label": "Cost",
      "recherche": {
        "rule": "Each search you run uses one search credit.",
        "free": "Browsing and sorting results you already have stays free."
      },
      "prospects": {
        "rule": "Each prospect analysis by the agent uses one analysis credit.",
        "free": "Creating, editing and organising a record stays free."
      },
      "emails": {
        "rule": "Each email written by the agent uses one writing credit.",
        "free": "Reading, editing and sending an existing email stays free."
      },
      "contenu": {
        "rule": "Each piece of content generated by the agent uses one content credit.",
        "free": "Editing, scheduling and publishing content stays free."
      },
      "credits": {
        "rule": "Credits are bought as one-off packs and never expire.",
        "free": "Checking your counters is free."
      }
    },
    "example": {
      "label": "Example",
      "counter": "1 search used",
      "recherche": {
        "question": "Find me managing directors of industrial SMEs in Occitanie.",
        "answer": "I found 7 matching profiles. Would you like me to add them to your prospects?"
      }
    },
    "warning": {
      "credits": "A spent credit is not refunded, even if the result does not suit you: refine your request before running it again.",
      "rgpd": "You remain responsible for the data you enter: check your legal basis before any outreach."
    }
  },
  "topbar": {
    "searchPlaceholder": "Search a prospect, an email, an event…",
    "accountMenu": "Account menu"
  },
  "globalSearch": {
    "title": "Global search",
    "placeholder": "Search a prospect, an email, an event…",
    "hint": "Type at least two characters to start searching.",
    "empty": "No result for “{{query}}”",
    "footer": "↑↓ navigate · ↵ open · ⌘↵ new tab",
    "groups": {
      "prospects": "Prospects",
      "emails": "Emails",
      "events": "Events",
      "tasks": "Tasks",
      "documents": "Documents"
    }
  },
  "ownerNav": {
    "subtitle": "Administration",
    "backToWorkspace": "Back to my workspace",
    "users": "User management",
    "aiUsage": "AI usage",
    "metrics": "Metrics & errors",
    "seo": "SEO & indexing",
    "branding": "Branding",
    "pricing": "Pricing & credits",
    "emailTemplates": "Email templates",
    "security": "Security & incidents",
    "eval": "Chat evaluation",
    "voiceAgent": "Voice agent",
    "announcements": "What's new",
    "settings": "Settings"
  },
  "receipts": {
    "pendingCount": "{{count}} receipt pending",
    "pendingCount_one": "{{count}} receipt pending",
    "pendingCount_other": "{{count}} receipts pending",
    "allOrganizations": "All organizations",
    "tabs": {
      "queue": "To process",
      "rules": "Vendor rules",
      "connections": "Connections",
      "log": "Log"
    },
    "queue": {
      "scan": "Run a pass",
      "period": "Period",
      "periodDays": "Last {{count}} days",
      "periodYear": "Last 12 months",
      "periodTwoYears": "Last 24 months",
      "periodCustom": "Custom period",
      "periodFrom": "From",
      "periodTo": "To",
      "scanDone": "Pass completed",
      "scanSummary": "{{pending}} transaction(s) without a receipt, {{created}} added to the queue.",
      "empty": "No transaction is waiting for a receipt.",
      "upload": "Upload a PDF",
      "attached": "Receipt attached to the transaction.",
      "searchPlaceholder": "Vendor, amount, reference…",
      "noResults": "No transaction matches this search.",
      "count": "{{count}} transaction(s)",
      "sort": {
        "dateDesc": "Date (newest)",
        "dateAsc": "Date (oldest)",
        "amountDesc": "Amount (high to low)",
        "amountAsc": "Amount (low to high)",
        "labelAsc": "Label (A-Z)",
        "labelDesc": "Label (Z-A)"
      },
      "filter": {
        "all": "All",
        "ready": "Ready",
        "choose": "To choose",
        "none": "No file"
      },
      "group": {
        "ready": "Ready to validate",
        "choose": "To choose",
        "none": "No receipt"
      },
      "summaryOne": "1 invoice, exact amount",
      "summaryMany": "{{count}} candidates",
      "summaryNone": "nothing found",
      "shortcuts": "J K navigate · ↵ validate · X dismiss · U upload",
      "validateAll": "Validate all",
      "side": {
        "debit": "Outgoing",
        "credit": "Incoming"
      }
    },
    "reason": {
      "new_vendor": "New vendor",
      "no_invoice": "No invoice found",
      "amount_mismatch": "Amount mismatch",
      "multiple_candidates": "Several invoices"
    },
    "connector": {
      "outlook": "Outlook",
      "ovh": "OVH",
      "manual": "Manual upload",
      "amazon": "Amazon Business",
      "qonto": "Qonto"
    },
    "mode": {
      "auto": "Automatic",
      "manual": "Manually approved"
    },
    "rules": {
      "pattern": "Label pattern",
      "vendor": "Vendor",
      "connector": "Connector",
      "add": "Add",
      "empty": "No vendor rule yet."
    },
    "connections": {
      "connected": "Connected",
      "disconnected": "Not connected",
      "connect": "Connect",
      "disconnect": "Disconnect",
      "qontoLogin": "Qonto login",
      "qontoSecret": "Secret key",
      "securityNote": "Your credentials are stored server-side and are never readable from the browser.",
      "manageInSettings": "Manage in Integrations"
    },
    "log": {
      "empty": "No attachment recorded yet."
    },
    "search": {
      "searchAll": "Find invoices",
      "searchOne": "Find the invoice",
      "stop": "Stop",
      "done": "Search complete",
      "foundCount": "{{count}} invoice(s) found",
      "noMailbox": "No mailbox connected for this organisation.",
      "failed": "No invoice found in your mailboxes",
      "preview": "Preview",
      "validate": "Validate and attach",
      "dismiss": "Dismiss",
      "openLink": "Open link",
      "nothingFound": "No invoice found in the searched mailboxes",
      "runDone": "Search pass finished",
      "runFound": "{{count}} invoice(s) found",
      "reportSummary": "{{mailboxes}} mailbox(es) searched · {{emails}} email(s) · {{pdfs}} PDF",
      "searchEverywhere": "Search everywhere",
      "searchWide": "Wider search",
      "amazonError": "Amazon Business: {{error}}",
      "reportWindow": "window −{{before}}d / +{{after}}d"
    },
    "band": {
      "qontoSynced": "Qonto · synced {{ago}}",
      "qontoDisconnected": "Qonto disconnected · Reconnect",
      "syncMinutes": "{{count}} min ago",
      "syncHours": "{{count}} h ago",
      "syncDays": "{{count}} d ago",
      "syncNever": "never synced",
      "searchEmails": "Search in emails"
    },
    "detail": {
      "debitedOn": "Debited on {{date}} · {{account}}"
    },
    "match": {
      "best": "Best match",
      "receivedOn": "received by email on {{date}}",
      "kindInvoice": "invoice",
      "kindReceipt": "receipt for the same payment",
      "criteriaAmount": "Same amount",
      "criteriaVendor": "Recognised vendor",
      "criteriaDate": "Closest date",
      "sameDay": "same day",
      "daysBefore": "{{count}} days before",
      "daysAfter": "{{count}} days after",
      "gap": "{{count}} d gap",
      "others": "Other candidates",
      "choose": "Choose",
      "hiddenDuplicate": "Hidden duplicate: {{name}}, also forwarded by email",
      "ignoredStatements": "{{count}} statements ignored",
      "attachFile": "Attach file",
      "attachFiles": "Attach the {{count}} files",
      "notThisOne": "Not this one",
      "autoRule": "Automatically attach future {{vendor}} invoices"
    },
    "bulkValidate": {
      "title": "Attach {{count}} receipts?",
      "confirm": "Attach"
    },
    "empty": {
      "title": "No invoice found in your emails",
      "searched": "Searched −{{before}} d / +{{after}} d around the debit, for an amount of {{amount}}",
      "dropHere": "Drop the PDF here",
      "or": "or",
      "choose": "Choose a file",
      "vendorAccount": "Download from your {{vendor}} account",
      "orderRef": "Order reference: {{ref}}",
      "noOrderRef": "No order reference in the bank label",
      "footerQuestion": "No invoice expected?",
      "markNone": "Mark as no receipt",
      "snooze": "Postpone to tomorrow"
    },
    "instructions": {
      "title": "Engine instructions",
      "hint": "Write in plain words what the engine should look for or ignore. These instructions come on top of vendor rules, which stay in charge.",
      "placeholder": "Lovable invoices come from billing@lovable.dev, never Stripe receipts. Ignore anything from my accountant.",
      "save": "Save instructions",
      "reinterpret": "Reinterpret",
      "saved": "Instructions saved",
      "saveError": "Could not save",
      "interpretError": "The text is saved, but it could not be interpreted. Try again with Reinterpret.",
      "understood": "What the engine applies",
      "includeTerms": "Look for:",
      "trustedSenders": "Trusted senders:",
      "excludeTerms": "Skip:",
      "excludeSenders": "Ignored senders:",
      "window": "Preferred window: {{before}} d before / {{after}} d after",
      "noCriteria": "No criteria yet.",
      "matches": "Matches your instructions",
      "guide": "Guide the search",
      "guideTitle": "Help the next search",
      "guideHint": "Explain what is wrong or how to recognise the right document. The note is added to your instructions and the search runs again.",
      "guidePlaceholder": "E.g. ignore url2820.qonto.com links, only take the attached PDF",
      "guideSuggestions": "Suggestions",
      "sugPdf": "Only take an attached PDF invoice, ignore tracking links",
      "sugExcludeDomain": "Ignore links from {{domain}}",
      "sugTrust": "Trust sender {{sender}}",
      "sugIgnoreSender": "Ignore sender {{sender}}",
      "guideSubmit": "Save and search again",
      "guideCancel": "Cancel",
      "dismissAndGuide": "Dismiss and guide"
    }
  },
  "voice": {
    "wake": {
      "standby": "Say \"Hey Thiia\"",
      "off": "Listening off — click to turn back on",
      "unsupported": "Click to talk to Thiia",
      "blocked": "Microphone blocked — allow it in your browser",
      "otherTab": "Thiia is listening in another tab",
      "expand": "Expand conversation",
      "minimize": "Minimize and keep talking",
      "connecting": "Connecting…",
      "timeout": "The voice connection did not complete. Please try again.",
      "speaking": "Thiia is speaking…",
      "listening": "I'm listening",
      "error": "Error",
      "ready": "Ready",
      "end": "End conversation",
      "settingsTitle": "\"Hey Thiia\" listening",
      "settingsHint": "Thiia listens on every page and starts the voice conversation when you say \"Hey Thiia\". Detection runs on your device.",
      "settingsToggle": "Always listening while the app is open"
    }
  },
  "chatPending": {
    "analyzing": "Thiia is analyzing your request",
    "gathering": "Gathering and synthesizing information",
    "composing": "Composing the answer",
    "detailed": "Writing a detailed answer",
    "elapsed": "{{s}} s"
  },
  "exportPreview": {
    "refine": {
      "title": "New instructions for a new version",
      "placeholder": "E.g. shorten the budget part, add a next steps section…",
      "apply": "Generate a new version",
      "applying": "Generating…",
      "save": "Save to note",
      "saved": "New version saved",
      "undo": "Back to previous version",
      "error": "Could not generate the new version"
    }
  },
  "noSubCrm": {
    "badge": "No subscription",
    "h1": "The subscription-free CRM for freelancers",
    "h1Accent": "and small businesses",
    "subtitle": "Find clients, prepare follow-ups and track your contacts. Buy a credit pack once and use it at your own pace.",
    "ctaPrimary": "Create my account",
    "ctaSecondary": "See pricing",
    "whyTitle": "Why pay every month for a tool you barely use?",
    "why1Title": "Pay for what you use",
    "why1Body": "No monthly bill landing even in quiet months. Your credits work when you need them.",
    "why2Title": "One tool instead of five",
    "why2Body": "Contacts, emails, prospect search, calendar and receipts in one place.",
    "why3Title": "Prospect without being a salesperson",
    "why3Body": "Thiia suggests prospects and drafts personalised messages, never mass mailings.",
    "why4Title": "Your data stays in Europe",
    "why4Body": "European hosting and GDPR from day one: consent and unsubscribe included.",
    "compareTitle": "Subscription or credit packs",
    "compareFeature": "Criterion",
    "compareSub": "Subscription CRM",
    "compareThiia": "Thiia",
    "rows": [
      {
        "feature": "Payment",
        "sub": "Every month, per user",
        "thiia": "Pack bought once: €29, €59 or €99"
      },
      {
        "feature": "Inactive months",
        "sub": "Billed anyway",
        "thiia": "Nothing to pay"
      },
      {
        "feature": "Commitment",
        "sub": "Often yearly",
        "thiia": "None"
      },
      {
        "feature": "Prospect search",
        "sub": "Paid add-on",
        "thiia": "Included"
      },
      {
        "feature": "Getting started",
        "sub": "Built for teams",
        "thiia": "Built for one person"
      }
    ],
    "stepsTitle": "Get started in three steps",
    "step1Title": "Create your account",
    "step1Body": "An email address is enough. You see your workspace right away.",
    "step2Title": "Describe your business",
    "step2Body": "Thiia asks a few questions to understand your ideal clients.",
    "step3Title": "Get your first prospects",
    "step3Body": "Pick a pack when you want to go further, with no commitment.",
    "testimonialsTitle": "They use it every day",
    "faqTitle": "Frequently asked questions",
    "faq": [
      {
        "q": "Is Thiia really subscription-free?",
        "a": "Yes. You buy a credit pack for €29, €59 or €99, once. No monthly charge, no commitment."
      },
      {
        "q": "What happens when my credits run out?",
        "a": "You keep access to your contacts and data. You buy another pack only if you want to keep using the features that use credits."
      },
      {
        "q": "Does Thiia fit if I work alone?",
        "a": "That's exactly what it was built for: freelancers, coaches, consultants and small business owners."
      },
      {
        "q": "Do I need sales skills to use it?",
        "a": "No. Thiia suggests prospects that fit your business and drafts personalised messages you review before sending."
      },
      {
        "q": "Is my data protected?",
        "a": "It's hosted in Europe. Consent is required before adding a contact or sending an email, and every email includes an unsubscribe link."
      },
      {
        "q": "Can I import my current contacts?",
        "a": "Yes, by file import or by connecting your Gmail or Outlook mailbox."
      }
    ],
    "finalTitle": "Ready to find your next clients?",
    "finalBody": "Create your account and pick a pack only when you need one.",
    "breadcrumb": "Subscription-free CRM",
    "footerLink": "CRM without subscription",
    "pricingLinkText": "Looking for a CRM with no monthly commitment?",
    "pricingLinkCta": "Discover our no-subscription approach"
  },
  "tpeParis": {
    "breadcrumb": "CRM for small business owners in Paris",
    "footerLink": "Small business CRM Paris",
    "badge": "Paris & Île-de-France",
    "h1": "The CRM for entrepreneurs and small business owners",
    "h1Accent": "in Paris and Île-de-France",
    "subtitle": "Running your business alone or with a small team? Thiia finds Île-de-France companies to contact, prepares your follow-ups and files your receipts. No subscription: a credit pack bought once.",
    "ctaPrimary": "Create my account",
    "ctaSecondary": "See pricing",
    "whyTitle": "Built for the daily life of a Paris-region business owner",
    "why1Title": "Prospects near you",
    "why1Body": "Search companies by city or department (Paris, Hauts-de-Seine, Seine-Saint-Denis, Val-de-Marne…), checked against official French registries.",
    "why2Title": "Your meetings and events",
    "why2Body": "Trade shows, meetups, Station F: add the events you attend and prepare your meetings in one calendar.",
    "why3Title": "Qonto receipts matched",
    "why3Body": "Thiia finds supplier invoices in your emails and suggests attaching them to your Qonto transactions, after your approval.",
    "why4Title": "French AI, data in Europe",
    "why4Body": "French sovereign AI, European hosting and GDPR compliance: consent and unsubscribe included.",
    "profilesTitle": "Who is it for?",
    "profiles": [
      {
        "title": "Small business owners",
        "body": "Agencies, firms and service companies of 1 to 10 people who handle their own business development."
      },
      {
        "title": "Independents and freelancers",
        "body": "Consultants, developers, designers and trainers based in Paris or the inner suburbs."
      },
      {
        "title": "Coaches and advisors",
        "body": "Coaches, therapists and advisors who want clients without aggressive cold outreach."
      }
    ],
    "stepsTitle": "Get started in three steps",
    "step1Title": "Create your account",
    "step1Body": "An email address is all you need.",
    "step2Title": "Describe your ideal clients",
    "step2Body": "Sector, size, area: Paris, inner suburbs or all of Île-de-France.",
    "step3Title": "Get your first prospects",
    "step3Body": "Pick a €29, €59 or €99 pack when you want to go further.",
    "faqTitle": "Frequently asked questions",
    "faq": [
      {
        "q": "Can I target only Île-de-France companies?",
        "a": "Yes. You set the area you want (a city, a department or the whole region) and Thiia limits its suggestions to those companies."
      },
      {
        "q": "Is Thiia subscription-free?",
        "a": "Yes. You buy a €29, €59 or €99 credit pack once, with no monthly charge and no commitment."
      },
      {
        "q": "Does it work with Qonto?",
        "a": "Yes. Thiia reads your Qonto transactions and suggests matching invoices found in your emails. Nothing is attached without your approval."
      },
      {
        "q": "Is my data protected?",
        "a": "Your data is hosted in Europe, and the AI used is French and does not train on your data."
      }
    ],
    "finalTitle": "Grow your Paris-region business without a subscription",
    "finalBody": "Create your account and discover your first prospects in minutes."
  }
}
